<template>
  <v-container>
    <template v-if="maintain">
      <div class="d-flex justify-center align-center">
        <span style="font-size: 50px;color: #ff6d81">{{ pageMessage }}</span>
      </div>
    </template>
    <template v-else>
      <v-card style="border: black 2px solid">
        <v-card-title class="headline mb-1">
          <span> ข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี</span>
          <v-spacer></v-spacer>
          <v-btn outlined :color="appColor" @click="$root.$refs.Train.ChooseProcess(TypeProject, true);">
            <span style="font-size: 20px">กลับเมนูหลัก</span>
          </v-btn>
        </v-card-title>
        <v-container>
          <v-list>
            <v-list-item>
              <v-row class="d-flex justify-center">
                <v-col
                    cols="12"
                    md="12"
                >
                  <v-radio-group row v-model="YearSel" @change="ChooseYearFiscal">
                    <v-radio v-for="(yearMenu, idx) in FiscalYearMenuData" :key="idx"
                             :label="'แผนประจำปี ' + yearMenu.yearth" :value="yearMenu.year">
                      <template v-slot:label>
                        <div>
                          <span style="font-weight: bold">
                           แผนประจำปี {{ yearMenu.yearth }}
                          </span>
                          <v-chip :color="appColor" class="font-weight-bold" dark>
                            {{
                              projectDataToTableDump.filter(projI => projI.Approve == '1' && projI.FiscalYear == yearMenu.year).length
                            }}
                          </v-chip>
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
          <v-expand-transition>
            <v-card v-if="!Details_Cordi"
                    style="border: black 1px solid"
            >
              <v-tabs
                  v-model="tab"
                  fixed-tabs
                  dark
                  class="pa-6"
              >
                <v-tab key="tab1">
                  <span style="font-weight: bold;font-size: 20px;padding: 10px">เสนอแผนอนุมัติงบประมาณ</span>
                </v-tab>
                <v-tab key="tab2">
                  <span style="font-weight: bold;font-size: 20px;padding: 10px">
                    ขอแก้ไขแผนหลังการอนุมัติ
                  </span>
                  <v-chip color="red" dark class="font-weight-bold">
                    {{
                      TempProjectDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.Req_status == '0').length
                    }}
                  </v-chip>
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item
                    key="tab1"
                >
                  <template>
                    <v-list>
                      <v-list-item class="d-flex justify-center">
                        <v-radio-group row v-model="Process" @change="ChooseProcess">
                          <v-radio label="โครงการ" value="1" :disabled="!checkProj1">
                            <template v-slot:label>
                              <span style="font-weight: bold">โครงการ
                              <v-chip :color="appColor" dark class="font-weight-bold">
                                {{
                                  projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.Project_category == typePermiss && item.Project_type == '1').length
                                }}
                              </v-chip>
                                </span>
                            </template>
                          </v-radio>
                          <v-radio label="อบรม / เดินทางไปปฏิบัติราชการ" value="2" @change="ChooseStatusPlan" :disabled="!checkProj2">
                            <template v-slot:label>
                              <span style="font-weight: bold">อบรม / เดินทางไปปฏิบัติราชการ
                              <v-chip :color="appColor" dark class="font-weight-bold">
                                {{
                                  projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.Project_type == '2').length
                                }}
                              </v-chip>
                                </span>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                    <v-list v-if="Process != null && Process == '1'">
                      <p class="font-weight-bold text-center mt-4">ปฏิบัติงานในนาม :</p>
                      <v-list>
                        <v-list-item class="d-flex justify-center">
                          <v-radio-group row v-model="typePermiss" @change="ChooseStatusPlan">
                            <v-radio label="HR" value="1"
                                     :disabled="ApproveMaster.length > 0 && ApproveMaster.filter(item => item.type == '1').length == 0">
                              <template v-slot:label>
                              <span style="font-weight: bold">HR
                              <v-chip :color="appColor" dark class="font-weight-bold">
                                {{
                                  projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.Project_category == '1').length
                                }}
                              </v-chip>
                                </span>
                              </template>
                            </v-radio>
                            <v-radio label="นโยบายและแผน" value="2"
                                     :disabled="ApproveMaster.length > 0 && ApproveMaster.filter(item => item.type == '2').length == 0">
                              <template v-slot:label>
                              <span style="font-weight: bold">นโยบายและแผน
                              <v-chip :color="appColor" dark class="font-weight-bold">
                                {{
                                  projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.Project_category == '2').length
                                }}
                              </v-chip>
                                </span>
                              </template>
                            </v-radio>
                            <v-radio label="ศูนย์จัดการประชุม" value="3"
                                     :disabled="ApproveMaster.length > 0 && ApproveMaster.filter(item => item.type == '3').length == 0">
                              <template v-slot:label>
                              <span style="font-weight: bold">ศูนย์จัดการประชุม
                              <v-chip :color="appColor" dark class="font-weight-bold">
                                {{
                                  projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.Project_category == '3').length
                                }}
                              </v-chip>
                                </span>
                              </template>
                            </v-radio>
                            <v-radio label="วิจัย" value="4"
                                     :disabled="ApproveMaster.length > 0 && ApproveMaster.filter(item => item.type == '4').length == 0">
                              <template v-slot:label>
                              <span style="font-weight: bold">วิจัย
                              <v-chip :color="appColor" dark class="font-weight-bold">
                                {{
                                  projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.Project_category == '4').length
                                }}
                              </v-chip>
                                </span>
                              </template>
                            </v-radio>
                            <!--                          <v-radio label="ข้อมูลไม่สมบูรณ์" value="E">-->
                            <!--                            <template v-slot:label>-->
                            <!--                              <span style="color: red">ข้อมูลไม่สมบูรณ์-->
                            <!--                              <v-chip :color="appColor" dark class="font-weight-bold">-->
                            <!--                                {{-->
                            <!--                                  projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.Project_category == null).length-->
                            <!--                                }}-->
                            <!--                              </v-chip>-->
                            <!--                                </span>-->
                            <!--                            </template>-->
                            <!--                          </v-radio>-->
                          </v-radio-group>
                        </v-list-item>
                      </v-list>
                      <v-divider></v-divider>
                      <v-list-item class="d-flex justify-center">
                        <v-radio-group row v-model="typeIsPlan" @change="ChooseStatusPlan">
                          <v-radio label="งานในแผน" value="1">
                            <template v-slot:label>
                              <span style="font-weight: bold">งานในแผน
                              <v-chip :color="appColor" dark class="font-weight-bold">
                                {{
                                  projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.IsPlan == '1' && item.Project_category == typePermiss && item.Project_type == Process).length
                                }}
                              </v-chip>
                                </span>
                            </template>
                          </v-radio>
                          <v-radio label="งานนอกแผน" value="0">
                            <template v-slot:label>
                              <span style="font-weight: bold">งานนอกแผน
                              <v-chip :color="appColor" dark class="font-weight-bold">
                                {{
                                  projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.IsPlan == '0' && item.Project_category == typePermiss && item.Project_type == Process).length
                                }}
                              </v-chip>
                                </span>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                    <v-list>

                      <v-list-item class="justify-center">
                        <v-radio-group class="font-weight-bold" v-model="sortStatus" row>
                          <v-radio label="แสดงทั้งหมด" value="1"></v-radio>
                          <v-radio label="เลือกแสดงตามสถานะ" value="2"></v-radio>
                        </v-radio-group>
                      </v-list-item>
                      <v-list-item v-if="sortStatus == '2'">
                        <v-row
                            justify="center"
                            class="justify-center">
                          <v-col
                              cols="12"
                              md="4"
                          >
                            <v-select
                                v-model="selStatus"
                                :items="StatusProject"
                                item-value="id"
                                item-text="status"
                            >
                              <template v-slot:item="{item}">
                                <h4 class="font-weight-bold">{{ item.status }}
                                  <span style="color: #364eff"
                                        v-if="Process == '1'">{{ projectDataToTable.filter(itemProj => itemProj.Approve == '1' && itemProj.Project_type == Process && itemProj.FiscalYear == YearSel && itemProj.IsPlanStatus == item.id && itemProj.IsPlan == typeIsPlan && itemProj.Project_category == typePermiss).length }}</span>
                                  <span style="color: #364eff"
                                        v-else-if="Process == '2'">{{ projectDataToTable.filter(itemProj => itemProj.Project_type == Process && itemProj.FiscalYear == YearSel && itemProj.IsPlanStatus == item.id).length }}</span>
                                  รายการ
                                </h4>
                              </template>
                            </v-select>
                          </v-col>
                        </v-row>
                      </v-list-item>

                      <!--                      <v-list-item class="d-flex justify-center">
                                              <v-radio-group row v-model="StatusPlan" @change="ChooseStatusPlan">
                                                <template v-if="Process != null && Process == '1'">
                                                  <v-radio label="ทั้งหมด" value="A">
                                                    <template v-slot:label>
                                              <span style="font-weight: bold">ทั้งหมด
                                                <v-chip :color="appColor" dark class="font-weight-bold">
                                                  {{
                                                    projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.IsPlan == typeIsPlan && item.Project_category == typePermiss && item.Project_type == Process).length
                                                  }}
                                                </v-chip>
                                              </span>
                                                    </template>
                                                  </v-radio>
                                                  <v-radio v-for="(staProject, idx) in StatusProject" :label="staProject.status"
                                                           :value="staProject.id" :key="idx" class="pa-1">
                                                    <template v-slot:label>
                                                      <div>
                                                <span>
                                                 {{ staProject.status }}
                                                </span>
                                                        <v-chip :color="staProject.color" class="font-weight-bold" dark>
                                                          {{
                                                            projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.IsPlan == typeIsPlan && item.IsPlanStatus == staProject.id && item.Project_category == typePermiss && item.Project_type == Process).length
                                                          }}
                                                        </v-chip>
                                                      </div>
                                                    </template>
                                                  </v-radio>
                                                </template>
                                                <template v-else-if="Process != null && Process == '2'">
                                                  <v-radio label="ทั้งหมด" value="A">
                                                    <template v-slot:label>
                                              <span style="font-weight: bold">ทั้งหมด
                                                <v-chip :color="appColor" dark class="font-weight-bold">
                                                  {{
                                                    projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.Project_type == Process).length
                                                  }}
                                                </v-chip>
                                              </span>
                                                    </template>
                                                  </v-radio>
                                                  <v-radio v-for="(staProject, idx) in StatusProject" :label="staProject.status"
                                                           :value="staProject.id" :key="idx" class="pa-1">
                                                    <template v-slot:label>
                                                      <div>
                                                <span>
                                                 {{ staProject.status }}
                                                </span>
                                                        <v-chip :color="staProject.color" class="font-weight-bold" dark>
                                                          {{
                                                            projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.IsPlanStatus == staProject.id && item.Project_type == Process).length
                                                          }}
                                                        </v-chip>
                                                      </div>
                                                    </template>
                                                  </v-radio>
                                                </template>
                                              </v-radio-group>
                                            </v-list-item>-->
                    </v-list>
                    <v-list-item class="d-flex justify-center">
                      <v-btn v-if="Process == '1'" outlined color="green" class="darken-3" @click="OpenDialogReport">
                        Export ข้อมูลแผน
                      </v-btn>
                    </v-list-item>
                    <v-list-item class="mt-6 mb-6">
                      <h3>
                        ตารางข้อมูลรายละเอียดขอเสนอแผนอนุมัติงบประมาณประจำปี
                      </h3>
                      <v-spacer></v-spacer>
                      <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="ค้นหา"
                          single-line
                          hide-details
                      ></v-text-field>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-row
                        justify="center"
                        class="justify-center">
                      <v-col
                          cols="12"
                          md="12"
                      >

                        <!--                        @click:row="GetData"-->
                        <v-data-table
                            :headers="courseHeaders"
                            :items="sortStatus == '1' ? projectDataToTable : projectDataToTable.filter(itemProj => itemProj.IsPlanStatus == selStatus)"
                            :search="search"
                            item-key="Project_code"
                            :single-expand="singleExpand"
                            :expanded.sync="expanded"
                            class="elevation-1"
                        >
                          <template v-slot:header.full_Name>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              ชื่องาน / กิจกรรม
                            </v-label>
                          </template>
                          <template v-slot:header.IsPlanStatus>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              สถานะ
                            </v-label>
                          </template>
                          <template v-slot:header.Item_Code>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              item code
                            </v-label>
                          </template>
                          <template v-slot:header.BudgetRequest>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              งบประมาณ
                            </v-label>
                          </template>
                          <template v-slot:header.BudgetArrove>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              อนุมัติวงเงิน
                            </v-label>
                          </template>
                          <template v-slot:header.MoneyDisburse>
                            <v-label
                                fontSize="16px"
                                fontWeight="bold">
                              จำนวนเงินเบิกจ่าย
                            </v-label>
                          </template>
                          <template v-slot:item.full_Name="{item}">
                            <div v-html="item.full_Name"></div>
                          </template>
                          <template v-slot:item.BudgetRequest="{item}">
                            <span style="font-weight: bold;color: #ff6d81">{{ item.BudgetRequest | currency }}</span>
                          </template>
                          <template v-slot:item.BudgetArrove="{item}">
                      <span style="font-weight: bold;color: #ff6d81"
                            v-if="parseInt(item.IsPlanStatus) > 5">{{ item.BudgetArrove | currency }}</span>
                          </template>
                          <template v-slot:item.MoneyDisburse="{item}">
                      <span style="font-weight: bold;color: #ff6d81"
                            v-if="parseInt(item.IsPlanStatus) > 5">{{ item.MoneyDisburse | currency }}</span>
                          </template>
                          <template v-slot:item.IsPlanStatus="{item}">
                            <v-chip
                                x-large
                                v-if="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0"
                                :color="StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].color : ''"
                                style="transform: scale(0.8);color: white"
                            >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == item.IsPlanStatus)[0].status : ''
                              }}</span>
                            </v-chip>
                          </template>
                          <template v-slot:item.Item_Code="props">
                            <v-edit-dialog
                                :return-value.sync="props.item.Item_Code"
                                large
                                persistent
                                @save="save(props.item)"
                                @cancel="cancel"
                                @open="open"
                                @close="close"
                            >
                              {{ props.item.Item_Code }}
                              <template v-slot:input>
                                <v-text-field
                                    v-model="props.item.Item_Code"
                                    label=""
                                    single-line
                                    counter
                                    autofocus
                                ></v-text-field>
                              </template>
                            </v-edit-dialog>
                          </template>
                          <template v-slot:item.Project_Details="{ item }">
                            <v-btn
                                text
                                color="#FFB300"
                                @click="ShowDetail(item)"
                            >
                              รายละเอียด
                            </v-btn>
                            <v-btn
                                text
                                color="#FFB300"
                                @click="OpenLinkApprove(item)"
                            >
                              ลิงค์อนุมัติโครงการ
                            </v-btn>
                            <v-btn color="red" text @click="DelProject(item)"
                                   v-if="(ApproveMaster.length > 0 && ApproveMaster[0].readonly == '0')">
                              ลบ
                            </v-btn>
                            <div>
                              <v-btn
                                  v-if="(item.Project_type == '1' && ApproveMaster.length > 0 && ApproveMaster[0].readonly == '0')"
                                  text
                                  color="green"
                                  @click="SendOtherApprove(item)"
                              >
                                ส่งต่อผู้อนุมัติ
                              </v-btn>
                            </div>
                            <div>
                              <v-btn
                                  v-if="MeData[0].perid == '46792'"
                                  text
                                  color="purple"
                                  @click="SendMailApproveAgain(item)"
                              >
                                ส่งเมลแจ้งเตือนผู้อนุมัติ
                              </v-btn>
                            </div>
                          </template>
                          <template v-slot:footer>
                            <div align="right">
                        <span
                            style="font-weight: bold;color: #364eff;padding-right: 25px">รวมงบประมาณประจำปี {{
                            (YearSel == null ? '' : parseInt(YearSel) + 543)
                          }} ทั้งหมด {{
                            projectDataToTableDump.filter(item => item.FiscalYear == YearSel && item.IsPlan != null && item.Project_category != null && item.Project_type != null).length
                          }} แผน {{ AllBudget | currency }} บาท</span>
                            </div>
                            <div align="right">
                        <span style="font-weight: bold;color: #42b983;padding-right: 25px">รวมงบประมาณแผนที่อนุมัติทั้งหมด {{
                            projectDataToTableDump.filter(item => item.FiscalYear == YearSel && item.IsPlan != null && item.Project_category != null && item.Project_type != null && (item.IsPlanStatus == '2' || item.IsPlanStatus == '5')).length
                          }} แผน {{ AllBudgetApprove | currency }} บาท</span>
                            </div>
                            <div align="right">
                        <span style="font-weight: bold;color: #ff6d81;padding-right: 25px">รวมงบประมาณแผนที่ไม่อนุมัติทั้งหมด {{
                            projectDataToTableDump.filter(item => item.FiscalYear == YearSel && item.IsPlan != null && item.Project_category != null && item.Project_type != null && item.IsPlanStatus == '3').length
                          }} แผน {{ AllBudgetNotApprove | currency }} บาท</span>
                            </div>
                            <div align="right">
                        <span style="font-weight: bold;color: goldenrod;padding-right: 25px">รวมงบประมาณแผนที่ต้องแก้ไขทั้งหมด {{
                            projectDataToTableDump.filter(item => item.FiscalYear == YearSel && item.IsPlan != null && item.Project_category != null && item.Project_type != null && item.IsPlanStatus == '4').length
                          }} แผน {{ AllBudgetEditApprove | currency }} บาท</span>
                            </div>
                            <div align="right">
                        <span style="font-weight: bold;color: brown;padding-right: 25px">รวมงบประมาณแผนที่ต้องรอพิจารณาทั้งหมด {{
                            projectDataToTableDump.filter(item => item.FiscalYear == YearSel && item.IsPlan != null && item.Project_category != null && item.Project_type != null && item.IsPlanStatus == '1').length
                          }} แผน {{ AllBudgetPendingApprove | currency }} บาท</span>
                            </div>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </template>
                </v-tab-item>
                <v-tab-item
                    key="tab2"
                >
                  <v-list>
                    <p class="font-weight-bold text-center">ปฏิบัติงานในนาม :</p>
                    <v-list>
                      <v-list-item class="d-flex justify-center">
                        <v-radio-group row v-model="typePermiss" @change="ChooseStatusPlan">
                          <v-radio label="HR" value="1"
                                   :disabled="ApproveMaster.length > 0 && ApproveMaster.filter(item => item.type == '1').length == 0">
                            <template v-slot:label>
                              <span style="font-weight: bold">HR
                              <v-chip :color="appColor" dark class="font-weight-bold">
                                {{
                                  TempProjectDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.Project_category == '1').length
                                }}
                              </v-chip>
                                </span>
                            </template>
                          </v-radio>
                          <v-radio label="นโยบายและแผน" value="2"
                                   :disabled="ApproveMaster.length > 0 && ApproveMaster.filter(item => item.type == '2').length == 0">
                            <template v-slot:label>
                              <span style="font-weight: bold">นโยบายและแผน
                              <v-chip :color="appColor" dark class="font-weight-bold">
                                {{
                                  TempProjectDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.Project_category == '2').length
                                }}
                              </v-chip>
                                </span>
                            </template>
                          </v-radio>
                          <v-radio label="ศูนย์จัดการประชุม" value="3"
                                   :disabled="ApproveMaster.length > 0 && ApproveMaster.filter(item => item.type == '3').length == 0">
                            <template v-slot:label>
                              <span style="font-weight: bold">ศูนย์จัดการประชุม
                              <v-chip :color="appColor" dark class="font-weight-bold">
                                {{
                                  TempProjectDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.Project_category == '3').length
                                }}
                              </v-chip>
                                </span>
                            </template>
                          </v-radio>
                          <v-radio label="วิจัย" value="4"
                                   :disabled="ApproveMaster.length > 0 && ApproveMaster.filter(item => item.type == '4').length == 0">
                            <template v-slot:label>
                              <span style="font-weight: bold">วิจัย
                              <v-chip :color="appColor" dark class="font-weight-bold">
                                {{
                                  TempProjectDump.filter(item => item.Approve == '1' && item.FiscalYear == YearSel && item.Project_category == '4').length
                                }}
                              </v-chip>
                                </span>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                    <v-list-item class="d-flex justify-center">
                      <v-radio-group row v-model="Process" @change="ChooseProcess">
                        <v-radio label="โครงการ" value="1">
                          <template v-slot:label>
                            <div>
                          <span style="font-weight: bold">
                           โครงการ
                          </span>
                              <v-chip :color="appColor" class="font-weight-bold" dark>
                                {{
                                  TempProjectDump.filter(projI => projI.Approve == '1' && projI.IsPlanStatus != '0' && projI.Project_type == '1' && projI.Project_category == typePermiss && projI.FiscalYear == YearSel).length
                                }}
                              </v-chip>
                            </div>
                          </template>
                        </v-radio>
                        <v-radio label="อบรม / เดินทางไปปฏิบัติราชการ" value="2">
                          <template v-slot:label>
                            <div>
                          <span style="font-weight: bold">
                           อบรม / เดินทางไปปฏิบัติราชการ
                          </span>
                              <v-chip :color="appColor" class="font-weight-bold" dark>
                                {{
                                  TempProjectDump.filter(projI => projI.Approve == '1' && projI.IsPlanStatus != '0' && projI.Project_type == '2' && projI.Project_category == typePermiss && projI.FiscalYear == YearSel).length
                                }}
                              </v-chip>
                            </div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-list-item>
                    <v-list-item>
                      <v-data-table
                          :headers="TempHeaders"
                          :items="TempProjectDump.filter(projI => projI.Approve == '1' && projI.IsPlanStatus != '0' && projI.Project_type == Process && projI.Project_category == typePermiss && projI.FiscalYear == YearSel)"
                          :search="searchTemp"
                          class="elevation-1"
                          style="width: 100%"
                      >
                        <template v-slot:header.full_Name>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            หัวข้อกิจกรรม
                          </v-label>
                        </template>
                        <template v-slot:header.Req_status>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            สถานะ
                          </v-label>
                        </template>
                        <template v-slot:header.Item_Code>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            item code
                          </v-label>
                        </template>
                        <template v-slot:header.BudgetRequest>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            งบประมาณ
                          </v-label>
                        </template>
                        <template v-slot:header.BudgetArrove>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            อนุมัติวงเงิน
                          </v-label>
                        </template>
                        <template v-slot:header.MoneyDisburse>
                          <v-label
                              fontSize="16px"
                              fontWeight="bold">
                            จำนวนเงินเบิกจ่าย
                          </v-label>
                        </template>
                        <template v-slot:item.full_Name="{item}">
                          <div v-html="item.full_Name"></div>
                        </template>
                        <template v-slot:item.BudgetRequest="{item}">
                          <span style="font-weight: bold;color: #ff6d81">{{ item.BudgetRequest | currency }}</span>
                        </template>
                        <template v-slot:item.BudgetArrove="{item}">
                      <span style="font-weight: bold;color: #ff6d81"
                            v-if="parseInt(item.IsPlanStatus) > 5">{{ item.BudgetArrove | currency }}</span>
                        </template>
                        <template v-slot:item.MoneyDisburse="{item}">
                      <span style="font-weight: bold;color: #ff6d81"
                            v-if="parseInt(item.IsPlanStatus) > 5">{{ item.MoneyDisburse | currency }}</span>
                        </template>
                        <template v-slot:item.Req_status="{item}">
                          <v-chip
                              v-if="TempStatusProject.filter(staItem => staItem.id == item.Req_status).length > 0"
                              :color="TempStatusProject.filter(staItem => staItem.id == item.Req_status).length > 0 ? TempStatusProject.filter(staItem => staItem.id == item.Req_status)[0].color : ''"
                              style="transform: scale(0.8);color: white"
                          >
                            <span
                                style="color: white">{{
                                TempStatusProject.filter(staItem => staItem.id == item.Req_status).length > 0 ? TempStatusProject.filter(staItem => staItem.id == item.Req_status)[0].status : ''
                              }}</span>
                          </v-chip>
                        </template>
                        <template v-slot:item.Item_Code="props">
                          <v-edit-dialog
                              :return-value.sync="props.item.Item_Code"
                              large
                              persistent
                              @save="save(props.item)"
                              @cancel="cancel"
                              @open="open"
                              @close="close"
                          >
                            {{ props.item.Item_Code }}
                            <template v-slot:input>
                              <v-text-field
                                  v-model="props.item.Item_Code"
                                  label=""
                                  single-line
                                  counter
                                  autofocus
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>
                        </template>
                        <template v-slot:item.Project_Details="{ item }">
                          <v-btn
                              text
                              color="#FFB300"
                              @click="ShowDetail(item)"
                          >
                            รายละเอียด
                          </v-btn>
                          <v-btn color="red" text @click="DelProject(item)"
                                 v-if="(ApproveMaster.length > 0 && ApproveMaster[0].readonly == '0')">
                            ลบ
                          </v-btn>
                        </template>
                        <template v-slot:footer>
                          <div align="right">
                        <span
                            style="font-weight: bold;color: #364eff;padding-right: 25px">รวมงบประมาณประจำปี {{
                            (YearSel == null ? '' : parseInt(YearSel) + 543)
                          }} ทั้งหมด {{ projectDataToTable.length }} แผน {{ AllBudget | currency }} บาท</span>
                          </div>
                          <div align="right">
                        <span style="font-weight: bold;color: #42b983;padding-right: 25px">รวมงบประมาณแผนที่อนุมัติทั้งหมด {{
                            projectDataToTable.filter(item => item.IsPlanStatus == '2' || item.IsPlanStatus == '5').length
                          }} แผน {{ AllBudgetApprove | currency }} บาท</span>
                          </div>
                          <div align="right">
                        <span style="font-weight: bold;color: #ff6d81;padding-right: 25px">รวมงบประมาณแผนที่ไม่อนุมัติทั้งหมด {{
                            projectDataToTable.filter(item => item.IsPlanStatus == '3').length
                          }} แผน {{ AllBudgetNotApprove | currency }} บาท</span>
                          </div>
                          <div align="right">
                        <span style="font-weight: bold;color: goldenrod;padding-right: 25px">รวมงบประมาณแผนที่ต้องแก้ไขทั้งหมด {{
                            projectDataToTable.filter(item => item.IsPlanStatus == '4').length
                          }} แผน {{ AllBudgetEditApprove | currency }} บาท</span>
                          </div>
                          <div align="right">
                        <span style="font-weight: bold;color: brown;padding-right: 25px">รวมงบประมาณแผนที่ต้องรอพิจารณาทั้งหมด {{
                            projectDataToTable.filter(item => item.IsPlanStatus == '1').length
                          }} แผน {{ AllBudgetPendingApprove | currency }} บาท</span>
                          </div>
                        </template>
                      </v-data-table>
                    </v-list-item>
                  </v-list>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-expand-transition>
          <v-card v-if="Details_Cordi"
                  elevation="10"
          >
            <v-list-item>
              <v-btn
                  outlined
                  color="#FF5722"
                  @click="BackMenu">
                ย้อนกลับ
              </v-btn>
            </v-list-item>
            <v-tabs
                v-model="tabMenu"
                center-active
                dark
                class="pa-6"
            >
              <v-tab key="tab1">
                <span style="font-weight: bold;font-size: 20px;padding: 10px">ข้อมูลแผน</span>
              </v-tab>
              <v-tab key="tab2" :disabled="Project.IsPlanStatus == '9'">
                <span
                    style="font-weight: bold;font-size: 20px;padding: 10px">{{
                    tab == '0' ? 'แก้ไขข้อมูลแผนตั้งงบ' : 'ประวัติขออนุมัติแก้ไขข้อมูลแผน'
                  }}</span>
              </v-tab>
              <v-tab key="tab3">
                <span
                    style="font-weight: bold;font-size: 20px;padding: 10px">ประวัติการแก้ไขแผนตั้งงประมาณประจำปี</span>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabMenu">
              <v-tab-item
                  key="tab1"
              >
                <template>
                  <div>
                    <v-stepper
                        v-model="e1"
                        :vertical="vertical"
                        :alt-labels="altLabels"
                    >
                      <v-stepper-step editable step="1">
                        <span
                            style="font-weight: bold">{{
                            ((ProjectBefore != null && ProjectBefore.Project_type == '1') ? 'ข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี' : 'ข้อมูลการอบรม/เดินทางไปปฏิบัติงาน')
                          }}</span>
                      </v-stepper-step>
                      <v-stepper-content step="1">
                        <v-list-item three-line>
                          <v-list-item-content>
                            <v-row>
                              <v-col
                                  cols="12"
                                  md="12">
                                <h2 class="font-weight-bold" style="color: #ff6d81">
                                  {{ tab == '0' ? 'รายละเอียด' : 'ข้อมูลแผน (เดิม)' }}</h2>
                                <v-list-item style="margin-top: 20px;width: 100%" v-if="ProjectBefore != null">
                                  <v-row>
                                    <v-divider vertical></v-divider>
                                    <v-col
                                        cols="12"
                                        md="5">
                                      <p class="font-weight-bold" style="color: blue">หน่วยงาน:
                                        <span style="color: black">{{
                                            depart.filter(item => item.dep_id == ProjectBefore.Dep_Code).length > 0 ? depart.filter(item => item.dep_id == ProjectBefore.Dep_Code)[0].dep_name : '-'
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                      <p class="font-weight-bold" style="color: blue">ข้อมูลประจำปี:
                                        <span style="color: black">{{
                                            parseInt(ProjectBefore.FiscalYear) + 543
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                      <template v-if="ProjectBefore.Project_type == '2'">
                                        <p class="font-weight-bold" style="color: blue">
                                          ประเภททำรายการ:
                                          <span style="color: black">{{
                                              ProjectBefore.IsProcess == '2' ? 'เดินทางไปราชการ (ในวิชาชีพ)' : ProjectBefore.IsProcess == '1' ? 'เดินทางไปราชการ (นอกวิชาชีพ)' : 'เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)'
                                            }}</span></p>
                                        <v-divider class="ma-4"></v-divider>
                                        <p class="font-weight-bold" style="color: blue">
                                          ประเภทค่าใช้จ่าย:
                                          <span style="color: black">{{
                                              ProjectBefore.IsExpense == '1' ? 'มีค่าใช้จ่าย' : ProjectBefore.IsExpense == '0' ? 'ไม่มีค่าใช้จ่าย' : '-'
                                            }}</span></p>
                                        <v-divider class="ma-4"></v-divider>
                                        <p class="font-weight-bold" style="color: blue">
                                          ประเภทการไปปฏิบัติราชการ:

                                          <span style="color: black">{{
                                              projectGroup.filter(item => item.Project_group == ProjectBefore.Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == ProjectBefore.Project_group)[0].Project_group_des : '-'
                                            }}</span></p>
                                        <v-divider class="ma-4"></v-divider>
                                      </template>
                                      <p class="font-weight-bold" style="color: blue">หมวด:
                                        <span style="color: black">{{
                                            ProjectBefore.Project_category == '1' ? 'พัฒนาบุคลากร' : ProjectBefore.Project_category == '2' ? 'โครงการอื่นๆ' : ProjectBefore.Project_category == '3' ? 'บริการวิชาการ' : 'วิจัย'
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                      <template v-if="ProjectBefore.Project_type == '1'">
                                        <p class="font-weight-bold" style="color: blue">ประเภทแผน:
                                          <span style="color: black">{{
                                              ProjectBefore.IsPlan == '1' ? 'ในแผน' : 'นอกแผน'
                                            }}</span></p>
                                        <v-divider class="ma-4"></v-divider>
                                      </template>
                                      <template v-if="ProjectBefore.Project_type == '1'">
                                        <template v-if="episode == '1'">
                                          <p class="font-weight-bold" style="color: blue">ระยะเวลาที่คาดว่าจะจัด:
                                            <span style="color: black">{{
                                                'ต.ค. ' + (parseInt(FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(FiscalYear) + 543 - 1)
                                              }}</span></p>
                                          <v-divider class="ma-4"></v-divider>
                                        </template>
                                        <template v-else-if="episode == '2'">
                                          <p class="font-weight-bold" style="color: blue">
                                            ระยะเวลาที่คาดว่าจะจัด:
                                            <span style="color: black">{{
                                                'ม.ค. ' + (parseInt(FiscalYear) + 543) + '- มี.ค. ' + (parseInt(FiscalYear) + 543)
                                              }}</span></p>
                                          <v-divider class="ma-4"></v-divider>
                                        </template>
                                        <template v-else-if="episode == '3'">
                                          <p class="font-weight-bold" style="color: blue">
                                            ระยะเวลาที่คาดว่าจะจัด:
                                            <span style="color: black">{{
                                                'เม.ย. ' + (parseInt(FiscalYear) + 543) + '- มิ.ย. ' + (parseInt(FiscalYear) + 543)
                                              }}</span></p>
                                          <v-divider class="ma-4"></v-divider>
                                        </template>
                                        <template v-else-if="episode == '4'">
                                          <p class="font-weight-bold" style="color: blue">
                                            ระยะเวลาที่คาดว่าจะจัด:
                                            <span style="color: black">{{
                                                'ก.ค. ' + (parseInt(FiscalYear) + 543) + '- ก.ย. ' + (parseInt(FiscalYear) + 543)
                                              }}</span></p>
                                          <v-divider class="ma-4"></v-divider>
                                        </template>
                                        <template v-else-if="episode == '9'">
                                          <p class="font-weight-bold" style="color: blue">ระยะเวลาที่คาดว่าจะจัด:
                                            <span style="color: black">{{
                                                'ตลอดปีงบประมาณ ' + (parseInt(FiscalYear) + 543)
                                              }}</span></p>
                                          <v-divider class="ma-4"></v-divider>
                                        </template>
                                      </template>
                                      <template v-else-if="ProjectBefore.Project_type == '2'">
                                        <p class="font-weight-bold" style="color: blue">วันที่จัด:
                                          <span style="color: black"
                                                v-if="ProjectBefore.DateStart == ProjectBefore.DateEnd">{{
                                              ProjectBefore.DateStart | dateToThai
                                            }}</span>
                                          <span style="color: black" v-else>{{
                                              ProjectBefore.DateStart | dateToThai
                                            }} - {{
                                              ProjectBefore.DateEnd | dateToThai
                                            }}</span>
                                        </p>
                                        <v-divider class="ma-4"></v-divider>
                                      </template>
                                      <p class="font-weight-bold" style="color: blue">รหัสอบรม/เดินทาง: <span
                                          style="color: black">{{ ProjectBefore.Project_code }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                      <p class="font-weight-bold" style="color: blue">ชื่องาน / กิจจกรม:
                                        <span style="color: black">{{
                                            ProjectBefore.Project_name
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                      <p class="font-weight-bold" style="color: blue">
                                        {{
                                          ProjectBefore.Project_type == '1' ? 'ประเภทแผน' : 'ประเภทการไปปฏิบัติราชการ'
                                        }}:
                                        <span style="color: black">{{
                                            projectGroup.filter(item => item.Project_group == ProjectBefore.Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == ProjectBefore.Project_group)[0].Project_group_des : '-'
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                      <p class="font-weight-bold" style="color: blue">หลักสูตร:
                                        <span style="color: black">{{
                                            courseData.filter(item => item.Course_code == ProjectBefore.Course_code).length > 0 ? courseData.filter(item => item.Course_code == ProjectBefore.Course_code)[0].Course_name : '-'
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                      <p class="font-weight-bold" style="color: blue">สาขาประเภทหลักสูตร:
                                        <span style="color: black">{{
                                            courseData.filter(item => item.Course_code == ProjectBefore.Course_code).length > 0 ? courseData.filter(item => item.Course_code == ProjectBefore.Course_code)[0].Course_type_des : '-'
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                      <p class="font-weight-bold" style="color: blue">ระยะเวลา:
                                        <span style="color: black">{{
                                            courseData.filter(item => item.Course_code == ProjectBefore.Course_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == ProjectBefore.Course_code)[0].Period_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == ProjectBefore.Course_code)[0].Period_code)[0].name : '-' : '-'
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                    </v-col>
                                    <v-divider vertical></v-divider>
                                    <v-col
                                        cols="12"
                                        md="5">
                                      <p class="font-weight-bold" style="color: blue">จำนวน ช.ม.: <span
                                          style="color: black">{{ ProjectBefore.CalHourse }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                      <p class="font-weight-bold" style="color: blue">จำนวน เครดิต: <span
                                          style="color: black">{{ ProjectBefore.CalCredit }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                      <p class="font-weight-bold" style="color: blue">งบประมาณที่ขอ: <span
                                          style="color: black">{{ ProjectBefore.BudgetRequest | currency }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                      <p class="font-weight-bold" style="color: blue">งานถูกจัดขึ้น: <span
                                          style="color: black">{{
                                          PLACESelete.filter(item => item.id == ProjectBefore.PLACE).length > 0 ? PLACESelete.filter(item => item.id == ProjectBefore.PLACE)[0].detail : '-'
                                        }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                      <template v-if="ProjectBefore.PLACE == '2'">
                                        <p class="font-weight-bold" style="color: blue">จังหวัด: <span
                                            style="color: black">{{
                                            provinces_Data.filter(item => item.code == ProjectBefore.Province_id).length > 0 ? provinces_Data.filter(item => item.code == ProjectBefore.Province_id)[0].name_th : '-'
                                          }}</span></p>
                                        <v-divider class="ma-4"></v-divider>
                                      </template>
                                      <template v-else-if="ProjectBefore.PLACE == '3'">
                                        <p class="font-weight-bold" style="color: blue">ประเทศ: <span
                                            style="color: black">{{
                                            countryData.filter(item => item.ct_code == ProjectBefore.Country_id).length > 0 ? countryData.filter(item => item.ct_code == ProjectBefore.Country_id)[0].ct_nameTHA : '-'
                                          }}</span></p>
                                        <v-divider class="ma-4"></v-divider>
                                      </template>
                                      <p class="font-weight-bold" style="color: blue">จัดโดย:
                                        <span style="color: black">{{
                                            WorkByData.filter(item => item.id == ProjectBefore.WorkBy).length > 0 ? WorkByData.filter(item => item.id == ProjectBefore.WorkBy)[0].detail : '-'
                                          }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                      <p class="font-weight-bold" style="color: blue">ชื่อผู้จัด: <span
                                          style="color: black">{{ ProjectBefore.WorkByName }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                      <p class="font-weight-bold" style="color: blue">เบอร์โทรติดต่อผู้กรอกข้อมูล:
                                        <span style="color: black">{{ ProjectBefore.WorkByPhone }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                      <p class="font-weight-bold" style="color: blue">สถานที่จัด: <span
                                          style="color: black">{{ ProjectBefore.Location }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                      <template v-if="ProjectBefore.Project_type == '1'">
                                        <p class="font-weight-bold" style="color: blue">กลุ่มเป้าหมาย: <span
                                            style="color: black">{{ ProjectBefore.TargetGroup }}</span></p>
                                        <v-divider class="ma-4"></v-divider>
                                        <p class="font-weight-bold" style="color: blue">วัตถุประสงค์: <span
                                            style="color: black">{{ ProjectBefore.Objective }}</span></p>
                                        <v-divider class="ma-4"></v-divider>
                                      </template>
                                      <p class="font-weight-bold" style="color: blue">รายละเอียดประกอบ (เพิ่มเติม):
                                        <span style="color: black">{{ ProjectBefore.Remarks }}</span></p>
                                      <v-divider class="ma-4"></v-divider>
                                      <p class="font-weight-bold" style="color: blue">Competency,Core Value,Strategic
                                        Objective:
                                        <v-btn text color="primary" @click="showCompetency(ProjectBefore)">คลิก!!
                                        </v-btn>
                                      </p>
                                      <v-divider class="ma-4"></v-divider>
                                      <p class="font-weight-bold" style="color: blue">ไฟล์เอกสารประกอบ:
                                        <v-btn text color="primary" @click="showFile()">คลิก!!</v-btn>
                                      </p>
                                      <v-divider class="ma-4"></v-divider>
                                      <template v-if="ProjectBefore.Project_type == '2'">
                                        <p class="font-weight-bold" style="color: blue"
                                           v-if="ProjectBefore.Project_type == '2'">ผู้เข้าร่วมจำนวน
                                          {{ JoinTravel.length }} คน:
                                          <v-btn text color="primary" v-if="JoinTravel.length > 0"
                                                 @click="showJoinTravel()">คลิก!!
                                          </v-btn>
                                        </p>
                                        <p class="font-weight-bold" style="color: blue"
                                           v-if="ProjectBefore.Project_type == '2'">เอกสารแบบฟอร์มเสนอ (จากระบบ):
                                          <v-btn text color="primary" @click="showFileReport(ProjectBefore)">คลิก!!
                                          </v-btn>
                                        </p>
                                        <v-divider class="ma-4"></v-divider>
                                      </template>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item>
                                  <p class="mt-8" style="font-weight: bold">
                                    <span v-if="ProjectBefore.Project_type == '1'">วันที่บันทึกข้อมูลแผน:</span>
                                    <span v-else-if="ProjectBefore.Project_type == '2'">วันที่บันทึกข้อมูล:</span>
                                    {{ ProjectBefore.Create_Time | dateToThai2 }}</p>
                                </v-list-item>
                                <v-list-item>
                                  <p style="font-weight: bold">สถานะแผน:
                                    <v-chip
                                        v-if="StatusProject.filter(staItem => staItem.id == ProjectBefore.IsPlanStatus).length > 0"
                                        :color="StatusProject.filter(staItem => staItem.id == ProjectBefore.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == ProjectBefore.IsPlanStatus)[0].color : ''"
                                        style="transform: scale(0.8);color: white"
                                    >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == ProjectBefore.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == ProjectBefore.IsPlanStatus)[0].status : ''
                              }}</span>
                                    </v-chip>
                                  </p>
                                </v-list-item>
                                <v-list-item
                                    v-if="parseInt(ProjectBefore.IsPlanStatus) >= 6 && parseInt(ProjectBefore.IsPlanStatus) <= 9">
                                  <hr class="mb-2 mt-2"/>
                                  <span style="font-size: 16px;color: green;font-weight: bold;margin-top: 30px">
                                อนุมัติวงเงิน : {{ ProjectBefore.BudgetArrove | currency }} บาท
                              </span>
                                </v-list-item>
                                <v-list-item
                                    v-if="parseInt(ProjectBefore.IsPlanStatus) >= 6 && parseInt(ProjectBefore.IsPlanStatus) <= 9">
                                  <hr class="mb-2 mt-2"/>
                                  <span style="font-size: 16px;color: green;font-weight: bold;margin-top: 30px">
                                จำนวนเงินเบิกจ่าย : {{ ProjectBefore.MoneyDisburse | currency }} บาท
                              </span>
                                </v-list-item>
                              </v-col>
                              <v-divider vertical></v-divider>
                              <v-col
                                  cols="12"
                                  md="12"
                                  v-if="tab == '1'"
                              >
                                <h2 class="font-weight-bold" style="color: #ff6d81">ข้อมูลแผน (แก้ไขใหม่)</h2>
                                <v-list-item style="margin-top: 20px">
                                  <div class="py-4">
                                    <v-row>
                                      <v-col
                                          cols="12"
                                          md="6">
                                        <p class="font-weight-bold">หน่วยงาน:
                                          {{
                                            depart.filter(item => item.dep_id == Project.Dep_Code).length > 0 ? depart.filter(item => item.dep_id == Project.Dep_Code)[0].dep_name : '-'
                                          }}</p>
                                        <p class="font-weight-bold">แผนประจำปี: {{
                                            parseInt(Project.FiscalYear) + 543
                                          }}</p>
                                        <p class="font-weight-bold" v-if="Project.Project_type == '2'">ประเภททำรายการ:
                                          {{
                                            Project.IsProcess == '2' ? 'เดินทางไปราชการ (ในวิชาชีพ)' : Project.IsProcess == '1' ? 'เดินทางไปราชการ (นอกวิชาชีพ)' : ' เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)'
                                          }}</p>
                                        <p class="font-weight-bold">หมวด:
                                          {{
                                            Project.Project_category == '1' ? 'พัฒนาบุคลากร' : Project.Project_category == '2' ? 'โครงการอื่นๆ' : Project.Project_category == '3' ? 'บริการวิชาการ' : 'วิจัย'
                                          }}</p>
                                        <p class="font-weight-bold">ประเภทแผน: {{
                                            Project.IsPlan == '1' ? 'ในแผน' : 'นอกแผน'
                                          }}</p>
                                        <p class="font-weight-bold" v-if="episode == '1'">ระยะเวลาที่คาดว่าจะจัด:
                                          {{
                                            'ต.ค. ' + (parseInt(FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(FiscalYear) + 543 - 1)
                                          }}</p>
                                        <p class="font-weight-bold" v-else-if="episode == '2'">
                                          ระยะเวลาที่คาดว่าจะจัด:
                                          {{
                                            'ม.ค. ' + (parseInt(FiscalYear) + 543) + '- มี.ค. ' + (parseInt(FiscalYear) + 543)
                                          }}</p>
                                        <p class="font-weight-bold" v-else-if="episode == '3'">
                                          ระยะเวลาที่คาดว่าจะจัด:
                                          {{
                                            'เม.ย. ' + (parseInt(FiscalYear) + 543) + '- มิ.ย. ' + (parseInt(FiscalYear) + 543)
                                          }}</p>
                                        <p class="font-weight-bold" v-else-if="episode == '4'">
                                          ระยะเวลาที่คาดว่าจะจัด:
                                          {{
                                            'ก.ค. ' + (parseInt(FiscalYear) + 543) + '- ก.ย. ' + (parseInt(FiscalYear) + 543)
                                          }}</p>
                                        <p class="font-weight-bold" v-else-if="episode == '9'">
                                          ระยะเวลาที่คาดว่าจะจัด:
                                          {{
                                            'ตลอดปีงบประมาณ ' + (parseInt(FiscalYear) + 543)
                                          }}</p>
                                        <p class="font-weight-bold">รหัสแผน: {{ Project.Project_code }}</p>
                                        <p class="font-weight-bold">ชื่องาน / กิจจกรม: {{ Project.Project_name }}</p>
                                        <p class="font-weight-bold">ประเภทแผน:
                                          {{
                                            projectGroup.filter(item => item.Project_group == Project.Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == Project.Project_group)[0].Project_group_des : '-'
                                          }}</p>
                                        <p class="font-weight-bold">หลักสูตร:
                                          {{
                                            courseData.filter(item => item.Course_code == Project.Course_code).length > 0 ? courseData.filter(item => item.Course_code == Project.Course_code)[0].Course_name : '-'
                                          }}</p>
                                        <p class="font-weight-bold">สาขาประเภทหลักสูตร:
                                          {{
                                            courseData.filter(item => item.Course_code == Project.Course_code).length > 0 ? courseData.filter(item => item.Course_code == Project.Course_code)[0].Course_type_des : '-'
                                          }}</p>
                                        <p class="font-weight-bold">ระยะเวลา:
                                          {{
                                            courseData.filter(item => item.Course_code == Project.Course_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == Project.Course_code)[0].Period_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == Project.Course_code)[0].Period_code)[0].name : '-' : '-'
                                          }}</p>
                                      </v-col>
                                      <v-col
                                          cols="12"
                                          md="6">
                                        <p class="font-weight-bold">จำนวน ช.ม.: {{ Project.CalHourse }}</p>
                                        <p class="font-weight-bold">จำนวน เครดิต: {{ Project.CalCredit }}</p>
                                        <p class="font-weight-bold">งบประมาณที่ขอ: {{ Project.BudgetRequest }}</p>
                                        <p class="font-weight-bold">งานถูกจัดขึ้น: {{
                                            PLACESelete.filter(item => item.id == Project.PLACE).length > 0 ? PLACESelete.filter(item => item.id == Project.PLACE)[0].detail : '-'
                                          }}</p>
                                        <p class="font-weight-bold" v-if="Project.PLACE == '2'">จังหวัด: {{
                                            provinces_Data.filter(item => item.code == Project.Province_id).length > 0 ? provinces_Data.filter(item => item.code == Project.Province_id)[0].name_th : '-'
                                          }}</p>
                                        <p class="font-weight-bold" v-else-if="Project.PLACE == '3'">ประเทศ: {{
                                            countryData.filter(item => item.ct_code == Project.Country_id).length > 0 ? countryData.filter(item => item.ct_code == Project.Country_id)[0].ct_nameTHA : '-'
                                          }}</p>
                                        <p class="font-weight-bold">จัดโดย:
                                          {{
                                            WorkByData.filter(item => item.id == Project.WorkBy).length > 0 ? WorkByData.filter(item => item.id == Project.WorkBy)[0].detail : '-'
                                          }}</p>
                                        <p class="font-weight-bold">ชื่อผู้จัด: {{ Project.WorkByName }}</p>
                                        <p class="font-weight-bold">เบอร์โทรติดต่อผู้กรอกข้อมูล: {{
                                            Project.WorkByPhone
                                          }}</p>
                                        <p class="font-weight-bold">สถานที่จัด: {{ Project.Location }}</p>
                                        <p class="font-weight-bold">กลุ่มเป้าหมาย: {{ Project.TargetGroup }}</p>
                                        <p class="font-weight-bold">วัตถุประสงค์: {{ Project.Objective }}</p>
                                        <p class="font-weight-bold">รายละเอียดประกอบ (เพิ่มเติม): {{
                                            Project.Remarks
                                          }}</p>
                                        <p class="font-weight-bold">Competency,Core Value,Strategic Objective:
                                          <v-btn text color="primary" @click="showTempCompetency(Project)">คลิก!!
                                          </v-btn>
                                        </p>
                                        <p class="font-weight-bold">ไฟล์เอกสารประกอบ:
                                          <v-btn text color="primary" @click="showTempFile(Project)">คลิก!!</v-btn>
                                        </p>
                                      </v-col>
                                    </v-row>
                                    <v-divider></v-divider>
                                    <p class="mt-8" style="font-weight: bold">วันที่บันทึกข้อมูลขอแก้ไขแผน:
                                      {{ Project.Create_Time | dateToThai2 }}</p>
                                    <v-divider></v-divider>
                                  </div>
                                </v-list-item>
                              </v-col>
                            </v-row>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item class="d-flex justify-end">
                        </v-list-item>
                      </v-stepper-content>
                      <template v-if="tab == '0'">
                        <template
                            v-if="(Project.IsPlanStatus != '0' && Project.IsPlanStatus != '4' && Project.IsPlanStatus != '8' && Project.IsPlanStatus != '9') && (ApproveMaster.length > 0 && ApproveMaster[0].readonly == '0')">
                          <v-stepper-step step="2" editable>
                        <span
                            class="font-weight-bold">พิจารณาแผน</span>
                          </v-stepper-step>
                          <v-stepper-content step="2">
                            <v-card style="border: 1px solid">
                              <v-toolbar
                                  dark
                                  :color="appColor">
                                <span>พิจารณาแผน</span>
                              </v-toolbar>
                              <template v-if="Approve_Status.filter(item => !item.disable).length > 0">
                                <v-list-item class="justify-center" style="margin-top: 30px">
                                  <v-row class="d-flex justify-center">
                                    <v-col
                                        cols="12"
                                        md="8">
                                      <v-autocomplete
                                          outlined
                                          v-model="Approve_m"
                                          label="ผลการพิจารณา"
                                          :items="Approve_Status.filter(item => !item.disable)"
                                          item-text="detail"
                                          item-value="id"
                                          :error-messages="Approve_m == '' ? 'ผลการพิจารณา (ห้ามว่าง)' : ''"
                                          persistent-hint
                                          :error="Approve_m == ''"
                                      >
                                      </v-autocomplete>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <!--                    <v-list-item class="justify-center" v-if="Approve_m == '0'">
                                                      <v-row class="d-flex justify-center">
                                                        &lt;!&ndash;                              <v-col&ndash;&gt;
                                                        &lt;!&ndash;                                  cols="12"&ndash;&gt;
                                                        &lt;!&ndash;                                  md="4">&ndash;&gt;
                                                        &lt;!&ndash;                                <v-text-field&ndash;&gt;
                                                        &lt;!&ndash;                                    v-model="App_doc_no"&ndash;&gt;
                                                        &lt;!&ndash;                                    outlined&ndash;&gt;
                                                        &lt;!&ndash;                                    label="หนังสือเลขที่อนุมัติหลักการ"&ndash;&gt;
                                                        &lt;!&ndash;                                >&ndash;&gt;
                                                        &lt;!&ndash;                                </v-text-field>&ndash;&gt;
                                                        &lt;!&ndash;                              </v-col>&ndash;&gt;
                                                        <v-col
                                                            cols="12"
                                                            md="8">
                                                          <v-text-field
                                                              v-model="BudgetArrove"
                                                              outlined
                                                              label="จำนวนเงินที่อนุมัติ"
                                                          >
                                                          </v-text-field>
                                                        </v-col>
                                                      </v-row>
                                                    </v-list-item>-->
                                <v-list-item class="justify-center">
                                  <v-row class="d-flex justify-center">
                                    <v-col
                                        cols="12"
                                        md="8">
                                      <v-textarea
                                          v-model="remarksApprove"
                                          outlined
                                          label="เหตุผล"
                                      >
                                      </v-textarea>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="justify-center">
                                  <v-row class="d-flex justify-center">
                                    <v-col
                                        cols="12"
                                        md="8">
                                      <v-text-field
                                          type="date"
                                          v-model="dateApprove"
                                          outlined
                                          label="วันที่พิจารณา"
                                          :error-messages="dateApprove == '' ? 'วันที่พิจารณา (ห้ามว่าง)' : ''"
                                          persistent-hint
                                          :error="dateApprove == ''"
                                      >
                                      </v-text-field>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="justify-center">
                                  <v-row class="d-flex justify-center">
                                    <v-col
                                        cols="12"
                                        md="8">
                                      <v-file-input
                                          v-model="files"
                                          color="deep-purple accent-4"
                                          counter
                                          label="ไฟล์แนบ"
                                          multiple
                                          placeholder="เลือกไฟล์"
                                          prepend-icon="mdi-paperclip"
                                          outlined
                                          :show-size="1000"
                                          @change="FileSelect"
                                      >
                                        <template v-slot:selection="{ index, text }">
                                          <v-chip
                                              v-if="index < 5"
                                              color="deep-purple accent-4"
                                              dark
                                              label
                                              small
                                          >
                                            {{ text }}
                                          </v-chip>

                                          <span
                                              v-else-if="index === 5"
                                              class="overline grey--text text--darken-3 mx-2"
                                          >
          +{{ files.length - 2 }} File(s)
        </span>
                                        </template>
                                      </v-file-input>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="justify-center">
                                  <v-row class="d-flex justify-center">
                                    <v-col
                                        cols="12"
                                        md="8">
                                      <v-alert
                                          v-if="alert"
                                          prominent
                                          type="error"
                                      >
                                        <v-row align="center" v-for="item in txtAlert"
                                               :key="item.id">
                                          <v-col class="d-flex grow">- {{ item.Detail }}
                                          </v-col>
                                        </v-row>
                                      </v-alert>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item v-if="File_Consider.length > 0">
                                  <template>
                                    <v-row>
                                      <v-col cols="12" sm="6" offset-sm="3">
                                        <v-card>
                                          <v-card-title>
                                            ไฟล์แนบประกอบ
                                          </v-card-title>
                                          <v-container fluid>
                                            <v-row>
                                              <v-col
                                                  v-for="(file_i, index) in File_Consider"
                                                  :key="index"
                                                  class="d-flex child-flex"
                                                  cols="12"
                                                  md="4"
                                              >
                                                <v-card flat tile>
                                                  <v-img
                                                      v-if="file_i.type == 'image'"
                                                      :src="file_i.src"
                                                      :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                      aspect-ratio="1"
                                                      class="grey lighten-2"
                                                  >
                                                    <template
                                                        v-slot:placeholder>
                                                      <v-row
                                                          class="fill-height ma-0"
                                                          align="center"
                                                          justify="center"
                                                      >
                                                        <v-progress-circular
                                                            indeterminate
                                                            color="grey lighten-5"></v-progress-circular>
                                                      </v-row>
                                                    </template>
                                                  </v-img>
                                                  <v-img
                                                      v-if="file_i.type == 'pdf'"
                                                      src="../assets/Image/pdf.png"
                                                      :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                      aspect-ratio="1"
                                                      class="grey lighten-2"
                                                  >
                                                    <template
                                                        v-slot:placeholder>
                                                      <v-row
                                                          class="fill-height ma-0"
                                                          align="center"
                                                          justify="center"
                                                      >
                                                        <v-progress-circular
                                                            indeterminate
                                                            color="grey lighten-5"></v-progress-circular>
                                                      </v-row>
                                                    </template>
                                                  </v-img>
                                                  <v-card-text>
                                                                          <span
                                                                              style="font-weight: bold;color: black">
                                                                              {{ file_i.name }}
                                                                          </span>
                                                  </v-card-text>
                                                  <v-card-actions>
                                                    <v-btn text
                                                           @click="ShowData(file_i.src)">
                                                                              <span
                                                                                  style="color: indigo;font-weight: bold">
                                                                                  เรียกดู
                                                                              </span>
                                                    </v-btn>
                                                    <v-btn text
                                                           @click="DeleteFile(file_i)">
                                                                               <span
                                                                                   style="color: red;font-weight: bold">
                                                                                  ลบ
                                                                              </span>
                                                    </v-btn>
                                                  </v-card-actions>
                                                </v-card>
                                              </v-col>
                                            </v-row>
                                          </v-container>
                                        </v-card>
                                      </v-col>
                                    </v-row>
                                  </template>
                                </v-list-item>
                                <v-list-item>
                                  <v-row class="d-flex justify-center">
                                    <v-col
                                        class="d-flex justify-center"
                                        cols="6"
                                        md="3">
                                      <v-btn
                                          style="height: 55px"
                                          outlined
                                          color="primary"
                                          @click="Approve_m == '10' ? ChooseMasterApprove('2', 'approvePlan') : Approve_m == '11' ?ChooseMasterApprove('3', 'approvePlan')  : ConsideProject(false)"
                                      >
                                        บันทึก
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                              </template>
                              <template v-else>
                                <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                                  คุณไม่ได้รับสิทธิ์ในการพิจารณาแผนตั้งงบประมาณประจำปี !!</p>
                              </template>
                              <v-list-item class="justify-center">
                                <v-row justify="center">
                                  <v-col
                                      cols="12"
                                      md="12">
                                    <span style="font-weight: bold">ประวัติการพิจารณา</span>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <template v-if="RecordDataDump.length > 0">
                                <v-list-item class="justify-center">
                                  <v-row justify="center">
                                    <v-col
                                        cols="12"
                                        md="12">
                                      <v-list-item>
                                        <v-expansion-panels popout>
                                          <v-expansion-panel
                                              v-for="(item,i) in RecordDataDump"
                                              :key="i"
                                          >
                                            <v-expansion-panel-header>
                                             <span
                                                 style="color: #364eff;margin-left: 15px;font-weight: bold">{{
                                                 item.Date_Approve | DateToThai
                                               }}</span><span
                                                style="font-weight: bold;color: blue">( {{ (item.Type == '1' ? 'คณะ' : item.Type == '2' ? 'หน่วยงาน' : 'ผู้มีอำนาจ(หน่วยงาน)') }} )</span>
                                              สถานะ :
                                              <v-chip
                                                  v-if="StatusProject.filter(staItem => staItem.id == item.Status).length > 0"
                                                  :color="StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].color : ''"
                                                  style="transform: scale(0.8);color: white"
                                                  class="d-flex justify-center"
                                              >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].status : ''
                              }}</span>
                                              </v-chip>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                              <p>
                                                เหตุผล : {{ item.Remark }}
                                              </p>
                                              <div v-for="(file,idx) in item.files"
                                                   v-bind:key="idx"
                                                   style="color: #ff6d81">
                                                ไฟล์ประกอบ :
                                                <v-btn text
                                                       @click="ShowData(Openfile + file.File_path)">
                                                  {{ file.File_name }}
                                                </v-btn>
                                              </div>
                                            </v-expansion-panel-content>
                                          </v-expansion-panel>
                                        </v-expansion-panels>
                                      </v-list-item>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                              </template>
                              <template v-else>
                                <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                                  ไม่พบข้อมูลประวัติผลการพิจารณาแผน !!</p>
                              </template>
                            </v-card>
                          </v-stepper-content>
                        </template>

                      </template>
                      <template v-else>
                        <v-stepper-step step="2" editable
                                        v-if="(Project.Req_status == '0' || Project.Req_status == '3' || Project.Req_status == '4') && (ApproveMaster.length > 0 && ApproveMaster[0].readonly == '0')">
                        <span
                            class="font-weight-bold">พิจารณาขออมุัติแก้ไขข้อมูลแผน</span>
                        </v-stepper-step>
                        <v-stepper-content step="2">
                          <v-card style="border: 1px solid">
                            <v-toolbar
                                dark
                                :color="appColor">
                                                      <span>พิจารณาขออมุัติแก้ไขข้อมูลแผน
                                                      </span>
                            </v-toolbar>
                            <template v-if="Req_Approve_Status.filter(item => !item.disable).length > 0">
                              <v-list-item class="justify-center" style="margin-top: 30px">
                                <v-row class="d-flex justify-center">
                                  <v-col
                                      cols="12"
                                      md="8">
                                    <v-autocomplete
                                        outlined
                                        v-model="Approve_m"
                                        label="ผลการพิจารณา"
                                        :items="Req_Approve_Status"
                                        item-text="detail"
                                        item-value="id"
                                        :error-messages="Approve_m == '' ? 'ผลการพิจารณา (ห้ามว่าง)' : ''"
                                        persistent-hint
                                        :error="Approve_m == ''"
                                    >
                                    </v-autocomplete>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <!--                    <v-list-item class="justify-center" v-if="Approve_m == '0'">
                                                    <v-row class="d-flex justify-center">
                                                      &lt;!&ndash;                              <v-col&ndash;&gt;
                                                      &lt;!&ndash;                                  cols="12"&ndash;&gt;
                                                      &lt;!&ndash;                                  md="4">&ndash;&gt;
                                                      &lt;!&ndash;                                <v-text-field&ndash;&gt;
                                                      &lt;!&ndash;                                    v-model="App_doc_no"&ndash;&gt;
                                                      &lt;!&ndash;                                    outlined&ndash;&gt;
                                                      &lt;!&ndash;                                    label="หนังสือเลขที่อนุมัติหลักการ"&ndash;&gt;
                                                      &lt;!&ndash;                                >&ndash;&gt;
                                                      &lt;!&ndash;                                </v-text-field>&ndash;&gt;
                                                      &lt;!&ndash;                              </v-col>&ndash;&gt;
                                                      <v-col
                                                          cols="12"
                                                          md="8">
                                                        <v-text-field
                                                            v-model="BudgetArrove"
                                                            outlined
                                                            label="จำนวนเงินที่อนุมัติ"
                                                        >
                                                        </v-text-field>
                                                      </v-col>
                                                    </v-row>
                                                  </v-list-item>-->
                              <v-list-item class="justify-center">
                                <v-row class="d-flex justify-center">
                                  <v-col
                                      cols="12"
                                      md="8">
                                    <v-textarea
                                        v-model="remarksApprove"
                                        outlined
                                        label="เหตุผล"
                                    >
                                    </v-textarea>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                              <v-list-item>
                                <v-row class="d-flex justify-center">
                                  <v-col
                                      class="d-flex justify-center"
                                      cols="6"
                                      md="3">
                                    <v-btn
                                        style="height: 55px"
                                        outlined
                                        color="primary"
                                        @click="Approve_m == '3' ? ChooseMasterApprove('2', 'approveEditPlan') : Approve_m == '4' ?ChooseMasterApprove('3', 'approveEditPlan')  : ConsideReqEditProject(false)"
                                        :disabled="btnDisable"
                                    >
                                      บันทึก
                                    </v-btn>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                            </template>
                            <template v-else>
                              <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                                คุณไม่ได้รับสิทธิ์ในการพิจารณาแผนตั้งงบประมาณประจำปี !!</p>
                            </template>
                            <v-list-item class="justify-center">
                              <v-row justify="center">
                                <v-col
                                    cols="12"
                                    md="12">
                                  <span style="font-weight: bold">ประวัติการพิจารณา</span>
                                </v-col>
                              </v-row>
                            </v-list-item>
                            <template v-if="TempRecordData.length > 0">
                              <v-list-item class="justify-center">
                                <v-row justify="center">
                                  <v-col
                                      cols="12"
                                      md="12">
                                    <v-list-item>
                                      <v-expansion-panels popout>
                                        <v-expansion-panel
                                            v-for="(item,i) in TempRecordData"
                                            :key="i"
                                        >
                                          <v-expansion-panel-header>
                                           <span
                                               style="color: #364eff;margin-left: 15px;font-weight: bold">{{
                                               item.Date_Approve | DateToThai
                                             }}</span><span
                                              style="font-weight: bold;color: blue">( {{ (item.Type == '1' ? 'คณะ' : item.Type == '2' ? 'หน่วยงาน' : 'ผู้มีอำนาจ(หน่วยงาน)') }} )</span>
                                            สถานะ :
                                            <v-chip
                                                v-if="StatusProject.filter(staItem => staItem.id == item.Status).length > 0"
                                                :color="StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].color : ''"
                                                style="transform: scale(0.8);color: white"
                                                class="d-flex justify-center"
                                            >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == item.Status).length > 0 ? StatusProject.filter(staItem => staItem.id == item.Status)[0].status : ''
                              }}</span>
                                            </v-chip>
                                          </v-expansion-panel-header>
                                          <v-expansion-panel-content>
                                            <p>
                                              เหตุผล : {{ item.Remark }}
                                            </p>
                                            <div v-for="(file,idx) in item.files"
                                                 v-bind:key="idx"
                                                 style="color: #ff6d81">
                                              ไฟล์ประกอบ :
                                              <v-btn text
                                                     @click="ShowData(Openfile + file.File_path)">
                                                {{ file.File_name }}
                                              </v-btn>
                                            </div>
                                          </v-expansion-panel-content>
                                        </v-expansion-panel>
                                      </v-expansion-panels>
                                    </v-list-item>
                                  </v-col>
                                </v-row>
                              </v-list-item>
                            </template>
                            <template v-else>
                              <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                                ไม่พบข้อมูลประวัติผลการพิจารณาแผน !!</p>
                            </template>
                          </v-card>
                        </v-stepper-content>
                      </template>
                    </v-stepper>
                  </div>
                </template>
              </v-tab-item>
              <v-tab-item
                  key="tab2"
              >
                <template v-if="tab == '0'">
                  <template v-if="(ApproveMaster.length > 0 && ApproveMaster[0].readonly == '0')">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title class="headline mb-1"><span>ข้อมูลเสนอแผนขอตั้งงบประมาณประจำปี</span>
                        </v-list-item-title>
                        <!--              <v-list-item>
                                        <v-row justify="space-around">
                                          <span>วันที่เริ่มต้นโครงการ</span>
                                          <span>วันที่สิ้นสุดโครงการ</span>
                                        </v-row>
                                      </v-list-item>
                                      <v-list-item>
                                        <v-row class="d-flex justify-center">
                                          <v-col
                                              class="d-flex justify-center"
                                              cols="12"
                                              md="6"
                                          >
                                            <v-date-picker
                                                v-model="DateStart"
                                                :landscape="landscape"
                                                :reactive="reactive"
                                                :full-width="fullWidth"
                                                :show-current="showCurrent"
                                                :type="month ? 'month' : 'date'"
                                                :multiple="multiple"
                                                :readonly="readonly"
                                                :disabled="disabled"
                                                locale="th"
                                                :events="enableEvents ? functionEvents : null"
                                                :color="DateStart == '' ? 'red' : 'primary'"
                                                style="border: 1px solid black;border-radius: 5px"
                                            ></v-date-picker>
                                          </v-col>
                                          <v-col
                                              class="d-flex justify-center"
                                              cols="12"
                                              md="6">
                                            <v-date-picker
                                                v-model="DateEnd"
                                                :landscape="landscape"
                                                :reactive="reactive"
                                                :full-width="fullWidth"
                                                :show-current="showCurrent"
                                                :type="month ? 'month' : 'date'"
                                                :multiple="multiple"
                                                :readonly="readonly"
                                                :disabled="disabled"
                                                locale="th"
                                                :events="enableEvents ? functionEvents : null"
                                                :color="DateEnd == '' ? 'red' : 'primary'"
                                                style="border: 1px solid black;border-radius: 5px"
                                            ></v-date-picker>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>-->
                        <v-row>
                          <v-col
                              cols="12"
                              md="6">
                            <v-card>
                              <v-card-subtitle>
                                <span style="font-size: 20px;color: black;font-weight: bold">ข้อมูลแผน</span>
                                <v-spacer></v-spacer>
                                <!--                        <span style="font-size: 20px;color: green;font-weight: bold" v-if="DateForPlan.length > 0">ช่วงระยะเวลาเสนอแผน ประจำปี {{ parseInt(DateForPlan[0].year) + 543 }} : {{ DateForPlan[0].date_start | dateToThai }} - {{ DateForPlan[0].date_end | dateToThai }}</span>-->
                              </v-card-subtitle>
                              <v-card-text>
                                <v-list-item style="margin-top: 20px">
                                  <v-row class="d-flex justify-center">
                                    <v-col
                                        cols="12"
                                        md="8"
                                    >
                                      <v-autocomplete
                                          v-model="DepSelect"
                                          label="หน่วยงาน"
                                          :items="depart"
                                          item-text="dep_name"
                                          item-value="dep_id"
                                          hint="หน่วยงาน (ห้ามว่าง)"
                                          :error-messages="DepSelect == '' ? 'หน่วยงาน (ห้ามว่าง)' : ''"
                                          persistent-hint
                                          :error="DepSelect == ''"
                                      >

                                      </v-autocomplete>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="4"
                                    >
                                      <v-autocomplete
                                          v-model="FiscalYear"
                                          label="แผนประจำปี"
                                          :items="FiscalYearData"
                                          item-text="yearth"
                                          item-value="year"
                                          :error-messages="FiscalYear == '' ? 'แผนประจำปี (ห้ามว่าง)' : ''"
                                          persistent-hint
                                          :error="FiscalYear == ''"
                                          disabled
                                      ></v-autocomplete>
                                    </v-col>
                                    <!--                  <v-col
                                                          cols="12"
                                                          md="4"
                                                      >
                                    &lt;!&ndash;                    <v-autocomplete
                                                            v-model="FiscalYear"
                                                            label="แผนประจำปี"
                                                            :items="FiscalYearData"
                                                            item-text="yearth"
                                                            item-value="year"
                                                            :error-messages="FiscalYear == '' ? 'แผนประจำปี (ห้ามว่าง)' : ''"
                                                            persistent-hint
                                                            :error="FiscalYear == ''"
                                                        ></v-autocomplete>&ndash;&gt;
                                                        <v-text-field
                                                            v-model="FiscalYear"
                                                            label="แผนประจำปี"
                                                            readonly
                                                        ></v-text-field>
                                                      </v-col>-->
                                  </v-row>
                                </v-list-item>
                                <v-list-item class="justify-center" v-if="FiscalYear != '' && TypeProject == '2'">
                                  <span style="font-weight: bold">ประเภทการทำรายการ</span>
                                </v-list-item>
                                <v-list-item class="justify-center" v-if="FiscalYear != '' && TypeProject == '2'">
                                  <v-radio-group row
                                                 v-model="IsProcess"
                                                 :error="IsProcess == null"
                                                 :error-messages="IsProcess == null ? 'ประเภทการทำรายการ' : ''"
                                                 persistent-hint
                                                 :rules="[rules.required]"
                                                 required
                                  >
                                    <v-radio value="2" class="font-weight-bold" label="เดินทางไปราชการ (ในวิชาชีพ)"
                                             color="green"></v-radio>
                                    <v-radio value="1" class="font-weight-bold" label="เดินทางไปราชการ (นอกวิชาชีพ)"
                                             color="yellow"></v-radio>
                                    <v-radio value="3" class="font-weight-bold" label="เดินทางไปราชการ (ผู้บริหาร : รองคณบดี ผู้ช่วยคณบดี หัวหน้าสาขาวิชา)"
                                             color="red"></v-radio>
                                  </v-radio-group>
                                </v-list-item>
                                <v-list-item class="justify-center">
                                  <span style="font-weight: bold">หมวดหมู่ งาน / กิจกรรม</span>
                                </v-list-item>
                                <v-list-item class="justify-center" v-if="FiscalYear != ''">
                                  <v-radio-group row
                                                 v-model="Project_category"
                                                 :error="(Project_category == '' || Project_category == null)"
                                                 :error-messages="(Project_category == '' || Project_category == null) ? 'หมวดหมู่ งาน / กิจกรรม (ห้ามว่าง)' : ''"
                                                 persistent-hint
                                                 :rules="[rules.required]"
                                                 required
                                                 @change="ChooseCompetency"
                                  >
                                    <v-radio value="1" class="font-weight-bold" label="พัฒนาบุคลากร"></v-radio>
                                    <v-radio value="2" class="font-weight-bold" label="โครงการอื่นๆ"></v-radio>
                                    <v-radio value="3" class="font-weight-bold" label="บริการวิชาการ"></v-radio>
                                    <v-radio value="4" class="font-weight-bold" label="วิจัย"></v-radio>
                                  </v-radio-group>
                                </v-list-item>
                                <v-list-item class="justify-center">
                                  <span style="font-weight: bold">ประเภทแผน</span>
                                </v-list-item>
                                <v-list-item class="justify-center" v-if="FiscalYear != ''">
                                  <v-radio-group row
                                                 v-model="IsPlan"
                                                 :error="IsPlan == null"
                                                 :error-messages="IsPlan == null ? 'ประเภทแผน (ห้ามว่าง)' : ''"
                                                 persistent-hint
                                                 :rules="[rules.required]"
                                                 required
                                                 @change="getCourseType"
                                  >
                                    <v-radio value="1" class="font-weight-bold" label="งานในแผน"
                                             :disabled="IsPlanCordi"></v-radio>
                                    <v-radio value="0" class="font-weight-bold" label="งานนอกแผน"></v-radio>
                                  </v-radio-group>
                                </v-list-item>
                                <v-list-item class="justify-center" v-if="FiscalYear != ''">
                                  <span style="font-weight: bold">ระยะเวลาที่คาดว่าจะจัด</span>
                                </v-list-item>
                                <v-list-item class="justify-center" v-if="FiscalYear != ''">
                                  <v-radio-group row
                                                 v-model="episode"
                                                 :error="episode == null"
                                                 :error-messages="episode == null ? 'ระยะเวลาที่คาดว่าจะจัด (ห้ามว่าง)' : ''"
                                                 persistent-hint
                                                 :rules="[rules.required]"
                                                 required
                                                 @change="changeDate"
                                  >
                                    <v-radio class="font-weight-bold" value="1"
                                             :label="'ต.ค. ' + (parseInt(FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(FiscalYear) + 543 - 1)"></v-radio>
                                    <v-radio class="font-weight-bold" value="2"
                                             :label="'ม.ค. ' + (parseInt(FiscalYear) + 543)  + '- มี.ค. ' + (parseInt(FiscalYear) + 543) "></v-radio>
                                    <v-radio class="font-weight-bold" value="3"
                                             :label="'เม.ย. ' + (parseInt(FiscalYear) + 543)  + '- มิ.ย. ' + (parseInt(FiscalYear) + 543) "></v-radio>
                                    <v-radio class="font-weight-bold" value="4"
                                             :label="'ก.ค. ' + (parseInt(FiscalYear) + 543)  + '- ก.ย. ' + (parseInt(FiscalYear) + 543) "></v-radio>
                                    <v-radio class="font-weight-bold" value="9"
                                             :label="'ตลอดปีงบประมาณ ' + (parseInt(FiscalYear) + 543) "></v-radio>
                                  </v-radio-group>
                                </v-list-item>
                                <p style="color: blue;font-weight: bold" v-if="episode == '9'">
                                  ***** สามารถระบุรายละเอียดระยะเวลาที่จัดเพิ่มเติมได้ที่ช่อง รายละเอียดประกอบ
                                  (เพิ่มเติม) ได้ที่ช่องด้านล่างเพื่อเป็นข้อมูลประกอบการพิจารณา *****
                                </p>
                                <v-list-item>
                                  <v-row>
                                    <v-col
                                        cols="12"
                                    >
                                      <div class="d-inline">
                                        <v-text-field v-model="Project_code" label="รหัสแผน"
                                                      hide-details="auto" disabled></v-text-field>
                                      </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                    >
                                      <div class="d-inline">
                                        <v-text-field v-model="Project_name" label="ชื่องาน / กิจกรรม"
                                                      :rules="[rules.required]"
                                                      required
                                                      hide-details="auto"
                                                      :error-messages="Project_name == '' ? 'ชื่องาน / กิจกรรม (ห้ามว่าง)' : ''"
                                                      :error="Project_name == ''"
                                                      persistent-hint></v-text-field>
                                      </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                    >
                                      <div class="d-inline">
                                        <v-select
                                            :error="Project_group == ''"
                                            v-model="Project_group"
                                            :items="projectGroup.filter(item => item.Project_group != '101' && item.Project_group != '106' && item.Project_group != '107')"
                                            item-value="Project_group"
                                            item-text="Project_group_des"
                                            label="ประเภทแผน"
                                            :error-messages="Project_group == '' ? 'ประเภทแผน (ห้ามว่าง)' : ''"
                                            persistent-hint
                                            :rules="[rules.required]"
                                            required
                                            @change="SelProjectGroup"
                                        ></v-select>
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item>
                                  <v-row class="d-flex justify-center">
                                    <v-col
                                        cols="12"
                                    >
                                      <div class="d-inline">
                                        <!--                      <v-autocomplete
                                                                  :items="courseData"
                                                                  item-text="Course_name"
                                                                  item-value="Course_code"
                                                                  v-model="Course_code"
                                                                  label="หลักสูตร"
                                                                  @change="getCourseType"
                                                                  :error-messages="((Project_group == '101' || Project_group == '102' || Project_group == '103' || Project_group == '104') && Course_code == '0000000') ? 'หลักสูตร (ห้ามว่าง)' : ''"
                                                                  :error="((Project_group == '101' || Project_group == '102' || Project_group == '103' || Project_group == '104') && Course_code == '0000000')"
                                                                  persistent-hint
                                                                  clearable
                                                              ></v-autocomplete>-->
                                        <v-autocomplete
                                            :items="courseData"
                                            item-text="Course_name"
                                            item-value="Course_code"
                                            v-model="Course_code"
                                            label="หลักสูตร"
                                            @change="getCourseType"
                                            persistent-hint
                                            clearable
                                        ></v-autocomplete>
                                      </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6"
                                    >
                                      <div class="d-inline">
                                        <v-text-field
                                            v-model="course_group"
                                            label="สาขาประเภทหลักสูตร"
                                            required
                                            disabled
                                        ></v-text-field>
                                      </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6"
                                    >
                                      <div class="d-inline">
                                        <v-autocomplete
                                            readonly
                                            :items="period"
                                            item-text="name"
                                            item-value="id"
                                            v-model="Period_code"
                                            label="ระยะเวลา"
                                            required
                                        ></v-autocomplete>
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item>
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6"
                                    >
                                      <div class="d-inline">
                                        <v-text-field type="number"
                                                      :error="CalHourse == ''"
                                                      v-model="CalHourse"
                                                      label="จำนวน ช.ม"
                                                      hide-details="auto"
                                                      :rules="[rules.required]"
                                                      required
                                                      :error-messages="CalHourse == '' ? 'จำนวน ช.ม (ห้ามว่าง)' : ''"
                                                      persistent-hint></v-text-field>
                                      </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6"
                                    >
                                      <div class="d-inline">
                                        <v-text-field type="number"
                                                      :error="CalCredit == ''"
                                                      v-model="CalCredit"
                                                      label="จำนวน เครดิต"
                                                      hide-details="auto"
                                                      :error-messages="CalCredit == '' ? 'จำนวน เครดิต (ห้ามว่าง) **ไม่มีใส่0' : ''"
                                                      persistent-hint></v-text-field>
                                      </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6"
                                    >
                                      <div class="d-inline">
                                        <v-select
                                            :items="PLACESelete"
                                            item-value="id"
                                            item-text="detail"
                                            :error="PLACE == ''"
                                            v-model="PLACE"
                                            label="งาน / กิจกรรม ถูกจัดขึ้น"
                                            :error-messages="PLACE == '' ? 'งาน / กิจกรรม ถูกจัดขึ้น (ห้ามว่าง)' : ''"
                                            persistent-hint
                                            required
                                            :rules="[rules.required]"
                                            @change="CheckPlace"
                                        >
                                        </v-select>
                                      </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6"
                                    >
                                      <div class="d-inline" v-if="PLACE == '2'">
                                        <v-autocomplete
                                            :error="Province_id == ''"
                                            v-model="Province_id"
                                            :items="provinces_Data"
                                            item-text="name_th"
                                            item-value="code"
                                            label="จังหวัด"
                                            :error-messages="Province_id == '' ? 'จังหวัด (ห้ามว่าง)' : ''"
                                            persistent-hint
                                            required
                                            :rules="[rules.required]"></v-autocomplete>
                                      </div>
                                      <div class="d-inline" v-if="PLACE == '3'">
                                        <v-autocomplete
                                            :error="Country_id == ''"
                                            v-model="Country_id"
                                            :items="countryData"
                                            item-text="ct_nameTHA"
                                            item-value="ct_code"
                                            label="ประเทศ"
                                            :error-messages="Country_id == '' ? 'ประเทศ (ห้ามว่าง)' : ''"
                                            persistent-hint
                                            required
                                            :rules="[rules.required]"></v-autocomplete>
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item>
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6"
                                    >
                                      <div class="d-inline">
                                        <v-text-field type="number"
                                                      :error="BudgetRequest == ''"
                                                      v-model="BudgetRequest"
                                                      label="งบประมาณที่ขอ"
                                                      hide-details="auto"
                                                      :rules="[rules.required]"
                                                      required
                                                      :error-messages="BudgetRequest == '' ? 'งบประมาณที่ขอ (ห้ามว่าง) **ไม่มีใส่0' : ''"
                                                      persistent-hint></v-text-field>
                                      </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6"
                                    >
                                      <div class="d-inline">
                                        <v-select
                                            :error="WorkBy == ''"
                                            v-model="WorkBy"
                                            label="จัดโดย"
                                            :items="WorkByData"
                                            item-value="id"
                                            item-text="detail"
                                            :error-messages="WorkBy == '' ? 'จัดโดย (ห้ามว่าง)' : ''"
                                            persistent-hint
                                            required
                                            :rules="[rules.required]"></v-select>
                                      </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6"
                                    >
                                      <div class="d-inline">
                                        <v-text-field
                                            :error="WorkByName == ''"
                                            v-model="WorkByName"
                                            label="ชื่อผู้จัด"
                                            hide-details="auto"
                                            :error-messages="WorkByName == '' ? 'ชื่อผู้จัด (ห้ามว่าง)' : ''"
                                            persistent-hint
                                            required
                                            :rules="[rules.required]"></v-text-field>
                                      </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="6"
                                    >
                                      <div class="d-inline">
                                        <v-text-field
                                            :error="WorkByPhone == ''"
                                            v-model="WorkByPhone"
                                            label="เบอร์โทรติดต่อผู้กรอกข้อมูล"
                                            hide-details="auto"
                                            :error-messages="WorkByPhone == '' ? 'เบอร์โทรติดต่อผู้กรอกข้อมูล (ห้ามว่าง)' : ''"
                                            persistent-hint
                                            required
                                            :rules="[rules.required]"></v-text-field>
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item>
                                  <v-row>
                                    <v-col
                                        cols="12"
                                        md="6"
                                    >
                                      <div class="d-inline">
                                        <v-text-field
                                            v-model="Location"
                                            label="สถานที่จัด"
                                            hide-details="auto"
                                            persistent-hint
                                        ></v-text-field>
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item>
                                  <v-row>
                                    <v-col
                                        cols="12"
                                    >
                                      <div class="d-inline">
                                        <v-textarea
                                            v-model="TargetGroup"
                                            outlined
                                            name=""
                                            label="กลุ่มเป้าหมาย"
                                            value=""
                                            persistent-hint
                                            :error="TargetGroup == '' || TargetGroup == null"
                                            :error-messages="(TargetGroup == '' || TargetGroup == null) ? 'กลุ่มเป้าหมาย (ห้ามว่าง)' : ''"
                                            required
                                        ></v-textarea>
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item>
                                  <v-row>
                                    <v-col
                                        cols="12"
                                    >
                                      <div class="d-inline">
                                        <v-textarea
                                            v-model="Objective"
                                            outlined
                                            name=""
                                            label="วัตถุประสงค์"
                                            value=""
                                            persistent-hint
                                            :error="Objective == '' || Objective == null"
                                            :error-messages="(Objective == '' || Objective == null) ? 'วัตถุประสงค์ (ห้ามว่าง)' : ''"
                                            required
                                        ></v-textarea>
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item>
                                  <v-row>
                                    <v-col
                                        cols="12"
                                    >
                                      <div class="d-inline">
                                        <v-textarea
                                            v-model="Remarks"
                                            outlined
                                            name=""
                                            label="รายละเอียดประกอบ (เพิ่มเติม ถ้ามี)"
                                            value=""
                                            persistent-hint
                                        ></v-textarea>
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-list-item>
                                <v-list-item>
                                  <v-file-input
                                      v-model="files"
                                      color="deep-purple accent-4"
                                      counter
                                      label="แนบไฟล์เอกสารประกอบ"
                                      multiple
                                      placeholder="เลือกไฟล์"
                                      prepend-icon="mdi-paperclip"
                                      outlined
                                      :show-size="1000"
                                      @change="FileDocSelect"
                                  >
                                    <template v-slot:selection="{ index, text }">
                                      <v-chip
                                          v-if="index < 5"
                                          color="deep-purple accent-4"
                                          dark
                                          label
                                          small
                                      >
                                        {{ text }}
                                      </v-chip>

                                      <span
                                          v-else-if="index === 5"
                                          class="overline grey--text text--darken-3 mx-2"
                                      >
                                  +{{ files.length - 2 }} File(s)
                                </span>
                                    </template>
                                  </v-file-input>
                                </v-list-item>
                                <v-list-item>
                                  <v-alert
                                      v-if="alert"
                                      prominent
                                      type="error"
                                  >
                                    <v-row align="center" v-for="item in txtAlert" :key="item.id">
                                      <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                                    </v-row>
                                  </v-alert>
                                </v-list-item>
                                <v-list-item v-if="FileProject.length > 0">
                                  <template>
                                    <v-row>
                                      <v-col cols="12">
                                        <v-card>
                                          <v-card-title>
                                            ไฟล์เอกสารประกอบ
                                          </v-card-title>
                                          <v-container fluid>
                                            <v-row>
                                              <v-col
                                                  v-for="(file_i, index) in FileProject"
                                                  :key="index"
                                                  class="d-flex child-flex"
                                                  cols="12"
                                                  md="4"
                                              >
                                                <v-card flat tile>
                                                  <v-img
                                                      v-if="file_i.type == 'image'"
                                                      :src="file_i.src"
                                                      :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                      aspect-ratio="1"
                                                      class="grey lighten-2"
                                                  >
                                                    <template
                                                        v-slot:placeholder>
                                                      <v-row
                                                          class="fill-height ma-0"
                                                          align="center"
                                                          justify="center"
                                                      >
                                                        <v-progress-circular
                                                            indeterminate
                                                            color="grey lighten-5"></v-progress-circular>
                                                      </v-row>
                                                    </template>
                                                  </v-img>
                                                  <v-img
                                                      v-if="file_i.type == 'pdf'"
                                                      src="../assets/Image/pdf.png"
                                                      :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                                      aspect-ratio="1"
                                                      class="grey lighten-2"
                                                  >
                                                    <template
                                                        v-slot:placeholder>
                                                      <v-row
                                                          class="fill-height ma-0"
                                                          align="center"
                                                          justify="center"
                                                      >
                                                        <v-progress-circular
                                                            indeterminate
                                                            color="grey lighten-5"></v-progress-circular>
                                                      </v-row>
                                                    </template>
                                                  </v-img>
                                                  <v-card-text>
                                                                                                  <span
                                                                                                      style="font-weight: bold;color: black">
                                                                                                      {{ file_i.name }}
                                                                                                  </span>
                                                  </v-card-text>
                                                  <v-card-actions>
                                                    <v-btn text
                                                           @click="ShowData(file_i.src)">
                                                                                                      <span
                                                                                                          style="color: indigo;font-weight: bold">
                                                                                                          เรียกดู
                                                                                                      </span>
                                                    </v-btn>
                                                    <v-btn text
                                                           @click="DeleteDocFile(file_i)">
                                                                                                       <span
                                                                                                           style="color: red;font-weight: bold">
                                                                                                          ลบ
                                                                                                      </span>
                                                    </v-btn>
                                                  </v-card-actions>
                                                </v-card>
                                              </v-col>
                                            </v-row>
                                          </v-container>
                                        </v-card>
                                      </v-col>
                                    </v-row>
                                  </template>
                                </v-list-item>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col
                              cols="12"
                              md="6">
                            <v-card>
                              <v-card-subtitle>
                                <span style="font-size: 20px;color: black;font-weight: bold">Strategic Objective( วัตถุประสงค์เชิงกลยุทธ์ )</span>
                              </v-card-subtitle>
                              <v-card-text>
                                <v-list>
                                  <v-list-item three-line>
                                    <v-list-item-content>
                                      <v-list-item-title class="headline mb-1">
                                        <span>สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์</span>
                                      </v-list-item-title>
                                      <v-list-item>
                                        <v-row class="d-flex justify-center">
                                          <v-col
                                              cols="12"
                                              md="12"
                                          >
                                            <v-row class="d-flex justify-center">
                                              <v-col
                                                  cols="12"
                                                  md="12">
                                                <v-responsive>
                                                  <v-spacer></v-spacer>
                                                  <v-text-field label="ค้นหา สมรรถนะ/ค่านิยม/วัตถุประสงค์เชิงกลยุทธ์"
                                                                v-model="searchCompe"></v-text-field>
                                                </v-responsive>
                                                <v-responsive>
                                                  <v-treeview v-model="selection" selectable
                                                              :activatable="true"
                                                              :items="CompetencyData"
                                                              :search="searchCompe"
                                                              @input="ChooseCompetency"
                                                  >
                                                    <template v-slot:prepend="{ item, open }">
                                                      <v-icon v-if="!item.file"
                                                              color="blue lighten-2">
                                                        {{
                                                          open ? 'mdi-folder-open' :
                                                              'mdi-folder'
                                                        }}
                                                      </v-icon>
                                                      <v-icon v-else>
                                                        {{ files[item.file] }}
                                                      </v-icon>
                                                    </template>
                                                    <template v-slot:label="{ item, active }">
                                                      <div v-if="isMobile" style="cursor: pointer"
                                                           @click="ShowDialogCompetency(item)">
               <span
                   :style="item.checkCordi ? {color:'red', fontWeight: 'bold', fontSize: '12px'} : {color:'black', fontSize: '12px'}"
                   v-if="!active">
                                                    {{ item.name }}
                                                </span>
                                                      </div>
                                                      <div v-else style="cursor: pointer"
                                                           @click="ShowDialogCompetency(item)">
                                                <span
                                                    :style="item.checkCordi ? {color:'red', fontWeight: 'bold'} : {color:'black'}"
                                                    v-if="!active">
                                                    {{ item.name }}
                                                </span>
                                                        <!--                                                <span style="color: #364eff;font-weight: bold"-->
                                                        <!--                                                      v-else>-->
                                                        <!--                                                    {{ item.name }}-->
                                                        <!--                                                </span>-->
                                                      </div>
                                                    </template>
                                                  </v-treeview>
                                                </v-responsive>
                                              </v-col>
                                            </v-row>
                                          </v-col>
                                        </v-row>
                                      </v-list-item>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="d-flex justify-center"
                                 v-if="Project.IsPlanStatus != '8' && Project.IsPlanStatus != '9'">
                      <v-row class="d-flex justify-center">
                        <v-col
                            class="d-flex justify-center"
                            cols="12"
                            md="6">
                          <v-btn
                              color="#8E24AA"
                              class="darken-3 pa-10"
                              @click="UpdateProject()"
                              :disabled="btnDisable"
                              dark
                          >
                            <span style="font-weight: bold;font-size: 20px">แก้ไขข้อมูล</span>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <!--                      <v-col
                                                class="d-flex justify-center"
                                                cols="12"
                                                md="6">
                                              <v-btn
                                                  color="#3E2723"
                                                  class="darken-3 pa-10"
                                                  @click="CancelProject()"
                                                  :disabled="btnDisable"
                                                  dark
                                              >
                                                <span style="font-weight: bold;font-size: 20px">ยกเลิก</span>
                                              </v-btn>
                                            </v-col>-->
                    </v-list-item>
                  </template>
                  <template v-else>
                    <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                      คุณไม่ได้รับสิทธิ์ในการแก้ไขข้อมูลแผน!!</p>
                  </template>
                </template>
                <template v-else>
                  <template v-if="TempProject.length > 0">
                    <v-timeline
                        dense
                    >
                      <v-timeline-item
                          v-for="(TempProject, i) in TempProject.filter(item => item.Project_code == Project.Project_code)"
                          :key="i"
                          color="cyan"
                          small
                      >
                        <template v-slot:opposite>
    <span
        class="headline font-weight-bold cyan--text"
    >{{ TempProject.Create_Time | dateToThai2 }}</span>
                        </template>
                        <div class="py-4">
                          <h2 :class="`headline font-weight-light mb-4 cyan--text`">
                            {{ TempProject.Create_Time | dateToThai2 }}
                          </h2>
                          <v-chip
                              v-if="TempStatusProject.filter(staItem => staItem.id == TempProject.Req_status).length > 0"
                              :color="TempStatusProject.filter(staItem => staItem.id == TempProject.Req_status).length > 0 ? TempStatusProject.filter(staItem => staItem.id == TempProject.Req_status)[0].color : ''"
                              style="transform: scale(0.8);color: white"
                          >
                            <span
                                style="color: white">{{
                                TempStatusProject.filter(staItem => staItem.id == TempProject.Req_status).length > 0 ? TempStatusProject.filter(staItem => staItem.id == TempProject.Req_status)[0].status : ''
                              }}</span>
                          </v-chip>
                          <v-row>
                            <v-col
                                cols="12"
                                md="6">
                              <p class="font-weight-bold">หน่วยงาน:
                                {{
                                  depart.filter(item => item.dep_id == TempProject.Dep_Code).length > 0 ? depart.filter(item => item.dep_id == TempProject.Dep_Code)[0].dep_name : '-'
                                }}</p>
                              <p class="font-weight-bold">แผนประจำปี: {{ parseInt(TempProject.FiscalYear) + 543 }}</p>
                              <p class="font-weight-bold">หมวดหมู่ งาน / กิจกรรม:
                                {{
                                  TempProject.Project_category == '1' ? 'พัฒนาบุคลากร' : TempProject.Project_category == '2' ? 'โครงการอื่นๆ' : TempProject.Project_category == '3' ? 'บริการวิชาการ' : 'วิจัย'
                                }}</p>
                              <p class="font-weight-bold">ประเภทแผน: {{
                                  TempProject.IsPlan == '1' ? 'ในแผน' : 'นอกแผน'
                                }}</p>
                              <p class="font-weight-bold" v-if="episode == '1'">ระยะเวลาที่คาดว่าจะจัด:
                                {{
                                  'ต.ค. ' + (parseInt(FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(FiscalYear) + 543 - 1)
                                }}</p>
                              <p class="font-weight-bold" v-else-if="episode == '2'">ระยะเวลาที่คาดว่าจะจัด:
                                {{
                                  'ม.ค. ' + (parseInt(FiscalYear) + 543) + '- มี.ค. ' + (parseInt(FiscalYear) + 543)
                                }}</p>
                              <p class="font-weight-bold" v-else-if="episode == '3'">ระยะเวลาที่คาดว่าจะจัด:
                                {{
                                  'เม.ย. ' + (parseInt(FiscalYear) + 543) + '- มิ.ย. ' + (parseInt(FiscalYear) + 543)
                                }}</p>
                              <p class="font-weight-bold" v-else-if="episode == '4'">ระยะเวลาที่คาดว่าจะจัด:
                                {{
                                  'ก.ค. ' + (parseInt(FiscalYear) + 543) + '- ก.ย. ' + (parseInt(FiscalYear) + 543)
                                }}</p>
                              <p class="font-weight-bold" v-else-if="episode == '9'">ระยะเวลาที่คาดว่าจะจัด:
                                {{
                                  'ตลอดปีงบประมาณ ' + (parseInt(FiscalYear) + 543)
                                }}</p>
                              <p class="font-weight-bold">รหัสแผน: {{ TempProject.Project_code }}</p>
                              <p class="font-weight-bold">ชื่องาน / กิจกรรม: {{ TempProject.Project_name }}</p>
                              <p class="font-weight-bold">ประเภทแผน: {{
                                  projectGroup.filter(item => item.Project_group == TempProject.Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == TempProject.Project_group)[0].Project_group_des : '-'
                                }}</p>
                              <p class="font-weight-bold">หลักสูตร:
                                {{
                                  courseData.filter(item => item.Course_code == TempProject.Course_code).length > 0 ? courseData.filter(item => item.Course_code == TempProject.Course_code)[0].Course_name : '-'
                                }}</p>
                              <p class="font-weight-bold">สาขาประเภทหลักสูตร:
                                {{
                                  courseData.filter(item => item.Course_code == TempProject.Course_code).length > 0 ? courseData.filter(item => item.Course_code == TempProject.Course_code)[0].Course_type_des : '-'
                                }}</p>
                              <p class="font-weight-bold">ระยะเวลา:
                                {{
                                  courseData.filter(item => item.Course_code == TempProject.Course_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == TempProject.Course_code)[0].Period_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == TempProject.Course_code)[0].Period_code)[0].name : '-' : '-'
                                }}</p>
                            </v-col>
                            <v-col
                                cols="12"
                                md="6">
                              <p class="font-weight-bold">จำนวน ช.ม.: {{ TempProject.CalHourse }}</p>
                              <p class="font-weight-bold">จำนวน เครดิต: {{ TempProject.CalCredit }}</p>
                              <p class="font-weight-bold">งบประมาณที่ขอ: {{ TempProject.BudgetRequest }}</p>
                              <p class="font-weight-bold">งาน / กิจกรรม ถูกจัดขึ้น: {{
                                  PLACESelete.filter(item => item.id == TempProject.PLACE).length > 0 ? PLACESelete.filter(item => item.id == TempProject.PLACE)[0].detail : '-'
                                }}</p>
                              <p class="font-weight-bold" v-if="TempProject.PLACE == '2'">จังหวัด: {{
                                  provinces_Data.filter(item => item.code == TempProject.Province_id).length > 0 ? provinces_Data.filter(item => item.code == TempProject.Province_id)[0].name_th : '-'
                                }}</p>
                              <p class="font-weight-bold" v-else-if="TempProject.PLACE == '3'">ประเทศ: {{
                                  countryData.filter(item => item.ct_code == TempProject.Country_id).length > 0 ? countryData.filter(item => item.ct_code == TempProject.Country_id)[0].ct_nameTHA : '-'
                                }}</p>
                              <p class="font-weight-bold">จัดโดย:
                                {{
                                  WorkByData.filter(item => item.id == TempProject.WorkBy).length > 0 ? WorkByData.filter(item => item.id == TempProject.WorkBy)[0].detail : '-'
                                }}</p>
                              <p class="font-weight-bold">ชื่อผู้จัด: {{ TempProject.WorkByName }}</p>
                              <p class="font-weight-bold">เบอร์โทรติดต่อผู้กรอกข้อมูล: {{
                                  TempProject.WorkByPhone
                                }}</p>
                              <p class="font-weight-bold">สถานที่จัด: {{ TempProject.Location }}</p>
                              <p class="font-weight-bold">กลุ่มเป้าหมาย: {{ TempProject.TargetGroup }}</p>
                              <p class="font-weight-bold">วัตถุประสงค์: {{ TempProject.Objective }}</p>
                              <p class="font-weight-bold">รายละเอียดประกอบ (เพิ่มเติม): {{ TempProject.Remarks }}</p>
                              <p class="font-weight-bold">Competency,Core Value,Strategic Objective:
                                <v-btn text color="primary" @click="showTempCompetency(TempProject)">คลิก!!</v-btn>
                              </p>
                              <p class="font-weight-bold">ไฟล์เอกสารประกอบ:
                                <v-btn text color="primary" @click="showTempFile(TempProject)">คลิก!!</v-btn>
                              </p>
                              <p class="font-weight-bold">แก้ไขโดย: {{
                                  staffData.filter(item => item.perid == TempProject.Create_By).length > 0 ? staffData.filter(item => item.perid == TempProject.Create_By)[0].full_Name + '(' + staffData.filter(item => item.perid == TempProject.Create_By)[0].perid + ') ' + staffData.filter(item => item.perid == TempProject.Create_By)[0].dep_name : '-'
                                }}</p>
                            </v-col>
                          </v-row>
                          <v-divider></v-divider>
                        </div>
                      </v-timeline-item>
                    </v-timeline>
                  </template>
                  <template v-else>
                    <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                      ไม่พบข้อมูลประวัติการขอนุมัติแก้ไขข้อมูลแผน</p>
                  </template>
                </template>
              </v-tab-item>
              <v-tab-item
                  key="tab3"
              >
                <template v-if="LogProject.length > 0">
                  <v-timeline
                      dense
                  >
                    <v-timeline-item
                        v-for="(logProject, i) in LogProject"
                        :key="i"
                        color="cyan"
                        small
                    >
                      <template v-slot:opposite>
        <span
            class="headline font-weight-bold cyan--text"
        >{{ logProject.Create_Time | dateToThai2 }}</span>
                      </template>
                      <div class="py-4">
                        <h2 :class="`headline font-weight-light mb-4 cyan--text`">
                          {{ logProject.Create_Time | dateToThai2 }}
                        </h2>

                        <v-chip
                            v-if="StatusProject.filter(staItem => staItem.id == logProject.IsPlanStatus).length > 0"
                            :color="StatusProject.filter(staItem => staItem.id == logProject.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == logProject.IsPlanStatus)[0].color : ''"
                            style="transform: scale(0.8);color: white"
                        >
                            <span
                                style="color: white">{{
                                StatusProject.filter(staItem => staItem.id == logProject.IsPlanStatus).length > 0 ? StatusProject.filter(staItem => staItem.id == logProject.IsPlanStatus)[0].status : ''
                              }}</span>
                        </v-chip>
                        <v-row>
                          <v-col
                              cols="12"
                              md="6">
                            <p class="font-weight-bold">หน่วยงาน:
                              {{
                                depart.filter(item => item.dep_id == logProject.Dep_Code).length > 0 ? depart.filter(item => item.dep_id == logProject.Dep_Code)[0].dep_name : '-'
                              }}</p>
                            <p class="font-weight-bold">แผนประจำปี: {{ parseInt(logProject.FiscalYear) + 543 }}</p>
                            <p class="font-weight-bold">หมวดหมู่ งาน / กิจกรรม:
                              {{
                                logProject.Project_category == '1' ? 'พัฒนาบุคลากร' : logProject.Project_category == '2' ? 'หมวดหมู่ งาน / กิจกรรม' : logProject.Project_category == '3' ? 'บริการวิชาการ' : 'วิจัย'
                              }}</p>
                            <p class="font-weight-bold">ประเภทแผน: {{
                                logProject.IsPlan == '1' ? 'ในแผน' : 'นอกแผน'
                              }}</p>
                            <p class="font-weight-bold" v-if="episode == '1'">ระยะเวลาที่คาดว่าจะจัด:
                              {{
                                'ต.ค. ' + (parseInt(FiscalYear) + 543 - 1) + '- ธ.ค. ' + (parseInt(FiscalYear) + 543 - 1)
                              }}</p>
                            <p class="font-weight-bold" v-else-if="episode == '2'">ระยะเวลาที่คาดว่าจะจัด:
                              {{
                                'ม.ค. ' + (parseInt(FiscalYear) + 543) + '- มี.ค. ' + (parseInt(FiscalYear) + 543)
                              }}</p>
                            <p class="font-weight-bold" v-else-if="episode == '3'">ระยะเวลาที่คาดว่าจะจัด:
                              {{
                                'เม.ย. ' + (parseInt(FiscalYear) + 543) + '- มิ.ย. ' + (parseInt(FiscalYear) + 543)
                              }}</p>
                            <p class="font-weight-bold" v-else-if="episode == '4'">ระยะเวลาที่คาดว่าจะจัด:
                              {{
                                'ก.ค. ' + (parseInt(FiscalYear) + 543) + '- ก.ย. ' + (parseInt(FiscalYear) + 543)
                              }}</p>
                            <p class="font-weight-bold" v-else-if="episode == '9'">ระยะเวลาที่คาดว่าจะจัด:
                              {{
                                'ตลอดปีงบประมาณ ' + (parseInt(FiscalYear) + 543)
                              }}</p>
                            <p class="font-weight-bold">รหัสแผน: {{ logProject.Project_code }}</p>
                            <p class="font-weight-bold">ชื่องาน / กิจกรรม: {{ logProject.Project_name }}</p>
                            <p class="font-weight-bold">ประเภทแผน:
                              {{
                                projectGroup.filter(item => item.Project_group == logProject.Project_group).length > 0 ? projectGroup.filter(item => item.Project_group == logProject.Project_group)[0].Project_group_des : '-'
                              }}
                            </p>
                            <p class="font-weight-bold">หลักสูตร:
                              {{
                                courseData.filter(item => item.Course_code == logProject.Course_code).length > 0 ? courseData.filter(item => item.Course_code == logProject.Course_code)[0].Course_name : '-'
                              }}</p>
                            <p class="font-weight-bold">สาขาประเภทหลักสูตร:
                              {{
                                courseData.filter(item => item.Course_code == logProject.Course_code).length > 0 ? courseData.filter(item => item.Course_code == logProject.Course_code)[0].Course_type_des : '-'
                              }}</p>
                            <p class="font-weight-bold">ระยะเวลา:
                              {{
                                courseData.filter(item => item.Course_code == logProject.Course_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == logProject.Course_code)[0].Period_code).length > 0 ? period.filter(perios_item => perios_item.id == courseData.filter(item => item.Course_code == logProject.Course_code)[0].Period_code)[0].name : '-' : '-'
                              }}</p>
                          </v-col>
                          <v-col
                              cols="12"
                              md="6">
                            <p class="font-weight-bold">จำนวน ช.ม.: {{ logProject.CalHourse }}</p>
                            <p class="font-weight-bold">จำนวน เครดิต: {{ logProject.CalCredit }}</p>
                            <p class="font-weight-bold">งบประมาณที่ขอ: {{ logProject.BudgetRequest }}</p>
                            <p class="font-weight-bold">งาน / กิจกรรม ถูกจัดขึ้น: {{
                                PLACESelete.filter(item => item.id == logProject.PLACE).length > 0 ? PLACESelete.filter(item => item.id == logProject.PLACE)[0].detail : '-'
                              }}</p>
                            <p class="font-weight-bold" v-if="logProject.PLACE == '2'">จังหวัด: {{
                                provinces_Data.filter(item => item.code == logProject.Province_id).length > 0 ? provinces_Data.filter(item => item.code == logProject.Province_id)[0].name_th : '-'
                              }}</p>
                            <p class="font-weight-bold" v-else-if="logProject.PLACE == '3'">ประเทศ: {{
                                countryData.filter(item => item.ct_code == logProject.Country_id).length > 0 ? countryData.filter(item => item.ct_code == logProject.Country_id)[0].ct_nameTHA : '-'
                              }}</p>
                            <p class="font-weight-bold">จัดโดย:
                              {{
                                WorkByData.filter(item => item.id == logProject.WorkBy).length > 0 ? WorkByData.filter(item => item.id == logProject.WorkBy)[0].detail : '-'
                              }}</p>
                            <p class="font-weight-bold">ชื่อผู้จัด: {{ logProject.WorkByName }}</p>
                            <p class="font-weight-bold">เบอร์โทรติดต่อผู้กรอกข้อมูล: {{ logProject.WorkByPhone }}</p>
                            <p class="font-weight-bold">สถานที่จัด: {{ logProject.Location }}</p>
                            <p class="font-weight-bold">กลุ่มเป้าหมาย: {{ logProject.TargetGroup }}</p>
                            <p class="font-weight-bold">วัตถุประสงค์: {{ logProject.Objective }}</p>
                            <p class="font-weight-bold">รายละเอียดประกอบ (เพิ่มเติม): {{ logProject.Remarks }}</p>
                            <p class="font-weight-bold">Competency,Core Value,Strategic Objective:
                              <v-btn text color="primary" @click="showLogCompetency(logProject)">คลิก!!</v-btn>
                            </p>
                            <p class="font-weight-bold">ไฟล์เอกสารประกอบ:
                              <v-btn text color="primary" @click="showLogFile(logProject)">คลิก!!</v-btn>
                            </p>
                            <p class="font-weight-bold">แก้ไขโดย: {{
                                staffData.filter(item => item.perid == logProject.Create_By).length > 0 ? staffData.filter(item => item.perid == logProject.Create_By)[0].full_Name + '(' + staffData.filter(item => item.perid == logProject.Create_By)[0].perid + ') ' + staffData.filter(item => item.perid == logProject.Create_By)[0].dep_name : '-'
                              }} {{ logProject.Edit_type == '0' ? '(user)' : '(Admin)' }}</p>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                      </div>
                    </v-timeline-item>
                  </v-timeline>
                </template>
                <template v-else>
                  <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                    ไม่พบข้อมูลประวัติการแก้ไขข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี</p>
                </template>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-container>
      </v-card>
      <template>
        <v-dialog v-model="dialogProposal" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">ยืนยันการทำรายการ</v-card-title>
            <v-card-text>ต้องการยื่นเสนอแผนใช่หรือไม่ ?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="dialogProposal = false">ยกเลิก</v-btn>
              <v-btn color="green darken-1" text @click="proposal_To_Db">ตกลง</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogDetail"
            max-width="800"
        >
          <v-card v-if="itemToShow != null">
            <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">{{
                itemToShow.DelvDes
              }}</span>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col
                    cols="12"
                    md="12">
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">ชื่อย่อ:</span> {{ itemToShow.DelvShort }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">ชื่อ Eng:</span> {{ itemToShow.DelvEng }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">คำอธิบาย:</span> {{ itemToShow.DelvRm }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">PSU:</span> {{ itemToShow.PSU }}
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black" v-if="itemToShow.DelvGroup == 'A'">
                    <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะหลัก
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'B'">
                    <span style="color: #364eff">กรุ๊ป:</span> สมรรถนะด้านบริหาร
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'C'">
                    <span style="color: #364eff">กรุ๊ป:</span> จิตสํานึกด้านความเสียงและความปลอดภัย
                  </p>
                  <p style="font-weight: bold;color: black" v-else-if="itemToShow.DelvGroup == 'D'">
                    <span style="color: #364eff">กรุ๊ป:</span> กลยุทธ์
                  </p>
                  <v-divider></v-divider>
                  <p style="font-weight: bold;color: black">
                    <span style="color: #364eff">คณะ/หน่วยงาน:</span> {{ itemToShow.dep_name }}
                  </p>
                  <v-divider></v-divider>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialogDetail = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogTemplate"
            max-width="800"
        >
          <v-card>
            <v-card-title>ฟอร์ฺมตัวอย่าง</v-card-title>
            <v-card-text>
              <div v-html="editorData"></div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="green darken-1"
                  text
                  @click="dialogTemplate = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogLecturerDetail"
            max-width="800"
        >
          <v-card>
            <v-card-title class="headline"><span style="color: #42b983;font-weight: bold">รายละเอียดการเป็นวิทยากร/คณะกรรมการ/นำเสนอผลงาน</span>
            </v-card-title>
            <v-card-text>
              <v-data-table :items="LecturerDetail" :headers="headerLecturer" class="elevation-2"
                            show-expand
                            style="width: 100%">
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length">
                    <div v-for="(file, idx) in item.files" v-bind:key="idx">
                      <v-btn color="primary" text @click="ShowData(Openfile + file.File_path)">ไฟล์ : {{
                          file.File_name
                        }}
                      </v-btn>
                    </div>
                  </td>
                </template>
                <template v-slot:item.date_start="{item}">
                  <span>
                    {{ item.date_start | DateToThai }}
                  </span>
                </template>
                <template v-slot:item.date_end="{item}">
                  <span>
                    {{ item.date_end | DateToThai }}
                  </span>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  text
                  @click="dialogLecturerDetail = false"
              >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <v-dialog
          v-model="dialogLoading"
          persistent
          width="300"
      >
        <v-card
            color="primary"
            dark
        >
          <v-card-text>
            Loading...
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <template>
        <v-snackbar
            v-model="snack"
            :timeout="3000"
            :color="snackColor"
        >
          {{ snackText }}

          <template v-slot:action="{ attrs }">
            <v-btn
                v-bind="attrs"
                text
                @click="snack = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </template>
      <template>
        <v-dialog
            v-model="dialogCompetency"
            max-width="800"
        >
          <v-card>
            <v-card-title>
              Competency,Core Value,Strategic Objective
            </v-card-title>
            <v-card-text>
              <template v-if="CompetencyToShow.length > 0">
                <v-treeview :activatable="true" :items="CompetencyToShow">
                  <template v-slot:prepend="{ item, open }">
                    <v-icon v-if="!item.file" color="blue lighten-2">
                      {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                    </v-icon>
                    <v-icon v-else>
                      {{ files[item.file] }}
                    </v-icon>
                  </template>
                  <template v-slot:label="{ item, active }">
                    <div v-if="isMobile" style="cursor: pointer">
                                                <span style="font-size: 12px;color: black" v-if="!active">
                                                    {{ item.name }}
                                                </span>
                      <span style="font-size: 12px;color: #364eff;font-weight: bold"
                            v-else>
                                                    {{ item.name }}
                                                </span>
                    </div>
                    <div v-else style="cursor: pointer">
                                                <span style="color:black;" v-if="!active">
                                                    {{ item.name }}
                                                </span>
                      <span style="color: #364eff;font-weight: bold" v-else>
                                                    {{ item.name }}
                                                </span>
                    </div>
                  </template>
                </v-treeview>
              </template>
              <template v-else>
                <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">ไม่พบข้อมูล
                  Competency,Core Value,Strategic Objective</p>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  outlined
                  @click="dialogCompetency = false"
              >
                <span style="font-size: 24px;font-weight: bold">ปิด</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogFile"
            max-width="800"
        >
          <v-card>
            <v-card-title>
              ไฟล์เอกสารประกอบ
            </v-card-title>
            <v-card-text>
              <template v-if="FileProject.length > 0">
                <v-container fluid>
                  <v-row>
                    <v-col
                        v-for="(file_i, index) in FileProject"
                        :key="index"
                        class="d-flex child-flex"
                        cols="12"
                        md="4"
                    >
                      <v-card flat tile>
                        <v-img
                            v-if="file_i.type == 'image'"
                            :src="file_i.src"
                            :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                            aspect-ratio="1"
                            class="grey lighten-2"
                        >
                          <template
                              v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                              <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-img
                            v-if="file_i.type == 'pdf'"
                            src="../assets/Image/pdf.png"
                            :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                            aspect-ratio="1"
                            class="grey lighten-2"
                        >
                          <template
                              v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                              <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-card-text>
                                                                                                  <span
                                                                                                      style="font-weight: bold;color: black">
                                                                                                      {{ file_i.name }}
                                                                                                  </span>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn text
                                 @click="ShowData(file_i.src)">
                                                                                                      <span
                                                                                                          style="color: indigo;font-weight: bold">
                                                                                                          เรียกดู
                                                                                                      </span>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <template v-else>
                <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                  ไม่พบข้อมูลไฟล์เอกสารประกอบ</p>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  outlined
                  @click="dialogFile = false"
              >
                <span style="font-size: 24px;font-weight: bold">ปิด</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogFileLog"
            max-width="800"
        >
          <v-card>
            <v-card-title>
              ไฟล์เอกสารประกอบ
            </v-card-title>
            <v-card-text>
              <template v-if="LogFileProject.length > 0">
                <v-container fluid>
                  <v-row>
                    <v-col
                        v-for="(file_i, index) in LogFileProject"
                        :key="index"
                        class="d-flex child-flex"
                        cols="12"
                        md="4"
                    >
                      <v-card flat tile>
                        <v-img
                            v-if="file_i.type == 'image'"
                            :src="file_i.src"
                            :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                            aspect-ratio="1"
                            class="grey lighten-2"
                        >
                          <template
                              v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                              <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-img
                            v-if="file_i.type == 'pdf'"
                            src="../assets/Image/pdf.png"
                            :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                            aspect-ratio="1"
                            class="grey lighten-2"
                        >
                          <template
                              v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                              <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-card-text>
                                                                                                  <span
                                                                                                      style="font-weight: bold;color: black">
                                                                                                      {{ file_i.name }}
                                                                                                  </span>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn text
                                 @click="ShowData(file_i.src)">
                                                                                                      <span
                                                                                                          style="color: indigo;font-weight: bold">
                                                                                                          เรียกดู
                                                                                                      </span>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <template v-else>
                <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                  ไม่พบข้อมูลไฟล์เอกสารประกอบ</p>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  outlined
                  @click="dialogFileLog = false"
              >
                <span style="font-size: 24px;font-weight: bold">ปิด</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogMasterApprove"
            max-width="800">
          <v-card>
            <v-card-title>
              <span
                  style="font-width: bold;">กรุณาเลือกผู้อนุมัติลำดับถัดไป => {{
                  (Approve_m == '10' ? '(พิจารณาโดยผู้มีอำนาจอนุมัติ (ขั้นต้น))' : '(พิจารณาโดยผู้มีอำนาจอนุม้ติ)')
                }}</span>
            </v-card-title>
            <v-card-text>
              <template v-if="approveMasterChoose.length > 0">
                <v-checkbox
                    class="font-weight-bold"
                    v-model="sendApprovePerson"
                    v-for="(approveMs, idx) in approveMasterChoose" :key="idx"
                    :label="(idx + 1) + ') ' + approveMs.custom_Detail + ' (' + approveMs.position + ')'"
                    :value="approveMs.id"
                ></v-checkbox>
              </template>
              <template v-else>
                <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                  ไม่พบข้อมูลผู้มีอำนาจอนุมัติลำดับถัดไป</p>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="font-weight-bold" color="primary" outlined @click="SendNextApprove"
                     v-if="approveMasterChoose.length > 0">
                ส่งต่อผู้มีอำนาจอนุมัติ
              </v-btn>
              <v-btn class="font-weight-bold" color="red" outlined @click="dialogMasterApprove = false">
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogMasterApprove2"
            max-width="800">
          <v-card>
            <v-card-title>
              <span
                  style="font-width: bold;">กรุณาเลือกผู้อนุมัติ => {{
                  (ChooseSendMail == '1' ? '(ผู้ตรวจสอบข้อมูล)' : ChooseSendMail == '2' ? '(พิจารณาโดยผู้มีอำนาจอนุมัติ (ขั้นต้น))' : ChooseSendMail == '3' ? '(พิจารณาโดยผู้มีอำนาจอนุม้ติ)' : 'ผู้มีอำนาจอนุมัติสูงสุด')
                }}</span>
            </v-card-title>
            <v-card-text>
              <template v-if="approveMasterChoose.length > 0">
                <v-checkbox
                    class="font-weight-bold"
                    v-model="sendApprovePerson"
                    v-for="(approveMs, idx) in approveMasterChoose" :key="idx"
                    :label="(idx + 1) + ') ' + approveMs.custom_Detail + ' (' + approveMs.position + ')'"
                    :value="approveMs.id"
                ></v-checkbox>
              </template>
              <template v-else>
                <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                  ไม่พบข้อมูลผู้มีอำนาจอนุมัติลำดับถัดไป</p>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="font-weight-bold" color="primary" outlined @click="SendNextApprove2"
                     v-if="approveMasterChoose.length > 0">
                ส่งอีเมล
              </v-btn>
              <v-btn class="font-weight-bold" color="red" outlined @click="dialogMasterApprove2 = false">
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogSendApprove"
            max-width="800">
          <v-card>
            <v-card-title>
              <span style="font-width: bold;">ส่งต่อผู้อนุมัติ</span>
            </v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item>
                  <v-radio-group row v-model="sendApprovePerson">
                    <v-radio class="font-weight-bold" label="HR" value="1" :disabled="typePermiss == '1'"></v-radio>
                    <v-radio class="font-weight-bold" label="นโยบายและแผน" value="2"
                             :disabled="typePermiss == '2'"></v-radio>
                    <v-radio class="font-weight-bold" label="ศูนย์จัดการประชุม" value="3"
                             :disabled="typePermiss == '3'"></v-radio>
                    <v-radio class="font-weight-bold" label="วิจัย" value="4" :disabled="typePermiss == '4'"></v-radio>
                  </v-radio-group>
                </v-list-item>
                <v-list-item>
                  <v-textarea v-model="RemarkSendApprove" outlined label="เหตุผล (ถ้ามี)"
                              style="width: 100%"></v-textarea>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="font-weight-bold" color="primary" outlined @click="SendOtherApproveFunc"
                     v-if="Process == '1'">
                ส่งต่อแผน!
              </v-btn>
              <v-btn class="font-weight-bold" color="red" outlined @click="dialogSendApprove = false">
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogSendMailApproveAgain"
            max-width="800">
          <v-card>
            <v-card-title>
              <span style="font-width: bold;">เลือกระดับที่ทำรายการ</span>
            </v-card-title>
            <v-card-text>
              <v-radio-group row v-model="ChooseSendMail">
                <v-radio class="font-weight-bold" label="ผู้ตรวจสอบข้อมูล" value="1"></v-radio>
                <v-radio class="font-weight-bold" label="ผู้อนุมัติขั้นต้น" value="2"></v-radio>
                <v-radio class="font-weight-bold" label="ผู้มีอำนาจอนุมัติ" value="3"></v-radio>
                <v-radio class="font-weight-bold" label="Admin" value="9"></v-radio>
              </v-radio-group>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="font-weight-bold" color="primary" outlined @click="ChooseMasterApprove2">
                ส่งเมล!
              </v-btn>
              <v-btn class="font-weight-bold" color="red" outlined @click="dialogSendMailApproveAgain = false">
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogTempFile"
            max-width="800"
        >
          <v-card>
            <v-card-title>
              ไฟล์เอกสารประกอบ
            </v-card-title>
            <v-card-text>
              <template v-if="TempFileProject.length > 0">
                <v-container fluid>
                  <v-row>
                    <v-col
                        v-for="(file_i, index) in TempFileProject"
                        :key="index"
                        class="d-flex child-flex"
                        cols="12"
                        md="4"
                    >
                      <v-card flat tile>
                        <v-img
                            v-if="file_i.type == 'image'"
                            :src="file_i.src"
                            :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                            aspect-ratio="1"
                            class="grey lighten-2"
                        >
                          <template
                              v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                              <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-img
                            v-if="file_i.type == 'pdf'"
                            src="../assets/Image/pdf.png"
                            :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                            aspect-ratio="1"
                            class="grey lighten-2"
                        >
                          <template
                              v-slot:placeholder>
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                              <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <v-card-text>
                                                                                                  <span
                                                                                                      style="font-weight: bold;color: black">
                                                                                                      {{ file_i.name }}
                                                                                                  </span>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn text
                                 @click="ShowData(file_i.src)">
                                                                                                      <span
                                                                                                          style="color: indigo;font-weight: bold">
                                                                                                          เรียกดู
                                                                                                      </span>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <template v-else>
                <p style="font-size: 32px;font-weight: bold;text-align: center;color: #ff6d81;padding: 25px">
                  ไม่พบข้อมูลไฟล์เอกสารประกอบ</p>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="red darken-1"
                  outlined
                  @click="dialogTempFile = false"
              >
                <span style="font-size: 24px;font-weight: bold">ปิด</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            v-model="dialogExportPlanProj"
            max-width="800">
          <v-card>
            <v-card-title>
              <span
                  style="font-width: bold;">เลือกรายละเอียดข้อมูลก่อนทำรายการ Export ข้อมูลแผนประจำปี {{
                  parseInt(YearSel) + 543
                }}</span>
            </v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item>
                  <v-radio-group v-model="exportType" row>
                    <v-radio class="font-weight-bold" label="พัฒนาบุคลากร" value="1"></v-radio>
                    <v-radio class="font-weight-bold" label="โครงการอื่น ๆ" value="2"></v-radio>
                    <v-radio class="font-weight-bold" label="บริการวิชาการ" value="3"></v-radio>
                    <v-radio class="font-weight-bold" label="วิจัย" value="4"></v-radio>
                  </v-radio-group>
                </v-list-item>
                <v-list-item>
                  <v-radio-group v-model="exportType2" row>
                    <v-radio class="font-weight-bold" label="โครงการ" value="1"></v-radio>
                    <v-radio class="font-weight-bold" label="อบรม / เดินทางไปปฏิบัติราชการ" value="2"></v-radio>
                  </v-radio-group>
                </v-list-item>
                <v-list-item>
                  <v-radio-group v-model="exportType3" row>
                    <v-radio class="font-weight-bold" label="ในแผน" value="1"></v-radio>
                    <v-radio class="font-weight-bold" label="นอกแผน" value="0"></v-radio>
                  </v-radio-group>
                </v-list-item>
                <v-list-item>
                  <v-radio-group v-model="exportType4" row>
                    <v-radio class="font-weight-bold" label="ทั้งหมด" value="1"></v-radio>
                    <v-radio class="font-weight-bold" label="เฉพาะที่อนุมัติ" value="0"></v-radio>
                  </v-radio-group>
                </v-list-item>
                <v-list-item class="d-flex justify-center">
                  <download-excel
                      class="btn btn-default"
                      :data="json_data"
                      :fields="json_fields"
                      worksheet="แผนทั้งหมดภายในปี"
                      :name="'ข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี ' + (parseInt(this.YearSel) + 543) + '.xls'"
                  >
                    <v-btn class="font-weight-bold" outlined color="primary" @click="ExportData">Export ข้อมูล</v-btn>
                  </download-excel>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="font-weight-bold" text color="red" @click="dialogExportPlanProj = false">ปิด</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template>
        <v-dialog
            max-width="1200"
            persistent
            v-model="dialogJoinTravel">
          <v-card>
            <v-card-title>
              <h2 class="pb-4" style="font-weight: bold">ข้อมูลรายชื่อผู้เข้าร่วมเดินทาง</h2>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="mt-6">
              <v-list>
                <v-list-item>
                  <v-data-table
                      class="mt-6"
                      :items="JoinTravel"
                      :headers="JoinTravelHeader"
                      style="width: 100%"
                  >
                    <template v-slot:header.customTravelDetail>
                      <h3 class="font-weight-bold">ผู้เดินทาง</h3>
                    </template>
                    <template v-slot:header.position>
                      <h3 class="font-weight-bold">ตำแหน่งระดับ(วันบรรจุ)</h3>
                    </template>
                    <template v-slot:header.Allowance>
                      <h3 class="font-weight-bold">ค่าเบี้ยเลี้ยง</h3>
                    </template>
                    <template v-slot:header.AccommodationCost>
                      <h3 class="font-weight-bold">ค่าที่พัก</h3>
                    </template>
                    <template v-slot:header.ShippingCosts>
                      <h3 class="font-weight-bold">ค่าพาหนะ</h3>
                    </template>
                    <template v-slot:header.RegistrationFee>
                      <h3 class="font-weight-bold">ค่าลงทะเบียน</h3>
                    </template>
                    <template v-slot:header.AllTravelExpenses>
                      <h3 class="font-weight-bold">รวมค่าเดินทาง</h3>
                    </template>
                    <template v-slot:header.RemainingBudget>
                      <h3 class="font-weight-bold">งบวิชาการคงเหลือ</h3>
                    </template>
                    <template v-slot:item="{item}">
                      <tr>
                        <td>
                          <div v-html="item.customTravelDetail"></div>
                        </td>
                        <td>{{ item.Allowance | currency }}</td>
                        <td>{{ item.AccommodationCost | currency }}</td>
                        <td>{{ item.ShippingCosts | currency }}</td>
                        <td>{{ item.RegistrationFee | currency }}</td>
                        <td>{{ item.AllTravelExpenses | currency }}</td>
                        <td>{{ item.RemainingBudget | currency }}</td>
                      </tr>
                      <!--                  <v-btn class="font-weight-bold darken-4" style="color: darkgoldenrod" text @click="editJoinTravel(item)">แก้ไข</v-btn>
                                        <v-btn class="font-weight-bold darken-4" style="color: red" text @click="delJoinTravel(item)">ลบ</v-btn>-->
                    </template>
                    <template v-slot:footer>
                      <v-divider></v-divider>
                      <v-row class="mt-4">
                        <v-col
                            cols="6"
                            md="2">
                          <p class="font-weight-bold" style="color: blue">
                            รวมค่าเบี้ยเลี้ยง:
                            <span style="color: black">{{ SumAllowance | currency }}</span>
                          </p>
                        </v-col>
                        <v-col
                            cols="6"
                            md="2">
                          <p class="font-weight-bold" style="color: blue">
                            รวมค่าที่พัก:
                            <span style="color: black">{{ SumAccommodationCost | currency }}</span>
                          </p>
                        </v-col>
                        <v-col
                            cols="6"
                            md="2">
                          <p class="font-weight-bold" style="color: blue">
                            รวมค่าพาหนะ:
                            <span style="color: black">{{ SumShippingCosts | currency }}</span>
                          </p>
                        </v-col>
                        <v-col
                            cols="6"
                            md="2">
                          <p class="font-weight-bold" style="color: blue">
                            รวมค่าลงทะเบียน:
                            <span style="color: black">{{ SumRegistrationFee | currency }}</span>
                          </p>
                        </v-col>
                        <v-col
                            cols="6"
                            md="2">
                          <p class="font-weight-bold" style="color: blue">
                            รวมค่ารวมค่าเดินทาง:
                            <span style="color: black">{{ SumAllTravelExpenses | currency }}</span>
                          </p>
                        </v-col>
                        <!--                        <v-col
                                                    cols="6"
                                                    md="2">
                                                  <p class="font-weight-bold" style="color: blue">
                                                    รวมค่าใช้จ่ายทั้งสิ้น:
                                                    <span style="color: black">{{
                                                        (parseFloat(SumAllowance) + parseFloat(SumAccommodationCost) + parseFloat(SumShippingCosts) + parseFloat(SumRegistrationFee) + parseFloat(AllTravelExpenses))  | currency
                                                      }}</span>
                                                  </p>
                                                </v-col>-->
                      </v-row>
                    </template>
                  </v-data-table>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" text @click="dialogJoinTravel = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </template>
  </v-container>
</template>

<script>
import Const from "../const/Const";

const queryString = require('query-string');
import axios from 'axios'
import ConstData from '../const/Const'
import ALlFunc from '../FuncGlobal/ALlFunc'
import {mapActions, mapGetters} from "vuex";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
// import Vue from "vue";

export default {
  name: "BudgetProject",
  data() {
    return {
      checkProj1: false,
      checkProj2: false,
      sortStatus: '1',
      selStatus: '0',
      SumAllowance: 0,
      SumAccommodationCost: 0,
      SumShippingCosts: 0,
      SumRegistrationFee: 0,
      SumAllTravelExpenses: 0,
      JoinTravel: [],
      JoinTravelHeader: [
        {text: 'ผู้เดินทาง', value: 'customTravelDetail'},
        {text: 'ค่าเบี้ยเลี้ยง', value: 'Allowance'},
        {text: 'ค่าที่พัก', value: 'AccommodationCost'},
        {text: 'ค่าพาหนะ', value: 'ShippingCosts'},
        {text: 'ค่าลงทะเบียน', value: 'RegistrationFee'},
        {text: 'รวมค่าเดินทาง', value: 'AllTravelExpenses'},
        {text: 'งบวิชาการคงเหลือ', value: 'RemainingBudget'},
      ],
      dialogJoinTravel: false,
      dialogExportPlanProj: false,
      exportType: null,
      exportType2: null,
      exportType3: null,
      exportType4: null,
      RemarkSendApprove: '',
      pageMessage: 'ปิดปรับปรุงระบบชั่วคราว',
      approveMasterChoose: [],
      ChooseSendMail: null,
      IsProcess: null,
      Project_category: null,
      DepSelect: '35000',
      TempProjectDump: [],
      searchTemp: '',
      Process: '1',
      masterApprove: null,
      sendApprove: null,
      sendApprovePerson: [],
      dialogMasterApprove: false,
      dialogMasterApprove2: false,
      dialogSendApprove: false,
      dialogSendMailApproveAgain: false,
      IsPlanCordi: false,
      btnDisable: false,
      dialogTempFile: false,
      dialogCompetency: false,
      dialogFile: false,
      dialogFileLog: false,
      typeIsPlan: '1',
      typePermiss: null,
      episode: null,
      maintain: false,
      AllBudget: 0,
      AllBudgetApprove: 0,
      AllBudgetNotApprove: 0,
      AllBudgetEditApprove: 0,
      AllBudgetPendingApprove: 0,
      json_fields: {
        '#': 'index',
        'รหัสแผน': 'Project_code',
        "ชื่องาน / กิจกรรม": 'Project_name',
        "วันที่เริ่มต้น": 'DateStart',
        "วันที่สิ้นสุด": 'DateEnd',
        "ประเภทแผน": 'Project_group_des',
        "หลักสูตร": 'Course_name',
        "งบประมาณที่ขอ": 'BudgetRequest',
        "จำนวน ช.ม.": 'CalHourse',
        "จำนวน เครดิต": 'CalCredit',
        "งาน / กิจกรรม ถูกจัดขึ้น": 'PLACE',
        "จัดโดย": 'WorkBy',
        "ชื่อผู้จัด": 'WorkByName',
        "เบอร์โทรติดต่อผู้กรอกข้อมูล": 'WorkByPhone',
        "สถานที่จัด": 'Location',
        "แผนของหน่วยงาน": 'Dep_Name',
        "แผนประจำปี": 'FiscalYear2',
        "รายละเอียด": 'Remarks',
        "วัตถุประสงค์": 'Objective',
        "กลุ่มเป้าหมาย": 'TargetGroup',
        "สถานะ": 'IsStatusName'
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      StatusPlan: 'A',
      dateApprove: '',
      Project: null,
      ProjectBefore: null,
      LogObjProject: null,
      snack: false,
      snackColor: '',
      snackText: '',
      max25chars: v => v.length <= 25 || 'Input too long!',
      pagination: {},
      YearSel: null,
      IsPlan: null,
      PlanProject_code: '',
      Project_code_dump: '',
      itemCode: '',
      Project_plan: [],
      TypeCreateProject: '0',
      FiscalYearData: [],
      FiscalYearMenuData: [],
      projectDataToTable: [],
      projectDataToTableDump: [],
      allProjectDataToTable: [],
      rdoRegisterProject: '0',
      ProjectQuotaDepCount: 0,
      dateRegStart: '',
      dateRegEnd: '',
      MessageSuc: '',
      MessageError: '',
      ShowAlertErr: false,
      ShowAlertSuc: false,
      DepQuotaData: [],
      searchDepQuota: '',
      ChooseTypRegis: '1',
      ChooseTypRegis2: '0',
      ChkJoinPerson: true,
      ProjectQuotaCount: '',
      DepQuotaCount: '',
      groupDepart: [],
      ChooseTypeDep: '0',
      DepQuotaSelect: '',
      CheckAdmin: false,
      CheckSubAdmin: false,
      WorkGroupData: [],
      dialogLecturerDetail: false,
      LecturerDetail: [],
      Country_id: '',
      dialogLecturer: false,
      percent: 0,
      dialogTemplate: false,
      CheckLecturer: false,
      Lecturer: [],
      TemplateProject: [],
      LecturerToShow: [],
      Committee_ToShow: [],
      projectGroupToShow: [],
      headerLecturer: [
        {text: 'หัวข้อเรื่อง', value: 'subject'},
        {text: 'วันที่เริ่มต้น', value: 'date_start'},
        {text: 'วันที่สิ้นสุด', value: 'date_end'},
        {text: 'เวลาเริ่มต้น', value: 'time_start'},
        {text: 'เวลาสิ้นสุด', value: 'time_end'}
      ],
      DepQuotaHeader: [
        {text: 'ประเภท', value: 'type'},
        {text: 'ภาควิชา/หน่วยงาน', value: 'dep_name'},
        {text: 'จำนวน', value: 'count'},
        {text: '', value: 'action'},
      ],
      SubjectForLecturer: '',
      dateSForLecturer: '',
      dateEForLecturer: '',
      timeSForLecturer: '',
      timeEForLecturer: '',
      editor: DecoupledEditor,
      editorDataGenerate: '',
      editorDataFormDB: '',
      editorData: '',
      dialogLoading: false,
      Expense: 0,
      Openfile: ConstData.ConnectionHost + '/rest/files',
      CompetencyToShow: [],
      ReqMoney: '',
      Rm: '',
      selection: [],
      logSelection: [],
      dialogDetail: false,
      itemToShow: null,
      searchCompe: '',
      isMobile: false,
      SelDelvNo: '',
      itemsSel: [],
      CompetencyData: [],
      CompetencyDataDump: [],
      proposal: [],
      dialogProposal: false,
      Period_code: '',
      period: [
        {
          'name': 'ระยะสั้น (ไม่เกิน 1 เดือน)',
          'id': '2'
        },
        {
          'name': 'ระยะยาว (มากกว่า 1 เดือน)',
          'id': '3'
        }
      ],
      RecordData: [],
      RecordDataDump: [],
      TempRecordData: [],
      searchPerson: '',
      headersPerson: [
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'สังกัด', value: 'affiliation'},
        {text: 'ลงทะเบียน', value: 'status_reg'},
      ],
      JoinPerson: [],
      Approve_m: null,
      Approve_Status: [
        {
          id: '1',
          detail: 'รอพิจารณา',
          disable: true
        },
        {
          id: '4',
          detail: 'แก้ไข',
          disable: true
        },
        {
          id: '3',
          detail: 'ไม่อนุมัติ',
          disable: true
        },
        {
          id: '10',
          detail: 'เสนอพิจารณาอนุมัติ',
          disable: true
        },
        {
          id: '11',
          detail: 'อนุมัติ (ขั้นต้น)',
          disable: true
        },
        {
          id: '2',
          detail: 'อนุมัติ',
          disable: true
        },
      ],
      Req_Approve_Status: [
        {
          id: '2',
          detail: 'ไม่อนุมัติ',
          disable: true
        },
        {
          id: '3',
          detail: 'เสนอพิจารณาอนุมัติ',
          disable: true
        },
        {
          id: '4',
          detail: 'อนุมัติ (ขั้นต้น)',
          disable: true
        },
        {
          id: '1',
          detail: 'อนุมัติ',
          disable: true
        }
      ],
      TempFileProject: [],
      FileProject: [],
      FileProjectOld: [],
      LogFileProject: [],
      File_Consider: [],
      alert: false,
      txtAlert: [],
      tab: null,
      tabMenu: null,
      Competency_code: '',
      UPercent: '',
      competencyHeader: [
        {text: 'Competency', value: 'Competency_des'},
        {text: 'เปอเซ็นต์', value: 'UPercent'}
      ],
      competency_DataForSubmit: [],
      expenseCostSum: 0,
      DepCost: '',
      expenseCost: '',
      moneyCost: '',
      expense_DataForSubmit: [],
      expense_p_DataForSubmit: [],
      CheckStep1: true,
      e1: 1,
      steps: 8,
      vertical: true,
      altLabels: false,
      editable: true,
      Details_Cordi: false,
      CheckFiles: false,
      full_name: '',
      phone: '',
      perid: '',
      peridCommittee: '',
      Committee_code: '',
      radioGroup: '0',
      radioGroup2: '0',
      files: [],
      ChooseCourse: '',
      posiCondi: '',
      levelCondi: '',
      WSYear_Condi: '',
      WEYear_Condi: '',
      Course_Choose: '',
      DataCondi: [],
      courseCondi: [],
      Project_code: '',
      Project_name: '',
      Course_code: '',
      FiscalYear: '',
      course_group: '',
      Project_type: '',
      WorkBy: '',
      WorkByName: '',
      WorkByPhone: '',
      Location: '',
      DateStart: '',
      DateEnd: '',
      CalHourse: '0',
      CalCredit: '0',
      PLACE: '',
      Province_id: '',
      Status: '0',
      Objective: '',
      TargetGroup: '',
      Remarks: '',
      remarksApprove: '',
      ProjectLevel: '',
      App_doc_no: '',
      BudgetRequest: '',
      BudgetArrove: '',
      MoneyDisburse: '',
      Project_group: '',
      D_Project: {
        Project_code: '',
        Project_name: '',
        Course_code: '',
        course_group: '',
        Project_type: '',
        IsProcess: null,
        Project_category: '',
        WorkBy: '',
        Location: '',
        DateStart: '',
        DateEnd: '',
        CalHourse: '',
        CalCredit: '',
        PLACE: '',
        Province_id: '',
        Status: '0',
        Objective: '',
        TargetGroup: '',
        Remarks: '',
        ProjectLevel: '',
        App_doc_no: '',
        BudgetRequest: '',
        BudgetArrove: '',
        MoneyDisburse: '',
        Project_group: '',
        FiscalYear: '',
        IsPlan: '',
        IsPlanStatus: '',
        Status_Reg: '',
        Status_Type_Reg: '',
        DateS_Reg: '',
        DateE_Reg: '',
        Status_Count_Reg: '',
        Count_Reg: '',
        Dep_Code: '',
        Create_By: '',
        Create_Time: '',
        Update_By: '',
      },
      expanded: [],
      singleExpand: false,
      search: '',
      search2: '',
      CoordinatorHeader: [
        {text: 'ชื่อ - สกุล', value: 'Name'},
        {text: 'ตำแหน่ง', value: 'position_com'},
        {text: 'เบอรโ์โทร', value: 'TEL'},
        {text: 'สถานะ', value: 'Committee_type'},
        {text: 'วิทยากร', value: 'Lecturer'},
      ],
      Coordinator: [],
      courseHeadersCondi: [
        {text: 'หลักสูตร', value: 'Course_name'}
      ],
      courseDataCondi: [],
      dataHeadersCondi: [
        {text: 'ตำแหน่ง', value: 'PosName'},
        {text: 'อายุงานเริ่มต้น', value: 'WSYear'},
        {text: 'อายุงานสิ้นสุด', value: 'WEYear'}
      ],
      dataDataCondi: [],
      projectNeed: false,
      picker: new Date().toISOString().substr(0, 10),
      landscape: false,
      reactive: false,
      fullWidth: false,
      showCurrent: true,
      month: false,
      multiple: false,
      readonly: false,
      disabled: false,
      enableEvents: false,
      PLACESelete: [
        {
          id: '0', detail: 'ภายในคณะ'
        },
        {
          id: '1', detail: 'ภายในมหาวิทยาลัย'
        },
        {
          id: '2', detail: 'ภายในจังหวัด'
        },
        {
          id: '3', detail: 'ต่างประเทศ'
        },
        {
          id: '4', detail: 'online'
        }
      ],
      WorkByData: [
        {
          id: 'D', detail: 'หน่วยงาน'
        },
        {
          id: 'F', detail: 'คณะ'
        },
        {
          id: 'U', detail: 'มหาวิทยาลัย'
        },
        {
          id: 'P', detail: 'ภายนอก'
        },
        {
          id: 'C', detail: 'ร่วมโครงการ'
        },
      ],
      Menu: [
        {
          'id': 1,
          'value': 'จัดโครงการ'
        },
        {
          'id': 2,
          'value': 'จัดการข้อมูลโครงการ'
        },
        {
          'id': 3,
          'value': 'ข้อมูลเบิกจ่ายเงินโครงการ'
        }],
      projectType: [
        {
          id: '0',
          details: 'อบรม'
        },
        {
          id: '1',
          details: 'ดูงาน'
        },
        {
          id: '2',
          details: 'ประชุม'
        },
        {
          id: '3',
          details: 'นำเสนองาน'
        }
      ],
      workBy: [
        'Depart',
        'Faculty',
        'University',
        'Public C',
        'Co-Project'
      ],
      CourseType: [
        'ทั่วไป',
        'เฉพาะตำแหน่ง'
      ],
      DataCourse: {
        Project_code: '',
        Course_code: '',
        Credit: ''
      },
      rules: {
        required: value => !!value || 'Required.',
        counterCourse: value => value.length <= 8 || 'Max 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      allProjectHeader: [
        {
          text: 'รหัสหลักสูตร', class: 'HeaderTable',
          align: 'start',
          value: 'Project_code',
        },
        {text: 'หลักสูตร', value: 'full_Name'},
        {text: 'อนุมัติโดย', value: 'Approve'},
        {text: 'สถานะ', value: 'Project_Status'},
        {text: '', value: 'Project_Details'}
      ],
      courseHeaders: [
        {text: 'หลักสูตร', value: 'full_Name'},
        {text: 'สถานะ', value: 'IsPlanStatus'},
        // {text: 'Item_Code', value: 'Item_Code'},
        {text: 'งบประมาณ', value: 'BudgetRequest'},
        {text: 'จำนวนเงินอนุมัติ', value: 'BudgetArrove'},
        {text: 'จำนวนเงินเบิกจ่าย', value: 'MoneyDisburse'},
        {text: '', value: 'Project_Details'}
      ],
      TempHeaders: [
        {text: 'หลักสูตร', value: 'full_Name'},
        {text: 'สถานะ', value: 'Req_status'},
        // {text: 'Item_Code', value: 'Item_Code'},
        {text: 'งบประมาณ', value: 'BudgetRequest'},
        {text: 'จำนวนเงินอนุมัติ', value: 'BudgetArrove'},
        {text: 'จำนวนเงินเบิกจ่าย', value: 'MoneyDisburse'},
        {text: '', value: 'Project_Details'}
      ],
      budgetHeader: [
        {text: 'รายการ', value: 'Expense_des'},
        {text: 'จำนวนเงิน', value: 'ReqMoney'},
        {text: 'หมายเหตุ', value: 'Rm'},
        {text: '', value: 'action'}
      ],
      budgetData: [],
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      projectForApprove: 'Project/getProjectForApprove',
      committee_Posi: 'Project/getComitteeType',
      Comittee_Data: 'Project/getComittee',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      textForPrint: 'Project/getTextForPrint',
      countryData: 'Project/getCountry',
      planProjectForApprove: 'Project/getProjectPlanApprove',
      planProjectForHistory: 'Project/getProjectPlanHistory',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      ApproveMaster: 'Staff/getApproveMaster',
      AllApproveMaster: 'Staff/getAllApproveMaster',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      Competency: 'Competency/getCompetency',
      ProjectCompetency: 'Project/getCompetency',
      ProjectExpense: 'Project/getProjectExpense',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      // Approve: 'Permission/getApprove',
      PermissionAdmin: 'Permission/getPermission',
      MenuPermiss: 'Permission/getMenuPermiss',
      IgnoreMenuPermiss: 'Permission/getIgnoreMenuPermiss',
      DateForPlan: 'Project/getDateForPlan',
      LogProject: 'Project/getLogProject',
      LogCompetencyProject: 'Project/getLogCompetency',
      LogFiles: 'Project/getLogFiles',
      TempProject: 'Project/getTempProject',
      TempCompetencyProject: 'Project/getTempCompetency',
      TempFiles: 'Project/getTempFiles',
      TypeProject: 'Project/getTypeProject',
      StatusProject: 'Project/getStatusProject',
      TempStatusProject: 'Project/getTempStatusProject',
      TravelForm: 'Project/getTravelForm',
      JoinTravelRes: 'Project/getJoinTravel',
      appColor: 'Page/getColor',
      appHeaderName: 'Page/getHeaderName',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initApproveMasterAll: 'Staff/initApproveMasterAll',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initPlanProjectDataForApprove: 'Project/initPlanProjectDataForApprove',
      initPlanProjectDataForHistory: 'Project/initPlanProjectDataForHistory',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      MangeTextForPrint: 'Project/MangeTextForPrint',
      initCountryData: 'Project/initCountryData',
      initProjectExpenseData: 'Project/initProjectExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveMaster: 'Staff/initApproveMaster',
      initApproveMasterByType: 'Staff/initApproveMasterByType',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      getMenuPermissData: 'Permission/getMenuPermissData',
      getIgnoreMenuPermissData: 'Permission/getIgnoreMenuPermissData',
      initDateForPlan: 'Project/initDateForPlan',
      initLogProject: 'Project/initLogProject',
      initLogCompetencyProject: 'Project/initLogCompetencyProject',
      initLogFileProject: 'Project/initLogFileProject',
      changeTypeProject: 'Project/changeTypeProject',
      initTempProject: 'Project/initTempProject',
      initAllTempProject: 'Project/initAllTempProject',
      initTempCompetencyProject: 'Project/initTempCompetencyProject',
      initTempFileProject: 'Project/initTempFileProject',
      initFileReportTravel: 'Project/initFileReportTravel',
      initJoinTravel: 'Project/initJoinTravel',
      changeColor: 'Page/changeColor',
      changeHeaderName: 'Page/changeHeaderName',
    }),
    init: function () {
      this.dialogLoading = true
      this.CompetencyData = []
      this.projectDataToTable = []
      this.projectDataToTableDump = []
      this.FiscalYearData = []
      this.FiscalYearMenuData = []
      this.TempProjectDump = []
      this.initComitteeType()
      this.initCountryData()
      // this.YearSel = (new Date().getFullYear())
      this.YearSel = 2025

      // for (var i = (new Date().getFullYear() - 1); i <= (new Date().getFullYear() + 1); i++) {
      for (var i = 2020; i <= (new Date().getFullYear() + 3); i++) {
        this.FiscalYearData.push({
          year: i,
          yearth: i + 543
        })
      }

      for (var j = 2020; j <= (new Date().getFullYear() + 3); j++) {
        this.FiscalYearMenuData.push({
          year: j,
          yearth: j + 543
        })
      }

      // this.initProjectData({
      //   perid: this.MeData[0].perid
      // })
      this.initCompetencyData().then(res => {
        if (res) {
          this.Competency.map(compe_i => {
            if (compe_i.DelvCover == null || compe_i.DelvCover == '') {
              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                this.CompetencyData.push({
                  ...compe_i,
                  id: compe_i.DelvNo,
                  name: compe_i.DelvDes,
                  DelvLevel: '0',
                  checkCordi: (compe_i.DelvGroup == 'A' || compe_i.DelvGroup == 'D') ? true : false,
                  children: []
                })
              } else {
                this.CompetencyData.push({
                  ...compe_i,
                  id: compe_i.DelvNo,
                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                  DelvLevel: '0',
                  checkCordi: (compe_i.DelvGroup == 'A' || compe_i.DelvGroup == 'D') ? true : false,
                  children: []
                })
              }
            }
          })
          this.CompetencyData.map((data_i, idx) => {
            if (data_i.children.length == 0) {
              this.Competency.map(compe_i => {
                if (data_i.DelvNo == compe_i.DelvCover) {
                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                    this.CompetencyData[idx].children.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes,
                      DelvLevel: '1',
                      checkCordi: false,
                      children: []
                    })
                  } else {
                    this.CompetencyData[idx].children.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                      DelvLevel: '1',
                      checkCordi: false,
                      children: []
                    })
                  }
                }
              })
            }
          })
          // lv2
          this.CompetencyData.map(data_i => {
            if (data_i.children.length > 0) {
              data_i.children.map((child1_i, idx) => {
                if (child1_i.children.length == 0) {
                  this.Competency.map(compe_i => {
                    if (child1_i.DelvNo == compe_i.DelvCover) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        data_i.children[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '2',
                          checkCordi: false,
                          children: []
                        })
                      } else {
                        data_i.children[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '2',
                          checkCordi: false,
                          children: []
                        })
                      }

                    }
                  })
                }
              })
            }
          })

          // item to autocomplete
          this.CompetencyData.map(itemRoot => {
            this.itemsSel.push({
              ...itemRoot
            })
            if (itemRoot.children.length > 0) {
              itemRoot.children.map(itemChild1 => {
                this.itemsSel.push({
                  ...itemChild1
                })
                if (itemChild1.children.length > 0) {
                  itemChild1.children.map(itemChild2 => {
                    this.itemsSel.push({
                      ...itemChild2
                    })
                  })
                }
              })
            }
          })

          this.CompetencyDataDump = JSON.parse(JSON.stringify(this.CompetencyData))
        }
      })


      this.initAllTempProject().then(res => {
        if (res) {
          if (this.TempProject.length > 0) {
            this.TempProject.map(Project => {
              var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)
              this.TempProjectDump.push({
                ...Project,
                full_Name: '' +
                    ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                    ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                    ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                    ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + Project.dep_name + '</span></div>' +
                    (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
              })
            })
          }
        }
      })

      this.initPlanProjectDataForApprove().then(res => {
        if (res) {
          if (this.planProjectForApprove.length > 0) {
            this.planProjectForApprove.map(Project => {
              if (Project.Approve == '1' && (Project.Project_type == '1' || (Project.Project_type == '2' && (Project.IsProcess == '3' && Project.IsExpense == '0')))) {
                var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)
                if (DepBy.length > 0) {
                  this.projectDataToTable.push({
                    ...Project,
                    full_Name: '' +
                        ' <div><span style="font-weight: bold;color: black">รหัส: (' + Project.Project_code + ')</span></div>' +
                        ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                        ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                        ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>' +
                        (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                    Owner: true
                  })
                } else if (DepBy.length == 0) {
                  this.projectDataToTable.push({
                    ...Project,
                    full_Name: '' +
                        ' <div><span style="font-weight: bold;color: ">รหัส: (' + Project.Project_code + ')</span></div>' +
                        ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                        ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>' +
                        (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                    Owner: true
                  })
                } else {
                  this.projectDataToTable.push({
                    ...Project,
                    full_Name: ' ' +
                        ' <div><span style="font-weight: bold;color: ">รหัส: (' + Project.Project_code + ')</span></div>' +
                        ' <div><span style="font-weight: bold;color: darkblue">' + Project.Project_name + '</span></div>' +
                        ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + (this.depart.filter(depi => depi.dep_id == Project.dep_id).length > 0 ? this.depart.filter(depi => depi.dep_id == Project.dep_id)[0].dep_name : '') + '</span></div>' +
                        (Project.IsDataComplete == '0' ? '<p style="font-weight: bold;color: red">****ข้อมูลไม่สมบูรณ์****</p>' : ''),
                    Owner: true
                  })
                }
              }
            })
          }

          this.ChooseYearFiscal()
          this.ChooseProcess()
          this.dialogLoading = false

        } else {
          this.ChooseYearFiscal()
          this.ChooseProcess()
          this.dialogLoading = false
        }
      }).catch(reason => {
        if (reason) {
          this.ChooseYearFiscal()
          this.ChooseProcess()
          this.dialogLoading = false
        }
      })


      if (this.courseData.length == 0) {
        this.initCourseData()
      }

      if (this.positions.length == 0) {
        this.initPositionsData()
      }

      if (this.Comittee_Data.length == 0) {
        this.initComitteeData()
      }

      if (this.provinces_Data.length == 0) {
        this.initProvincesData()
      }

      this.initExpenseData({
        cost_type: this.TypeProject
      })

      // if (this.Competency_Data.length == 0) {
      //   this.initCompetencyData()
      // }

      if (this.projectGroup.length == 0) {
        this.initProjectGroupData()
      }
    },
    ExportData() {
      if (this.exportType != null && this.exportType2 != null && this.exportType3 != null && this.exportType4 != null) {
        this.json_data = []
        var count = 0
        if (this.projectDataToTableDump.length > 0) {
          if (this.projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == this.YearSel && item.IsPlan == this.exportType3 && item.Project_category == this.exportType && item.Project_type == this.exportType2).length > 0) {
            this.projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == this.YearSel && item.IsPlan == this.exportType3 && item.Project_category == this.exportType && item.Project_type == this.exportType2).map((item) => {
              if (this.exportType4 == '0' && item.IsPlanStatus == '2' || item.IsPlanStatus == '6' || item.IsPlanStatus == '7' || item.IsPlanStatus == '8') {
                this.json_data.push({
                  ...item,
                  index: ++count,
                  PLACE: this.PLACESelete.filter(itemP => itemP.id == item.PLACE).length > 0 ? this.PLACESelete.filter(itemP => itemP.id == item.PLACE)[0].detail : '',
                  WorkBy: this.WorkByData.filter(itemW => itemW.id == item.WorkBy).length > 0 ? this.WorkByData.filter(itemW => itemW.id == item.WorkBy)[0].detail : '',
                  Dep_Name: this.depart.filter(itemD => itemD.dep_id == item.Dep_Code).length > 0 ? this.depart.filter(itemD => itemD.dep_id == item.Dep_Code)[0].dep_name : '',
                  FiscalYear2: parseInt(item.FiscalYear) + 543
                })
              } else {
                this.json_data.push({
                  ...item,
                  index: ++count,
                  PLACE: this.PLACESelete.filter(itemP => itemP.id == item.PLACE).length > 0 ? this.PLACESelete.filter(itemP => itemP.id == item.PLACE)[0].detail : '',
                  WorkBy: this.WorkByData.filter(itemW => itemW.id == item.WorkBy).length > 0 ? this.WorkByData.filter(itemW => itemW.id == item.WorkBy)[0].detail : '',
                  Dep_Name: this.depart.filter(itemD => itemD.dep_id == item.Dep_Code).length > 0 ? this.depart.filter(itemD => itemD.dep_id == item.Dep_Code)[0].dep_name : '',
                  FiscalYear2: parseInt(item.FiscalYear) + 543
                })
              }
            })
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่พบข้อมูลที่ต้องการ Export'
            })
          }
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุข้อมูลให้ครบถ้วน'
        })
      }
    },
    ChooseYearFiscal() {
      this.AllBudget = 0
      this.AllBudgetApprove = 0
      this.AllBudgetNotApprove = 0
      this.AllBudgetEditApprove = 0
      if (this.projectDataToTableDump.length == 0) {
        this.projectDataToTableDump = this.projectDataToTable
      }
      if (this.projectDataToTableDump.length > 0) {
        this.projectDataToTable = []
        this.projectDataToTable = this.projectDataToTableDump.filter(item => item.FiscalYear == this.YearSel)
        // var projectFilter = this.projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == this.YearSel && item.IsPlan != null && item.Project_category != null && item.Project_type != null)
        var projectFilter = this.projectDataToTableDump.filter(item => item.FiscalYear == this.YearSel)
        this.AllBudget = projectFilter.length > 0 ? parseFloat(projectFilter.reduce((prev, cur) => ({BudgetRequest: parseFloat(prev.BudgetRequest) + parseFloat(cur.BudgetRequest)})).BudgetRequest) : 0
        this.AllBudgetApprove = projectFilter.length > 0 ? projectFilter.filter(item => item.IsPlanStatus == '2').length > 0 ? parseFloat(projectFilter.filter(item => item.IsPlanStatus == '2').reduce((prev, cur) => ({BudgetRequest: parseFloat(prev.BudgetRequest) + parseFloat(cur.BudgetRequest)})).BudgetRequest) : 0 : 0
        this.AllBudgetApprove += projectFilter.length > 0 ? projectFilter.filter(item => item.IsPlanStatus == '5').length > 0 ? parseFloat(projectFilter.filter(item => item.IsPlanStatus == '5').reduce((prev, cur) => ({BudgetRequest: parseFloat(prev.BudgetRequest) + parseFloat(cur.BudgetRequest)})).BudgetRequest) : 0 : 0
        this.AllBudgetApprove += projectFilter.length > 0 ? projectFilter.filter(item => item.IsPlanStatus == '6').length > 0 ? parseFloat(projectFilter.filter(item => item.IsPlanStatus == '6').reduce((prev, cur) => ({BudgetRequest: parseFloat(prev.BudgetRequest) + parseFloat(cur.BudgetRequest)})).BudgetRequest) : 0 : 0
        this.AllBudgetNotApprove = projectFilter.length > 0 ? projectFilter.filter(item => item.IsPlanStatus == '3').length > 0 ? parseFloat(projectFilter.filter(item => item.IsPlanStatus == '3').reduce((prev, cur) => ({BudgetRequest: parseFloat(prev.BudgetRequest) + parseFloat(cur.BudgetRequest)})).BudgetRequest) : 0 : 0
        this.AllBudgetEditApprove = projectFilter.length > 0 ? projectFilter.filter(item => item.IsPlanStatus == '4').length > 0 ? parseFloat(projectFilter.filter(item => item.IsPlanStatus == '4').reduce((prev, cur) => ({BudgetRequest: parseFloat(prev.BudgetRequest) + parseFloat(cur.BudgetRequest)})).BudgetRequest) : 0 : 0
        this.AllBudgetPendingApprove = projectFilter.length > 0 ? projectFilter.filter(item => item.IsPlanStatus == '1').length > 0 ? parseFloat(projectFilter.filter(item => item.IsPlanStatus == '1').reduce((prev, cur) => ({BudgetRequest: parseFloat(prev.BudgetRequest) + parseFloat(cur.BudgetRequest)})).BudgetRequest) : 0 : 0
        this.ChooseStatusPlan()
      }
    },
    ChooseStatusPlan() {
      this.projectDataToTable = []
      if (this.projectDataToTableDump.length > 0) {
        if (this.typePermiss == 'E') {
          this.projectDataToTable = this.projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == this.YearSel && ((item.IsPlanStatus == '' || item.IsPlanStatus == null) || (item.IsPlan == '' || item.IsPlan == null) || (item.Project_category == '' || item.Project_category == null) || (item.Project_type == '' || item.Project_type == null) || (item.DatePeriod == '' || item.DatePeriod == null) || (item.Project_type == '2' && (item.IsProcess != '' && item.IsProcess != null))))
        } else {
          if (this.StatusPlan == 'A') {
            if (this.Process == '1') {
              this.projectDataToTable = this.projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == this.YearSel && item.IsPlan == this.typeIsPlan && item.Project_category == this.typePermiss && item.Project_type == this.Process)
            } else if (this.Process == '2') {
              this.projectDataToTable = this.projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == this.YearSel && item.Project_type == this.Process)
            }
          } else {
            if (this.Process == '1') {
              this.projectDataToTable = this.projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == this.YearSel && item.IsPlanStatus == this.StatusPlan && item.IsPlan == this.typeIsPlan && item.Project_category == this.typePermiss && item.Project_type == this.Process)
            } else if (this.Process == '2') {
              this.projectDataToTable = this.projectDataToTableDump.filter(item => item.Approve == '1' && item.FiscalYear == this.YearSel && item.IsPlanStatus == this.StatusPlan && item.Project_type == this.Process)
            }
          }
        }
      }
    },
    ShowDetailLecturer(item) {
      this.LecturerDetail = []
      this.LecturerDetail = this.WorkGroupData.filter(L_item => L_item.perid == item.Perid && L_item.type == item.Committee_code)
      this.dialogLecturerDetail = true
    },
    onProgress(evt) {
      console.log(evt)
      this.percent = 0
      this.percent = evt
    },
    hasGenerated(evt) {
      console.log(evt)
    },
    hasStartedGeneration(evt) {
      console.log(evt)
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf()
    },
    ShowTemplate() {
      // this.dialogTemplate = true
      // this.generateReport()
      let routeData = this.$router.resolve({name: 'PrintFormProject', query: {data: this.editorData}});
      window.open(routeData.href, '_blank', 'location=yes,height=800,width=800,scrollbars=yes,status=yes');
    },
    SelProjectGroup() {
      if (this.projectGroup.filter(item => item.Project_group == this.Project_group).length > 0) {
        this.projectGroupToShow = this.projectGroup.filter(item => item.Project_group == this.Project_group)[0].Project_group_des
      } else {
        this.projectGroupToShow = ''
      }
    },
    AddWorkGuest() {
      if (this.SubjectForLecturer != '' && this.dateSForLecturer != '' && this.dateEForLecturer != '' && this.timeSForLecturer != '' && this.timeEForLecturer != '') {
        this.Lecturer.push({
          perid: this.perid,
          subject: this.SubjectForLecturer,
          date_start: this.dateSForLecturer,
          date_end: this.dateEForLecturer,
          time_start: this.timeSForLecturer,
          time_end: this.timeEForLecturer
        })
        this.SubjectForLecturer = ''
        this.dateSForLecturer = ''
        this.dateEForLecturer = ''
        this.timeSForLecturer = ''
        this.timeEForLecturer = ''
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาระบุข้อมูลให้ครบถ้วน'
        })
      }
    },
    DocumentExec() {
      this.formprint1 = this.editorData
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.docx'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
    },
    PrintForm() {
      axios.post('http://localhost:3006/exec/docx', {
        data: {
          val1: this.formprint1, // หลักการและเหตุผล
          val2: this.formprint2, // วัตถุประสงค์
          val3: this.formprint3, // กลุ่มเป้าหมาย
          val4: this.formprint4, // วิธีการจัดอบรม
          val5: this.formprint5, // ระยะเวลาการจัดอบรม
          val6: this.formprint6, // สถานที่จัดอบรม
          val7: this.formprint7, // ผลที่คาดว่าจะได้รับ
          val8: this.formprint8, // ผู้รับผิดชอบโครงการ
          val9: this.formprint9, // ผู้รับผิดชอบโครงการ
          val10: this.formprint10, // วิทยากร
          val11: this.formprint11, // งบประมาณ
          val12: this.formprint12, // หมายเหตุ
          budget: this.budgetData,
          Lecturer: this.LecturerToShow,
          Committee: this.Committee_ToShow,
          projectGroup: this.projectGroupToShow,
          projectname: this.Project_name,
          projectcode: '01010-0220-1541'
        }
      }).then((res) => {
        console.log(res.data)
      })
      // axios({
      //   url: 'http://localhost:3006/exec/test', //your url
      //   method: 'GET',
      //   responseType: 'blob', // important
      // }).then((response) => {
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', 'file.pdf'); //or any other extension
      //   document.body.appendChild(link);
      //   link.click();
      // });
      // this.$htmlToPaper('printForm');
      // this.MangeTextForPrint({
      //     process: 'SET',
      //     message: this.editorData
      // }).then(res => {
      //     if (res) {
      //         // console.log(this.textForPrint)
      //         this.$router.push({name: 'PrintFormProject'});
      //         // window.open(routeData.href, '_blank');
      //         // console.log('------------------------------------')
      //         // console.log(this.textForPrint)
      //
      //     }
      // })
    },
    save(item) {
      const headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + item.Project_code, {
        Item_Code: this.itemCode,
        Update_By: this.MeData[0].perid,
      }, headerAxios).then(res => {
        if (res.data.status) {
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_Item_Code/', {
            Project_Code: item.Project_code,
            Item_Code: this.itemCode,
            Create_By: this.MeData[0].perid
          }, headerAxiosPUT)
          this.snack = true
          this.snackColor = 'success'
          this.snackText = 'Data saved'
        } else {
          this.cancel()
        }
      })
    },
    cancel() {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    open() {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    close() {
      console.log('Dialog closed')
    },
    BackMenu() {
      this.Details_Cordi = false
    },
    onInput(val) {
      this.steps = parseInt(val)
    },
    backStep(n) {
      this.e1 = n
    },
    nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1
      } else {
        this.e1 = n + 1
      }
    },
    DeleteFile(file_i) {
      this.File_Consider.map((item, idx) => {
        if (item.name == file_i.name) {
          this.File_Consider.splice(idx, 1)
        }
      })
    },
    DeleteDocFile(file_i) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการลบไฟล์เอกสารประกอบ " + file_i.name + ' ใช่หรือไม่ ??',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/id/' + file_i.id, {
            active: '0',
            Update_By: this.MeData[0].perid
          }, {
            headers: {
              'Content-Type': 'application/json',
            }
          }).then(res => {
            if (res.data.status) {
              this.$swal.fire({
                icon: 'success',
                title: 'ลบไฟล์เอกสารประกอบ ' + file_i.name + ' สำเสร็จ!'
              })
              if (this.FileProject.length > 0) {
                this.FileProject.map((item, idx) => {
                  if (item.name == file_i.name) {
                    this.FileProject.splice(idx, 1)
                  }
                })
              }
            }
          })
        }
      })
    },
    ShowCompeDetail(item) {
      this.dialogDetail = true
      this.itemToShow = null
      this.itemToShow = item
    },
    getCompetency() {
      this.logSelection = []
      this.selection = []
      this.initProjectCompetencyData({
        Project_code: this.Project_code
      }).then(res => {
        if (res) {
          this.ProjectCompetency.map(ProjectCom => {
            this.selection.push(ProjectCom.DelvNo)
          })
          this.logSelection = [...this.selection]
        }
        this.ChooseCompetency()
      })
    },
    showCompetency(item) {
      this.CompetencyToShow = []
      var urlConnection = ''
      this.dialogLoading = true
      urlConnection = ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency_view/Project_code/' + item.Project_code
      axios.get(urlConnection).then(res => {
        if (res.data) {
          this.dialogCompetency = true
          this.dialogLoading = false
          if (res.data.length > 0) {
            res.data.map(posi_i => {
              this.Competency.map(compe_i => {
                if (posi_i.DelvCover == compe_i.DelvNo) {
                  if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                    this.Competency.map(compe_i2 => {
                      if (compe_i.DelvCover == compe_i2.DelvNo) {
                        var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i2.DelvNo)

                        if (CheckCompetency.length == 0) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      }
                    })

                    // lv1
                    if (this.CompetencyToShow.length > 0) {
                      this.CompetencyToShow.map(ComToShow => {
                        if (ComToShow.children.length > 0) {
                          ComToShow.children.map((ComToShow_c, idx_to_Show) => {
                            CheckCompetency = false
                            if (compe_i.DelvNo == ComToShow_c.DelvNo) {
                              CheckCompetency = true
                            }
                            if (!CheckCompetency && idx_to_Show == ComToShow.children.length - 1) {
                              this.CompetencyToShow.map((data_i, idx) => {
                                if (data_i.DelvNo == compe_i.DelvCover) {
                                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes,
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  } else {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.CompetencyToShow.map((data_i, idx) => {
                            if (data_i.DelvNo == compe_i.DelvCover) {
                              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes,
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              } else {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              }
                            }
                          })
                        }
                      })
                    }

                    //lv2
                    this.CompetencyToShow.map((data_i, idx) => {
                      data_i.children.map((child_i, c_idx) => {
                        if (child_i.DelvNo == posi_i.DelvCover) {
                          if (posi_i.DelvEng == null || posi_i.DelvEng == '') {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes,
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes + '( ' + posi_i.DelvEng + ' )',
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    })
                  } else {
                    var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i.DelvNo)

                    if (CheckCompetency.length == 0) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      }
                    }

                    this.Competency.map(compe_i2 => {
                      if (posi_i.DelvNo == compe_i2.DelvNo) {
                        this.CompetencyToShow.map((data_i, idx) => {
                          if (data_i.DelvNo == posi_i.DelvCover) {
                            if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes,
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            } else {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            }
                          }
                        })
                      }
                    })
                  }
                }
              })
            })
          } else {
            // root
            this.Competency.map(compe_i => {
              if (res.data.DelvCover == compe_i.DelvNo) {
                if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                  this.Competency.map(compe_i2 => {
                    if (compe_i.DelvCover == compe_i2.DelvNo) {
                      if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i2,
                          id: compe_i2.DelvNo,
                          name: compe_i2.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i2,
                          id: compe_i2.DelvNo,
                          name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      }
                    }
                  })

                  // lv1
                  this.CompetencyToShow.map((data_i, idx) => {
                    if (data_i.DelvNo == compe_i.DelvCover) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '1',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow[idx].children.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '1',
                          NeedsCredit: res.data.NeedsCredit,
                          ExpectCredit: res.data.ExpectCredit,
                          children: []
                        })
                      }
                    }
                  })

                  //lv2
                  this.CompetencyToShow.map((data_i, idx) => {
                    data_i.children.map((child_i, c_idx) => {
                      if (child_i.DelvNo == res.data.DelvCover) {
                        if (res.data.DelvEng == null || res.data.DelvEng == '') {
                          this.CompetencyToShow[idx].children[c_idx].children.push({
                            ...res.data,
                            id: res.data.DelvNo,
                            name: res.data.DelvDes,
                            DelvLevel: '2',
                            NeedsCredit: res.data.NeedsCredit,
                            ExpectCredit: res.data.ExpectCredit,
                            children: []
                          })
                        } else {
                          this.CompetencyToShow[idx].children[c_idx].children.push({
                            ...res.data,
                            id: res.data.DelvNo,
                            name: res.data.DelvDes + '( ' + res.data.DelvEng + ' )',
                            DelvLevel: '2',
                            NeedsCredit: res.data.NeedsCredit,
                            ExpectCredit: res.data.ExpectCredit,
                            children: []
                          })
                        }
                      }
                    })
                  })
                } else {
                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                    this.CompetencyToShow.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes,
                      DelvLevel: '0',
                      NeedsCredit: res.data.NeedsCredit,
                      ExpectCredit: res.data.ExpectCredit,
                      children: []
                    })
                  } else {
                    this.CompetencyToShow.push({
                      ...compe_i,
                      id: compe_i.DelvNo,
                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                      DelvLevel: '0',
                      NeedsCredit: res.data.NeedsCredit,
                      ExpectCredit: res.data.ExpectCredit,
                      children: []
                    })
                  }

                  this.Competency.map(compe_i2 => {
                    if (res.data.DelvNo == compe_i2.DelvNo) {
                      this.CompetencyToShow.map((data_i, idx) => {
                        if (data_i.DelvNo == res.data.DelvCover) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '1',
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '1',
                              NeedsCredit: res.data.NeedsCredit,
                              ExpectCredit: res.data.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    }
                  })
                }
              }
            })
          }
        } else {
          this.dialogCompetency = true
          this.dialogLoading = false
          // Error Competency
        }
      }).catch(res => {
        if (res) {
          this.dialogCompetency = true
          this.dialogLoading = false
        }
      })
    },
    showFile() {
      this.dialogFile = true
    },
    showFileReport(proj) {
      this.dialogLoading = true
      this.initFileReportTravel({
        Project_code: proj.Project_code
      }).then(res => {
        if (res) {
          this.dialogLoading = false
          if (this.TravelForm.length > 0) {
            if (this.TravelForm[0].file_name != null) {
              window.open(ConstData.ConnectionHost + '/HrTrain2/upload/file/' + this.TravelForm[0].file_name, '_blank');
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'ไม่พบไฟล์เอกสารแบบฟอร์ม!'
              })
            }
          }
        }
      })
    },
    showJoinTravel() {
      this.dialogJoinTravel = false
      this.dialogJoinTravel = true
    },
    showTempCompetency(item) {
      this.CompetencyToShow = []
      this.dialogLoading = true
      this.initTempCompetencyProject({
        Ref_id: item.Ref_id
      }).then(res => {
        if (res) {
          this.dialogCompetency = true
          this.dialogLoading = false
          if (this.TempCompetencyProject.length > 0) {
            this.TempCompetencyProject.map(posi_i => {
              this.Competency.map(compe_i => {
                if (posi_i.DelvCover == compe_i.DelvNo) {
                  if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                    this.Competency.map(compe_i2 => {
                      if (compe_i.DelvCover == compe_i2.DelvNo) {
                        var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i2.DelvNo)

                        if (CheckCompetency.length == 0) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      }
                    })

                    // lv1
                    if (this.CompetencyToShow.length > 0) {
                      this.CompetencyToShow.map(ComToShow => {
                        if (ComToShow.children.length > 0) {
                          ComToShow.children.map((ComToShow_c, idx_to_Show) => {
                            CheckCompetency = false
                            if (compe_i.DelvNo == ComToShow_c.DelvNo) {
                              CheckCompetency = true
                            }
                            if (!CheckCompetency && idx_to_Show == ComToShow.children.length - 1) {
                              this.CompetencyToShow.map((data_i, idx) => {
                                if (data_i.DelvNo == compe_i.DelvCover) {
                                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes,
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  } else {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.CompetencyToShow.map((data_i, idx) => {
                            if (data_i.DelvNo == compe_i.DelvCover) {
                              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes,
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              } else {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              }
                            }
                          })
                        }
                      })
                    }

                    //lv2
                    this.CompetencyToShow.map((data_i, idx) => {
                      data_i.children.map((child_i, c_idx) => {
                        if (child_i.DelvNo == posi_i.DelvCover) {
                          if (posi_i.DelvEng == null || posi_i.DelvEng == '') {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes,
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes + '( ' + posi_i.DelvEng + ' )',
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    })
                  } else {
                    var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i.DelvNo)

                    if (CheckCompetency.length == 0) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      }
                    }

                    this.Competency.map(compe_i2 => {
                      if (posi_i.DelvNo == compe_i2.DelvNo) {
                        this.CompetencyToShow.map((data_i, idx) => {
                          if (data_i.DelvNo == posi_i.DelvCover) {
                            if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes,
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            } else {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            }
                          }
                        })
                      }
                    })
                  }
                }
              })
            })
          }
        } else {
          this.dialogLoading = false
          this.dialogCompetency = true
          // Error Competency
        }
      }).catch(res => {
        if (res) {
          this.dialogLoading = false
          this.dialogCompetency = true
        }
      })
    },
    showTempFile(item) {
      this.dialogTempFile = true
      this.dialogLoading = true
      this.TempFileProject = []
      this.initTempFileProject({
        Ref_id: item.Ref_id
      }).then(res => {
        if (res) {
          if (this.TempFiles.length > 0) {
            this.TempFiles.map((item) => {
              switch (item.File_type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.TempFileProject.push({
                    id: item.id,
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'image',
                    type_Img: item.File_type
                  })
                  break
                case 'application/pdf':
                  this.TempFileProject.push({
                    id: item.id,
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'pdf',
                    type_Img: item.File_type
                  })
                  break
                default:
                  break
              }
            })
          }
        }
        this.dialogLoading = false
      }).catch(res => {
        if (res) {
          this.dialogLoading = false
        }
      })
    },
    showLogCompetency(item) {
      this.CompetencyToShow = []
      this.dialogLoading = true
      this.initLogCompetencyProject({
        Ref_id: item.Ref_id
      }).then(res => {
        if (res) {
          this.dialogCompetency = true
          this.dialogLoading = false
          if (this.LogCompetencyProject.length > 0) {
            this.LogCompetencyProject.map(posi_i => {
              this.Competency.map(compe_i => {
                if (posi_i.DelvCover == compe_i.DelvNo) {
                  if (compe_i.DelvCover != null && compe_i.DelvCover != '') {
                    this.Competency.map(compe_i2 => {
                      if (compe_i.DelvCover == compe_i2.DelvNo) {
                        var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i2.DelvNo)

                        if (CheckCompetency.length == 0) {
                          if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes,
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow.push({
                              ...compe_i2,
                              id: compe_i2.DelvNo,
                              name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                              DelvLevel: '0',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      }
                    })

                    // lv1
                    if (this.CompetencyToShow.length > 0) {
                      this.CompetencyToShow.map(ComToShow => {
                        if (ComToShow.children.length > 0) {
                          ComToShow.children.map((ComToShow_c, idx_to_Show) => {
                            CheckCompetency = false
                            if (compe_i.DelvNo == ComToShow_c.DelvNo) {
                              CheckCompetency = true
                            }
                            if (!CheckCompetency && idx_to_Show == ComToShow.children.length - 1) {
                              this.CompetencyToShow.map((data_i, idx) => {
                                if (data_i.DelvNo == compe_i.DelvCover) {
                                  if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes,
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  } else {
                                    this.CompetencyToShow[idx].children.push({
                                      ...compe_i,
                                      id: compe_i.DelvNo,
                                      name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                      DelvLevel: '1',
                                      NeedsCredit: posi_i.NeedsCredit,
                                      ExpectCredit: posi_i.ExpectCredit,
                                      children: []
                                    })
                                  }
                                }
                              })
                            }
                          })
                        } else {
                          this.CompetencyToShow.map((data_i, idx) => {
                            if (data_i.DelvNo == compe_i.DelvCover) {
                              if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes,
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              } else {
                                this.CompetencyToShow[idx].children.push({
                                  ...compe_i,
                                  id: compe_i.DelvNo,
                                  name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                                  DelvLevel: '1',
                                  NeedsCredit: posi_i.NeedsCredit,
                                  ExpectCredit: posi_i.ExpectCredit,
                                  children: []
                                })
                              }
                            }
                          })
                        }
                      })
                    }

                    //lv2
                    this.CompetencyToShow.map((data_i, idx) => {
                      data_i.children.map((child_i, c_idx) => {
                        if (child_i.DelvNo == posi_i.DelvCover) {
                          if (posi_i.DelvEng == null || posi_i.DelvEng == '') {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes,
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          } else {
                            this.CompetencyToShow[idx].children[c_idx].children.push({
                              ...posi_i,
                              id: posi_i.DelvNo,
                              name: posi_i.DelvDes + '( ' + posi_i.DelvEng + ' )',
                              DelvLevel: '2',
                              NeedsCredit: posi_i.NeedsCredit,
                              ExpectCredit: posi_i.ExpectCredit,
                              children: []
                            })
                          }
                        }
                      })
                    })
                  } else {
                    var CheckCompetency = this.CompetencyToShow.filter(ComToShow => ComToShow.DelvNo == compe_i.DelvNo)

                    if (CheckCompetency.length == 0) {
                      if (compe_i.DelvEng == null || compe_i.DelvEng == '') {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes,
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      } else {
                        this.CompetencyToShow.push({
                          ...compe_i,
                          id: compe_i.DelvNo,
                          name: compe_i.DelvDes + '( ' + compe_i.DelvEng + ' )',
                          DelvLevel: '0',
                          NeedsCredit: posi_i.NeedsCredit,
                          ExpectCredit: posi_i.ExpectCredit,
                          children: []
                        })
                      }
                    }

                    this.Competency.map(compe_i2 => {
                      if (posi_i.DelvNo == compe_i2.DelvNo) {
                        this.CompetencyToShow.map((data_i, idx) => {
                          if (data_i.DelvNo == posi_i.DelvCover) {
                            if (compe_i2.DelvEng == null || compe_i2.DelvEng == '') {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes,
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            } else {
                              this.CompetencyToShow[idx].children.push({
                                ...compe_i2,
                                id: compe_i2.DelvNo,
                                name: compe_i2.DelvDes + '( ' + compe_i2.DelvEng + ' )',
                                DelvLevel: '1',
                                NeedsCredit: posi_i.NeedsCredit,
                                ExpectCredit: posi_i.ExpectCredit,
                                children: []
                              })
                            }
                          }
                        })
                      }
                    })
                  }
                }
              })
            })
          }
        } else {
          this.dialogLoading = false
          this.dialogCompetency = true
          // Error Competency
        }
      }).catch(res => {
        if (res) {
          this.dialogLoading = false
          this.dialogCompetency = true
        }
      })
    },
    showLogFile(item) {
      this.dialogFileLog = true
      this.dialogLoading = true
      this.LogFileProject = []
      this.initLogFileProject({
        Ref_id: item.Ref_id
      }).then(res => {
        if (res) {
          if (this.LogFiles.length > 0) {
            this.LogFiles.map((item) => {
              switch (item.File_type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.LogFileProject.push({
                    id: item.id,
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'image',
                    type_Img: item.File_type
                  })
                  break
                case 'application/pdf':
                  this.LogFileProject.push({
                    id: item.id,
                    name: item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + item.File_path,
                    path: item.File_path,
                    type: 'pdf',
                    type_Img: item.File_type
                  })
                  break
                default:
                  break
              }
            })
          }
        }
        this.dialogLoading = false
      }).catch(res => {
        if (res) {
          this.dialogLoading = false
        }
      })
    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );

    },
    getTrainFiles(Ref_id) {
      return new Promise(resolve => {
        var dumpArr = []
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/Ref_id/' + Ref_id).then(res => {
          if (res.data) {
            if (res.data.length > 0) {
              dumpArr = res.data
            } else {
              dumpArr.push(res.data)
            }
          } else {
            dumpArr = []
          }
          resolve(dumpArr)
        })
      })
    },
    DelProjectOwner(item) {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการลบข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี " + item.Project_name + ' ใช่หรือไม่ ??',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          const headerAxios = {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'DELETE'
            }
          }
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + item.Project_code, '', headerAxios)
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + item.Project_code + '/?limit=1', '', {
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(res => {
            if (res.data) {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + item.Project_code, '', headerAxios)
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/Ref_id/' + res.data.Ref_id, '', headerAxios)
            }
          })

          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_expense/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee/Project_code/' + item.Project_code, '', headerAxios)
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/TemplateProject/Project_code/' + item.Project_code, '', headerAxios)

          setTimeout(() => {
            this.$swal.fire({
              timer: 1500,
              showConfirmButton: false,
              icon: 'success',
              title: 'ลบข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี  ' + item.Project_name + '  สำเร็จ!!'
            }, 1500)
            this.init()
          })
        }
      })
    },
    DelProject(item) {
      this.initMeData().then(async res => {
        if (res) {
          this.$swal.fire({
            title: 'ยืนยันการทำรายการ',
            text: "คุณต้องการลบข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี " + item.Project_name + ' ใช่หรือไม่ ??',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.value) {
              axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
                queryName: 'cancelProject',
                param: btoa(JSON.stringify({
                  Project_code: item.Project_code,
                  perid: this.MeData[0].perid,
                }))
              }).then(res => {
                if (res.data.status) {
                  setTimeout(() => {
                    this.$swal.fire({
                      timer: 1500,
                      showConfirmButton: false,
                      icon: 'success',
                      title: 'ลบข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี  ' + item.Project_name + '  สำเร็จ!!'
                    }, 1500)
                    this.init()
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาดไม่สามารถลบข้อมูลได้ โปรดลองอีกครั้ง'
                  })
                }
              })
            }
          })
        }
      }).catch(reason => {
        console.log('Reject = ' + reason)
      })
    },
    OpenLinkApprove(item) {
      window.open(
          Const.ConnectionHostHrTrain + '/ApproveProject/' + item.Project_code,
          '_blank' // <- This is what makes it open in a new window.
      );
    },
    SendOtherApprove(item) {
      this.Project = null
      this.sendApprove = null
      this.RemarkSendApprove = ''
      this.Project = item
      this.sendApprove = this.typePermiss
      this.dialogSendApprove = true
    },
    SendMailApproveAgain(item) {
      this.Project = null
      this.sendApprove = null
      this.Project = item
      this.sendApprove = this.typePermiss
      this.dialogSendMailApproveAgain = true
    },
    SendMailApproveAgainFunc() {
      if (this.ChooseSendMail == null) {
        this.$swal.fire({
          timer: 1500,
          showConfirmButton: false,
          icon: 'error',
          title: 'พบข้อผิดพลาด ไม่สามารถส่งอีเมลได้ โปรดลองอีกครั้ง'
        }, 1500)
        this.dialogSendMailApproveAgain = false
        this.dialogMasterApprove2 = false
        this.ChooseSendMail = null
      } else {
        this.initApproveMasterByType({
          type: this.sendApprove
        }).then(res => {
          if (res) {
            if (this.ChooseSendMail == '1') {
              this.SendMailApprove2()
            } else {
              this.SendMailApprove3()
            }
            this.$swal.fire({
              timer: 1500,
              showConfirmButton: false,
              icon: 'success',
              title: 'ส่งอีเมลไปยังผู้มีอำนาจอนุมัติ สำหรับโครงการ ' + this.Project.Project_name + '  สำเร็จ!!'
            }, 1500)
            this.dialogSendMailApproveAgain = false
            this.dialogMasterApprove2 = false
            this.ChooseSendMail = null
          }
        })
      }
    },
    SendOtherApproveFunc() {
      if (this.typePermiss == this.sendApprove) {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด ไม่สามารถส่งต่อข้อมูลผู้อนุมัติเดิมได้ !!'
        })
      } else {
        this.$swal.fire({
          title: 'ยืนยันการทำรายการ',
          text: "คุณต้องการส่งต่อข้อมูลเสนอแผนขออนุมัติงบประมาณประจำปี " + this.Project.Project_name + ' ใช่หรือไม่ ??',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.value) {
            if (this.sendApprove != null) {
              const headerAxios = {
                headers: {
                  'Content-Type': 'application/json'
                }
              }
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.Project.Project_code, {
                Project_category: this.sendApprove
              }, headerAxios).then(res => {
                if (res.data.status) {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_Send_Approve', {
                    Project_code: this.Project.Project_code,
                    Project_type_old: this.Project.Project_type,
                    Project_type_new: this.sendApprove,
                    Remark: this.RemarkSendApprove,
                    Create_By: this.MeData[0].perid
                  }, {
                    headers: {
                      'Content-Type': 'application/json',
                      'X-REST-METHOD': 'PUT'
                    }
                  })
                  this.initApproveMasterByType({
                    type: this.sendApprove
                  }).then(res => {
                    if (res) {
                      if (this.ApproveMaster.length > 0) {
                        var SendMailApprove = this.ApproveMaster.filter(Approveitem => Approveitem.type == this.sendApprove && Approveitem.sendmail == '1' && (Approveitem.Approve_Project_Type_Ms == '1' || Approveitem.Approve_Project_Type_Ms == '9') && Approveitem.readonly == '0')
                        if (SendMailApprove.length > 0) {
                          SendMailApprove.map(SendMailI => {
                            this.SendOtherApproveMail(SendMailI, this.RemarkSendApprove)
                          })
                        }
                      }
                      setTimeout(() => {
                        this.$swal.fire({
                          timer: 1500,
                          showConfirmButton: false,
                          icon: 'success',
                          title: 'ส่งต่อข้อมูลแผน  ' + this.Project.Project_name + '  สำเร็จ!!'
                        }, 1500)
                        this.dialogSendApprove = false
                        this.init()
                      })
                    }
                  })
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาดไม่สามารถทำรายการได้ โปรดลองอีกครั้ง'
                  })
                }
              })
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาดไม่สามารถทำรายการได้ โปรดลองอีกครั้ง'
              })
            }
          }
        })
      }
    },
    SendNextApprove() {
      if (this.sendApprovePerson.length > 0) {
        this.tabMenu == '0' ? this.ConsideProject(true) : this.ConsideReqEditProject(true)
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถทำรายการได้ กรุณาเลือกผู้มีอำนาจอนุมัติ'
        })
      }
    },
    SendNextApprove2() {
      if (this.sendApprovePerson.length > 0) {
        this.SendMailApproveAgainFunc()
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถทำรายการได้ กรุณาเลือกผู้มีอำนาจอนุมัติ'
        })
      }
    },
    SendMailApprove() {
      this.AllApproveMaster.map(App_item => {
        for (var i = 0; i <= this.sendApprovePerson.length; i++) {
          if (App_item.id == this.sendApprovePerson[i] && App_item.sendmail == '1' && App_item.readonly == '0') {
            axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
              perid_admin: App_item.perid,
              perid: this.MeData[0].perid,
              headerName: this.Process == '1' ? (this.tabMenu == '0' ? 'แจ้งเตือนการพิจารณาแผนอนุมัติงบประมาณประจำปี ' : 'แจ้งเตือนการพิจารณาขอแก้ไขแผนอนุมัติงบประมาณประจำปี ') + this.Project.Project_name + ' (' + this.Project.Project_code + ')' : 'แจ้งเตือนการพิจารณาคำขอเดินทางไปราชการ : ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')',
              header: this.Project.Project_name + ' (' + this.Project.Project_code + ')',
              body: this.Process == '1' ? '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project.Project_name + ' (' + this.Project.Project_code + ') ' + (this.Approve_m == '10' ? 'ได้ถูกเสนอพิจารณาอนุมัติแล้ว' : 'ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว') + ' </p> ' +
                  '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project.Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                  '<hr style="margin-top: 50px;">' +
                  '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                  '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>' :
                  '<p style="font-size: 25px;color: #364eff;font-weight: bold">เดินทางไปราชการ :  ' + this.Project.Project_name + ' (' + this.Project.Project_code + ') ' + (this.Approve_m == '10' ? 'ได้ถูกเสนอพิจารณาอนุมัติแล้ว' : 'ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว') + ' </p> ' +
                  '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project.Project_code + '"> พิจารณาการเดินทางไปราชการ  </a> </p> ' +
                  '<hr style="margin-top: 50px;">' +
                  '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                  '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
            }), {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              }
            })

            if (this.Approve_m == '11' || this.Project.IsPlanStatus == '11') {
              if (App_item.psu_passport != null && App_item.psu_passport != '') {
                this.SendGMail({
                  email: App_item.psu_passport,
                  headerName: this.Process == '1' ? 'แจ้งเตือนการพิจารณาแผนอนุมัติงบประมาณประจำปี' : 'แจ้งผลการพิจารณาการเดินทางไปราชการ',
                  header: this.Project.Project_name + ' (' + this.Project.Project_code + ')',
                  body: this.Process == '1' ? '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')' + ' ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว </p> ' +
                      '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project.Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                      '<hr style="margin-top: 50px;">' +
                      '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                      '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>' :
                      '<p style="font-size: 25px;color: #364eff;font-weight: bold">เดินทางไปราชการ :   ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')' + ' ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว </p> ' +
                      '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project.Project_code + '"> พิจารณาการเดินทางไปราชการ </a> </p> ' +
                      '<hr style="margin-top: 50px;">' +
                      '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                      '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
                })
              }
              this.SendGMail({
                email: 'thawatchai.j@psu.ac.th',
                headerName: this.Process == '1' ? '(สำเนา) แจ้งเตือนการพิจารณาแผนอนุมัติงบประมาณประจำปี' : '(สำเนา) แจ้งผลการพิจารณาการเดินทางไปราชการ',
                header: this.Project.Project_name + ' (' + this.Project.Project_code + ')',
                body: this.Process == '1' ? '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')' + ' ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว </p> ' +
                    '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project.Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                    '<hr style="margin-top: 50px;">' +
                    '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                    '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>' :
                    '<p style="font-size: 25px;color: #364eff;font-weight: bold">เดินทางไปราชการ :  ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')' + ' ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว </p> ' +
                    '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project.Project_code + '"> พิจารณาการเดินทางไปราชการ </a> </p> ' +
                    '<hr style="margin-top: 50px;">' +
                    '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                    '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
              })

              /*if (this.Project.Project_category == '1') {
                this.SendGMail({
                  email: 'hrdalert2u@gmail.com',
                  headerName: '(สำเนา) แจ้งเตือนการพิจารณาแผนอนุมัติงบประมาณประจำปี',
                  header: this.Project.Project_name + ' (' + this.Project.Project_code + ')',
                  body: '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')' + ' ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว </p> ' +
                      '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + App_item.position + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project.Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                      '<hr style="margin-top: 50px;">' +
                      '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                      '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                })
              }*/
            }
          }
        }
      })
    },
    SendOtherApproveMail(obj, remark) {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: obj.perid,
        perid: this.Project.Create_By,
        headerName: 'แจ้งเตือนการส่งต่อข้อมูลการอนุมัติแผนตั้งงบประมาณประจำปี ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')',
        header: this.Project.Project_name + ' (' + this.Project.Project_code + ')',
        body: '<p style="font-size: 25px;color: peru;font-weight: bold">มีการส่งต่อข้อมูลการอนุมัติแผนตั้งงบประมาณประจำปี ชื่อแผน: ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')' + '</p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> เหตุผล <span style="margin: 0px 10px 10px 0px;font-weight: bold">' + remark + '</span></p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">ผู้มีอำนาจพิจารณาแผนตั้งงบ</span> โปรดพิจารณาในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project.Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    SendMailApprove2() {
      this.AllApproveMaster.map(App_item => {
        for (var i = 0; i <= this.sendApprovePerson.length; i++) {
          if (App_item.id == this.sendApprovePerson[i] && App_item.sendmail == '1' && App_item.readonly == '0') {
            axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
              perid_admin: App_item.perid,
              perid: this.MeData[0].perid,
              headerName: this.Process == '1' ? 'แจ้งเตือนการพิจารณาข้อมูลเสนอแผนตั้งงบประมาณประจำปี ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')' : 'แจ้งเตือนการพิจารณาการเดินทางไปราชการ ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')',
              header: this.Project.Project_name + ' (' + this.Project.Project_code + ')',
              body: this.Process == '1' ? '<p style="font-size: 25px;color: peru;font-weight: bold">มีการเสนอแผนตั้งงบเข้ามาใหม่ ชื่อแผน: ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')' + '</p> ' +
                  '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">ผู้มีอำนาจพิจารณาแผนตั้งงบ</span> โปรดพิจารณาในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project.Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                  '<hr style="margin-top: 50px;">' +
                  '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                  '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>' :
                  '<p style="font-size: 25px;color: peru;font-weight: bold">เดินทางไปราชการ : ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')' + '</p> ' +
                  '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">ผู้มีอำนาจพิจารณา</span> โปรดพิจารณาในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project.Project_code + '"> พิจารณาการเดินทางไปราชการ </a> </p> ' +
                  '<hr style="margin-top: 50px;">' +
                  '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                  '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
            }), {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              }
            })
          }
        }
      })
    },
    SendMailApprove3() {
      this.AllApproveMaster.map(App_item => {
        for (var i = 0; i <= this.sendApprovePerson.length; i++) {
          if (App_item.id == this.sendApprovePerson[i] && App_item.sendmail == '1' && App_item.readonly == '0') {
            axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
              perid_admin: App_item.perid,
              perid: this.MeData[0].perid,
              headerName: this.Process == '1' ? (this.tabMenu == '0' ? 'แจ้งเตือนการพิจารณาแผนอนุมัติงบประมาณประจำปี ' : 'แจ้งเตือนการพิจารณาขอแก้ไขแผนอนุมัติงบประมาณประจำปี ') + this.Project.Project_name + ' (' + this.Project.Project_code + ')' : 'แจ้งเตือนการพิจารณาการเดินทางไปราชการ ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')',
              header: this.Project.Project_name + ' (' + this.Project.Project_code + ')',
              body: this.Process == '1' ? '<p style="font-size: 25px;color: #364eff;font-weight: bold">แผนประจำปี ' + this.Project.Project_name + ' (' + this.Project.Project_code + ') ' + (this.ChooseSendMail == '2' ? 'ได้ถูกเสนอพิจารณาอนุมัติแล้ว' : 'ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว') + ' </p> ' +
                  '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + (this.ChooseSendMail == '1' ? ' ผู้มีอำนาจพิจารณาแผนตั้งงบ' : App_item.position) + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project.Project_code + '"> พิจารณาแผนตั้งงบประมาณประจำปี (โดยผู้มีอำนาจอนุมัติ) </a> </p> ' +
                  '<hr style="margin-top: 50px;">' +
                  '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                  '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>' :
                  '<p style="font-size: 25px;color: #364eff;font-weight: bold">เดินทางไปราชการ ' + this.Project.Project_name + ' (' + this.Project.Project_code + ') ' + (this.ChooseSendMail == '2' ? 'ได้ถูกเสนอพิจารณาอนุมัติแล้ว' : 'ได้ถูกเสนอพิจารณาอนุมัติ (ขั้นต้น) แล้ว') + ' </p> ' +
                  '<p style="margin-top: 25px;font-size: 16px;"> เรียน <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">' + (this.ChooseSendMail == '1' ? ' ผู้มีอำนาจพิจารณา' : App_item.position) + '</span> โปรดพิจารณาแผนในลำดับถัดไป ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/ApproveProject/' + this.Project.Project_code + '"> พิจารณาการเดินทางไปราชการ) </a> </p> ' +
                  '<hr style="margin-top: 50px;">' +
                  '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                  '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
            }), {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              }
            })
          }
        }
      })
    },
    ShowDetail(item) {
      this.dialogLoading = true
      this.e1 = '1'
      this.tabMenu = '1'
      this.Expense = 0
      this.episode = null

      this.files = []
      this.Coordinator = []
      this.courseCondi = []
      this.competency_DataForSubmit = []
      this.expense_DataForSubmit = []
      this.expense_p_DataForSubmit = []
      this.FileProject = []
      this.DataCondi = []
      this.JoinPerson = []
      this.selection = []
      this.logSelection = []
      this.budgetData = []
      this.Lecturer = []
      this.TemplateProject = []
      this.DepQuotaData = []
      this.RecordData = []
      this.RecordDataDump = []
      this.TempRecordData = []
      this.FileProjectOld = []
      this.FileProject = []
      this.Project = null
      this.ProjectBefore = null
      this.LogObjProject = null

      this.editorData = ''
      this.dateApprove = ALlFunc.getDateNow()
      this.Approve_m = null
      this.remarksApprove = ''
      this.JoinTravel = []

      this.Details_Cordi = true
      this.Project = item
      this.ProjectBefore = this.tab == '0' ? item : this.planProjectForApprove.filter(itemPlan => itemPlan.Project_code == item.Project_code).length > 0 ? this.planProjectForApprove.filter(itemPlan => itemPlan.Project_code == item.Project_code)[0] : null
      this.LogObjProject = item
      this.Project_code = item.Project_code
      this.Project_name = item.Project_name
      this.Course_code = item.Course_code
      this.course_group = item.Course_group
      this.Period_code = item.Period_code
      this.Project_type = item.Project_type
      this.Objective = item.Objective
      this.TargetGroup = item.TargetGroup
      this.IsProcess = item.IsProcess
      this.Project_category = item.Project_category
      this.Remarks = item.Remarks
      this.CalCredit = '' + item.CalCredit
      this.CalHourse = '' + item.CalHourse
      this.PLACE = item.PLACE
      this.Province_id = item.Province_id
      this.Country_id = item.Country_id
      this.BudgetRequest = item.BudgetRequest
      this.Location = item.Location
      this.WorkBy = item.WorkBy
      this.WorkByName = item.WorkByName
      this.WorkByPhone = item.WorkByPhone
      this.episode = item.DatePeriod
      this.DateStart = item.DateStart
      this.DateEnd = item.DateEnd
      this.DepSelect = item.Dep_Code
      this.Project_group = item.Project_group
      this.FiscalYear = parseInt(item.FiscalYear)
      this.IsPlan = item.IsPlan
      this.IsPlanStatus = item.IsPlanStatus
      this.itemCode = item.Item_Code
      this.Status = item.Status
      this.Approve = item.Approve

      this.ChooseTypeDep = item.Approve
      this.ChooseTypRegis = item.Status_Reg
      this.ChooseTypRegis2 = item.Status_Type_Reg
      this.dateRegStart = item.DateS_Reg
      this.dateRegEnd = item.DateE_Reg
      this.ProjectQuotaCount = item.Count_Reg
      var checkMatch = false

      this.SumAllowance = 0
      this.SumAccommodationCost = 0
      this.SumShippingCosts = 0
      this.SumRegistrationFee = 0
      this.SumAllTravelExpenses = 0

      if (item.Status_Count_Reg == '0') {
        this.ChkJoinPerson = false
      } else {
        this.ChkJoinPerson = true
      }

      if (this.ApproveMaster.length > 0) {
        if (this.ApproveMaster.filter(appMs => appMs.type == this.typePermiss && appMs.Approve_Project_Type_Ms == '1' && appMs.readonly == '0').length > 0) {
          this.Approve_Status.map(app_i => {
            if (app_i.id == '4' || app_i.id == '10') {
              app_i.disable = false
            }
          })
          this.Req_Approve_Status.map(app_i => {
            if (app_i.id == '3') {
              app_i.disable = false
            }
          })
        }
        if (this.ApproveMaster.filter(appMs => appMs.type == this.typePermiss && appMs.Approve_Project_Type_Ms == '2' && appMs.readonly == '0').length > 0) {
          this.Approve_Status.map(app_i => {
            if (app_i.id == '3' || app_i.id == '4' || app_i.id == '11') {
              app_i.disable = false
            }
          })
          this.Req_Approve_Status.map(app_i => {
            if (app_i.id == '2' || app_i.id == '4') {
              app_i.disable = false
            }
          })
        }
        if (this.ApproveMaster.filter(appMs => appMs.type == this.typePermiss && appMs.Approve_Project_Type_Ms == '3' && appMs.readonly == '0').length > 0) {
          this.Approve_Status.map(app_i => {
            if (app_i.id == '2' || app_i.id == '3' || app_i.id == '4') {
              app_i.disable = false
            }
          })
          this.Req_Approve_Status.map(app_i => {
            if (app_i.id == '1' || app_i.id == '2') {
              app_i.disable = false
            }
          })
        }
        if (this.ApproveMaster.filter(appMs => appMs.type == this.typePermiss && appMs.Approve_Project_Type_Ms == '9' && appMs.readonly == '0').length > 0) {
          this.Approve_Status.map(app_i => {
            app_i.disable = false
          })
          this.Req_Approve_Status.map(app_i => {
            app_i.disable = false
          })
        }
      } else {
        this.Approve_Status.map(app_i => {
          app_i.disable = true
        })
        this.Req_Approve_Status.map(app_i => {
          app_i.disable = true
        })
      }

      // this.showCompetency(item)


      this.SelProjectGroup()
      this.getCourseType()
      this.getCompetency()
      this.initLogProject({
        Project_code: this.Project_code
      })
      this.initJoinTravel({
        Project_code: this.Project_code
      }).then(res => {
        if (res) {
          this.JoinTravelRes.map((item) => {
            checkMatch = false
            this.staffData.map(staff_i => {
              if (staff_i.perid == item.uid) {
                checkMatch = true
                this.JoinTravel.push({
                  ...item,
                  ...staff_i,
                  idx: this.JoinTravel.length + 1,
                  full_Name: item.full_name,
                  customTravelDetail: '<p style="font-weight: bold">' + (item.prefix == null || item.prefix == '' ? '' : item.prefix + " ") + item.full_name + '</p>' +
                      '<p style="font-weight: bold">ตำแหน่ง: ' + item.position + '</p>',
                  AllTravelExpenses: parseFloat(item.Allowance) + parseFloat(item.AccommodationCost) + parseFloat(item.ShippingCosts) + parseFloat(item.RegistrationFee),
                  Lecturer: this.Lecturer.length > 0 ? this.Lecturer.filter(lecI => lecI.perid == item.uid).length > 0 ? this.Lecturer.filter(lecI => lecI.perid == item.uid) : null : null,
                  files: [],
                  idCard: item.id_card,
                  status_reg: item.join_status
                })
              }
            })
            if (!checkMatch) {
              this.JoinTravel.push({
                ...item,
                idx: this.JoinTravel.length + 1,
                full_Name: item.full_name,
                customTravelDetail: '<p style="font-weight: bold">' + (item.prefix == null || item.prefix == '' ? '' : item.prefix + " ") + item.full_name + '</p>' +
                    '<p style="font-weight: bold">ตำแหน่ง: ' + item.position + '</p>',
                AllTravelExpenses: parseFloat(item.Allowance) + parseFloat(item.AccommodationCost) + parseFloat(item.ShippingCosts) + parseFloat(item.RegistrationFee),
                Lecturer: this.Lecturer.length > 0 ? this.Lecturer.filter(lecI => lecI.perid == item.uid).length > 0 ? this.Lecturer.filter(lecI => lecI.perid == item.uid) : null : null,
                files: [],
                idCard: item.id_card,
                status_reg: item.join_status
              })
            }
          })
          if (this.JoinTravel.length > 0) {
            this.JoinTravel.map((item, idx) => {
              item.idx = (this.JoinTravel.length - (idx + 1)) + 1
              this.SumAllowance += parseFloat(item.Allowance)
              this.SumAccommodationCost += parseFloat(item.AccommodationCost)
              this.SumShippingCosts += parseFloat(item.ShippingCosts)
              this.SumRegistrationFee += parseFloat(item.RegistrationFee)
              this.SumAllTravelExpenses += parseFloat(item.Allowance) + parseFloat(item.AccommodationCost) + parseFloat(item.ShippingCosts) + parseFloat(item.RegistrationFee)
            })
          }
        }
      })

      this.initProjectExpenseData({
        Project_code: this.Project_code
      }).then(res => {
        if (res) {
          this.ProjectExpense.map(ProjectEx => {
            this.expense_Data.map(expenseData => {
              if (ProjectEx.Expense_id == expenseData.Expense_id) {
                this.budgetData.push({
                  Expense_id: expenseData.Expense_id,
                  Expense_des: expenseData.Expense_des,
                  ReqMoney: ProjectEx.ReqMoney,
                  Rm: ProjectEx.Rm
                })
                this.Expense += parseFloat(ProjectEx.ReqMoney)
              }
            })

          })
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/quata_dep_reg/Project_code/' + this.Project_code).then(res => {
        if (res.data) {
          var type = ''
          if (res.data.length > 0) {
            this.projectNeed = true
            res.data.map((item_qua) => {
              type = ''
              if (item_qua.dep_type == '0') {
                type = 'หน่วยงาน/ภาควิชา'
              } else {
                type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
              }
              this.DepQuotaData.push({
                quotaType: item_qua.dep_type,
                type: type,
                type_id: item_qua.dep_type,
                dep_name: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_name,
                dep_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_id,
                dep_group_id: this.depart.filter(item => item.dep_id == item_qua.dep_id)[0].dep_group_id,
                count: item_qua.count
              })
            })
          } else {
            this.projectNeed = true
            type = ''
            if (res.data.dep_type == '0') {
              type = 'หน่วยงาน/ภาควิชา'
            } else {
              type = 'กลุ่มหน่วยงาน/กลุ่มภาควิชา'
            }
            this.DepQuotaData.push({
              quotaType: res.data.dep_type,
              type: type,
              type_id: res.data.dep_type,
              dep_name: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_name,
              dep_id: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_id,
              dep_group_id: this.depart.filter(item => item.dep_id == res.data.dep_id)[0].dep_group_id,
              count: res.data.count
            })
          }

          if (this.DepQuotaData.length > 0) {
            this.DepQuotaData.map(item_dep_q => {
              this.ProjectQuotaDepCount += parseInt(item_dep_q.count)
            })
          }
        } else {
          this.projectNeed = false
          this.DepQuotaData = []
        }
      })


      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Project_code/' + item.Project_code).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.projectNeed = true
            this.WorkGroupData = res.data
          } else {
            this.projectNeed = true
            this.WorkGroupData.push(res.data)
          }

          if (this.WorkGroupData.length > 0) {
            this.WorkGroupData.map(item_w => {
              this.getTrainFiles(item_w.Ref_id).then(res => {
                item_w.files = res
              })
            })
          }
        } else {
          this.projectNeed = false
          this.WorkGroupData = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/TemplateProject/Project_code/' + item.Project_code).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.projectNeed = true
            this.TemplateProject = res.data
          } else {
            this.projectNeed = true
            this.TemplateProject.push(res.data)
          }
          if (this.TemplateProject.length > 0) {
            this.editorDataFormDB = this.TemplateProject[0].Template
            this.editorData = this.editorDataFormDB.replaceAll('&quot;', '"')
          }
        } else {
          this.projectNeed = false
          this.TemplateProject = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_D_project_record_view/Project_code/' + item.Project_code + '/?sort=id_DESC').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.TempRecordData = res.data
          } else {
            this.TempRecordData.push(res.data)
          }
        } else {
          this.TempRecordData = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record_view/Project_code/' + item.Project_code + '/?sort=id_DESC').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.RecordData = res.data
          } else {
            this.RecordData.push(res.data)
          }
          this.RecordData.map(item => {
            item.files = []
          })
          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/active/1/Project_code/' + item.Project_code + '/?sort=id_DESC').then(res => {
            if (res.data) {
              this.dialogLoading = false
              // var files_Project = []
              if (res.data.length > 0) {
                res.data.map(file_i => {
                  this.RecordData.map(record_i => {
                    if (record_i.Project_code == file_i.Project_code && record_i.id == file_i.project_record_id) {
                      record_i.files.push(file_i)
                    }
                  })
                })
              } else {
                this.dialogLoading = false
                this.RecordData.map(record_i => {
                  if (record_i.Project_code == res.data.Project_code && record_i.id == res.data.project_record_id) {
                    record_i.files.push(res.data)
                  }
                })
              }
              this.RecordDataDump = this.RecordData
            } else {
              this.dialogLoading = false
              this.RecordDataDump = this.RecordData
            }
          })
        } else {
          this.dialogLoading = false
          this.RecordData = []
          this.RecordDataDump = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level_view/Project_code/' + item.Project_code).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            this.DataCondi = res.data
          } else {
            this.DataCondi.push(res.data)
          }
          if (this.DataCondi.length > 0) {
            this.DataCondi.map(item => {
              item.workAgeStart = item.WSYear
              item.workAgeEnd = item.WEYear
            })
          }
        } else {
          this.DataCondi = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_need_view/Project_code/' + item.Project_code).then(res => {
        if (res.data) {

          if (res.data.length > 0) {
            this.courseCondi = res.data
          } else {
            this.courseCondi.push(res.data)
          }
        } else {
          this.courseCondi = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_committee/Project_code/' + item.Project_code).then(res => {
        if (res.data) {

          if (res.data.length > 0) {
            this.Coordinator = res.data
          } else {
            this.Coordinator.push(res.data)
          }

          this.Committee_ToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code != '6')
          this.LecturerToShow = this.Coordinator.filter(itemLecturer => itemLecturer.Committee_code == '6')
          if (this.Committee_ToShow.length > 0) {
            this.Committee_ToShow.map(item => {
              item.Committee_des = this.committee_Posi.filter(commit_i => commit_i.Committee_code == item.Committee_code)[0].committee_des
            })
          }
          if (this.LecturerToShow.length > 0) {
            this.LecturerToShow.map(item => {
              item.Committee_des = this.committee_Posi.filter(commit_i => commit_i.Committee_code == item.Committee_code)[0].committee_des
            })
          }
        } else {
          this.projectNeed = false
          this.Coordinator = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/active/1/Type/0/Project_code/' + item.Project_code).then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map((f_item) => {
              switch (f_item.File_type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.FileProject.push({
                    ...f_item,
                    name: f_item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + f_item.File_path,
                    path: f_item.File_path,
                    type: 'image',
                    type_Img: f_item.File_type
                  })
                  break
                case 'application/pdf':
                  this.FileProject.push({
                    ...f_item,
                    name: f_item.File_name,
                    src: ConstData.ConnectionHost + '/rest/files' + f_item.File_path,
                    path: f_item.File_path,
                    type: 'pdf',
                    type_Img: f_item.File_type
                  })
                  break
                default:
                  break
              }
            })
          } else {
            switch (res.data.File_type) {
              case 'image/jpg':
              case 'image/jpeg':
              case 'image/gif':
              case 'image/bmp':
              case 'image/png':
                this.FileProject.push({
                  ...res.data,
                  name: res.data.File_name,
                  src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
                  path: res.data.File_path,
                  type: 'image',
                  type_Img: res.data.File_type
                })
                break
              case 'application/pdf':
                this.FileProject.push({
                  ...res.data,
                  name: res.data.File_name,
                  src: ConstData.ConnectionHost + '/rest/files' + res.data.File_path,
                  path: res.data.File_path,
                  type: 'pdf',
                  type_Img: res.data.File_type
                })
                break
              default:
                break
            }
          }
          this.FileProjectOld = [...this.FileProject]
        } else {
          this.FileProject = []
        }
      })

      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/join_project/Project_code/' + item.Project_code + '/active/1').then(res => {
        if (res.data) {
          if (res.data.length > 0) {
            res.data.map((item) => {
              this.JoinPerson.push({
                ...item,
                full_Name: item.name + ' ' + item.sname,
                idCard: item.id_card,
              })
            })
          } else {
            this.JoinPerson.push({
              ...res.data,
              full_Name: res.data.name + ' ' + res.data.sname,
              idCard: res.data.id_card,
            })
          }
        } else {
          this.JoinPerson = []
        }
      })
    },
    Project_proposal(item) {
      this.CheckPermission().then(res => {
        if (res) {
          this.proposal = []
          this.proposal = item
          this.dialogProposal = true
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    CancelProject() {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "คุณต้องการยกเลิกแผนใช่หรือไม่ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.btnDisable = true
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.D_Project.Project_code, {
            IsPlanStatus: '9',
            Update_By: this.MeData[0].perid,
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(res => {
            if (res.data.status) {
              this.btnDisable = false
              this.$swal.fire({
                icon: 'success',
                title: 'บันทึกข้อมูลสำเร็จ'
              })
              this.SendCancelMail()
              this.init()
              this.Details_Cordi = false
            } else {
              this.btnDisable = false
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้สำเร็จโปรดติดต่อผู้ดูแลระบบ'
              })
            }
          }).catch(res => {
            if (res) {
              this.btnDisable = false
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด ไม่สามารถทำรายการได้สำเร็จโปรดติดต่อผู้ดูแลระบบ'
              })
            }
          })
        }
      })
    },
    UpdateProject() {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการยืนยันแก้ไขข้อมูล",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.btnDisable = true
          this.CheckPermission().then(resPermiss => {
            if (resPermiss) {
              if (this.Project_code == '' || this.Project_name == '' || this.Project_group == '' || this.PLACE == ''
                  || this.WorkBy == '' || this.WorkByName == '' || this.WorkByPhone == '' || this.DateStart == '' || this.DateEnd == '' || this.BudgetRequest == ''
                  || this.CalCredit == '' || this.CalHourse == '' || this.DepSelect == null || this.TargetGroup == '' || this.Objective == '' || (this.IsPlan == '' || this.IsPlan == null) || (this.Project_category == '' || this.Project_category == null) || (this.Project_type == '' || this.Project_type == null) || (this.Project_type == '2' && (this.IsProcess != '' && this.IsProcess != null))) {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'โปรดกรอกข้อมูลให้ครบถ้วน',
                })
                this.btnDisable = false
              } else if (this.episode == null) {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'ระยะเวลาที่คาดว่าจะจัด ห้ามว่าง',
                })
                this.btnDisable = false
              }
              /*else if (this.Project_group == '101' || this.Project_group == '102' || this.Project_group == '103' || this.Project_group == '104') {
                if (this.Course_code == '0000000' || this.Course_code == '') {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: 'เลือกประเภทโครงการ : จัดบริหารวิชาการ,จัดพัฒนาบุคลากร เงื่อนไขหลักสูตรต้องห้ามว่าง',
                  })
                  this.btnDisable = false
                } else {
                  this.updateData()
                }
              } */
              else if (this.PLACE == '2' && this.Province_id == '') {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'โปรดกรอกข้อมูลจังหวัด',
                })
                this.btnDisable = false
              } else if (this.PLACE == '3' && this.Country_id == '') {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'โปรดกรอกข้อมูลประเทศ',
                })
                this.btnDisable = false
              } else if (this.selection.length == 0) {
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด',
                  text: 'โปรดเลือก ค่า Competency,Core Value,Strategic Objective ก่อนบันทึกข้อมูล',
                })
                this.btnDisable = false
              } else if (this.selection.length > 0) {
                if (this.Project_category == '1' && !this.CompetencyData[0].checkCordi && !this.CompetencyData[2].checkCordi) {
                  this.updateData()
                } else if (this.Project_category != '1' && !this.CompetencyData[2].checkCordi) {
                  this.updateData()
                } else {
                  this.$swal.fire({
                    icon: 'error',
                    title: 'พบข้อผิดพลาด',
                    text: this.Project_category == '1' ? 'โปรดตรวจสอบ ข้อมูล Competency และ Strategic Objective' : 'โปรดตรวจสอบ ข้อมูล Strategic Objective',
                  })
                  this.btnDisable = false
                }
              } else {
                this.updateData()
              }
            } else {
              this.btnDisable = length
              this.$swal.fire({
                icon: 'error',
                title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
              })
            }
          })
        }
      })
    },
    updateData() {
      var Ref_id_edit = this.getRandomFileName()
      if (this.TypeCreateProject == '1') {
        this.D_Project.Project_code = this.ProjectPlan
      } else {
        this.D_Project.Project_code = this.Project_code
      }
      this.D_Project.Project_name = this.Project_name
      this.courseData.map((item) => {
        if (item.Course_code == this.Course_code) {
          this.D_Project.Course_code = item.Course_code
          this.D_Project.course_group = item.Course_group
        }
      })
      this.D_Project.Project_group = this.Project_group
      this.D_Project.IsProcess = this.IsProcess
      this.D_Project.Project_category = this.Project_category
      this.D_Project.Objective = this.Objective
      this.D_Project.TargetGroup = this.TargetGroup
      this.D_Project.Project_type = this.Project_type
      this.D_Project.Remarks = this.Remarks
      this.D_Project.CalCredit = '' + this.CalCredit
      this.D_Project.CalHourse = '' + this.CalHourse
      this.D_Project.PLACE = this.PLACE
      this.D_Project.Province_id = this.Province_id
      this.D_Project.Country_id = this.Country_id
      this.D_Project.BudgetRequest = this.BudgetRequest
      this.D_Project.BudgetArrove = this.Project.BudgetArrove
      this.D_Project.MoneyDisburse = this.Project.MoneyDisburse
      this.D_Project.Location = this.Location
      this.D_Project.WorkBy = this.WorkBy
      this.D_Project.WorkByName = this.WorkByName
      this.D_Project.WorkByPhone = this.WorkByPhone
      this.D_Project.DatePeriod = this.episode
      this.D_Project.DateStart = this.DateStart
      this.D_Project.DateEnd = this.DateEnd
      this.D_Project.Approve = this.Approve
      this.D_Project.FiscalYear = this.FiscalYear
      this.D_Project.IsPlan = this.IsPlan
      this.D_Project.IsPlanStatus = this.IsPlanStatus
      this.D_Project.Status_Reg = this.ChooseTypRegis
      this.D_Project.Status_Type_Reg = this.ChooseTypRegis2
      this.D_Project.DateS_Reg = this.dateRegStart
      this.D_Project.DateE_Reg = this.dateRegEnd
      if (this.ChkJoinPerson) {
        this.D_Project.Status_Count_Reg = '1'
      } else {
        this.D_Project.Status_Count_Reg = '0'
      }
      this.D_Project.Count_Reg = this.ProjectQuotaCount
      this.D_Project.Dep_Code = this.DepSelect
      this.D_Project.Status = this.Status
      this.D_Project.Create_By = this.Project.Create_By
      this.D_Project.Create_Time = this.Project.Create_Time
      this.D_Project.Update_By = this.MeData[0].perid

      const headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.D_Project.Project_code, this.D_Project, headerAxios).then(async res => {
        if (res.data.status) {
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_Edit_Project/', {
            Ref_id: Ref_id_edit,
            Create_By: this.MeData[0].perid
          }, {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'PUT'
            }
          })
          axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project/', {
            Ref_id: Ref_id_edit,
            Project_code: this.LogObjProject.Project_code,
            Project_name: this.LogObjProject.Project_name,
            Course_code: this.LogObjProject.Course_code,
            course_group: this.LogObjProject.course_group,
            Project_type: this.LogObjProject.Project_type,
            WorkBy: this.LogObjProject.WorkBy,
            WorkByName: this.LogObjProject.WorkByName,
            WorkByPhone: this.LogObjProject.WorkByPhone,
            Location: this.LogObjProject.Location,
            DatePeriod: this.LogObjProject.DatePeriod,
            DateStart: this.LogObjProject.DateStart,
            DateEnd: this.LogObjProject.DateEnd,
            CalHourse: this.LogObjProject.CalHourse,
            CalCredit: this.LogObjProject.CalCredit,
            PLACE: this.LogObjProject.PLACE,
            Province_id: this.LogObjProject.Province_id,
            Country_id: this.LogObjProject.Country_id,
            Status: this.LogObjProject.Status,
            Remarks: this.LogObjProject.Remarks,
            ProjectLevel: this.LogObjProject.ProjectLevel,
            App_doc_no: this.LogObjProject.App_doc_no,
            BudgetRequest: this.LogObjProject.BudgetRequest,
            BudgetArrove: this.LogObjProject.BudgetArrove,
            MoneyDisburse: this.LogObjProject.MoneyDisburse,
            Project_group: this.LogObjProject.Project_group,
            IsProcess: this.LogObjProject.IsProcess,
            Project_category: this.LogObjProject.Project_category,
            Objective: this.LogObjProject.Objective,
            TargetGroup: this.LogObjProject.TargetGroup,
            Approve: this.LogObjProject.Approve,
            FiscalYear: this.LogObjProject.FiscalYear,
            IsPlan: this.LogObjProject.IsPlan,
            IsPlanStatus: this.LogObjProject.IsPlanStatus,
            Status_Reg: this.LogObjProject.Status_Reg,
            Status_Type_Reg: this.LogObjProject.Status_Type_Reg,
            DateS_Reg: this.LogObjProject.DateS_Reg,
            DateE_Reg: this.LogObjProject.DateE_Reg,
            Status_Count_Reg: this.LogObjProject.Status_Count_Reg,
            Count_Reg: this.LogObjProject.Count_Reg,
            Edit_type: '1',
            Dep_Code: this.LogObjProject.Dep_Code,
            Create_By: this.MeData[0].perid
          }, {
            headers: {
              'Content-Type': 'application/json',
              'X-REST-METHOD': 'PUT'
            }
          })
          this.DataCourse.Project_code = this.D_Project.Project_code
          await this.clearActiveData(this.D_Project.Project_code)

          if (this.FileProject.length > 0) {
            const headerAxiosPUT = {
              headers: {
                'Content-Type': 'application/json',
                'X-REST-METHOD': 'PUT'
              }
            }

            var Count = 0

            if (this.FileProject.length > 0) {
              this.FileProject.map((item) => {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files', {
                  Project_code: this.DataCourse.Project_code,
                  File_name: item.name,
                  File_path: item.path,
                  File_type: item.type_Img,
                  Type: '0'
                }, headerAxiosPUT).then(res => {
                  if (res.data.status) {
                    Count++
                    if (Count == this.FileProject.length) {
                      this.FileProject = []
                      this.files = []
                    }
                  }
                })
              })
            }
          }

          // Log D_project_files
          if (this.FileProjectOld.length > 0) {
            var countFileProject = 0
            this.FileProjectOld.map((item) => {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project_files', {
                Ref_id: Ref_id_edit,
                Project_code: this.Project_code,
                File_name: item.name,
                File_path: item.path,
                File_type: item.type_Img,
                Type: '0',
                Create_By: this.MeData[0].perid
              }, {
                headers: {
                  'Content-Type': 'application/json',
                  'X-REST-METHOD': 'PUT'
                }
              }).then(res => {
                if (res.data.status) {
                  countFileProject++
                  if (countFileProject == this.FileProjectOld.length) {
                    this.FileProjectOld = []
                  }
                }
              })
            })
          }

          // Log D_project_competency
          this.AddLogCompetency(Ref_id_edit)

          this.AddCompetency().then(res => {
            if (res) {

              this.SendEditMail()

              this.init()
              this.Details_Cordi = false

              this.$swal.fire({
                icon: 'success',
                title: 'แก้ไขข้อมูลสำเร็จ'
              })

              this.btnDisable = false

              this.e1 = '1'

              this.Project_code = ''
              this.Project_name = ''
              this.Course_code = '0000000'
              this.course_group = ''
              this.Project_type = ''
              this.Objective = ''
              this.TargetGroup = ''
              this.Project_group = ''
              this.IsProcess = null
              this.Project_category = null
              this.Remarks = ''
              this.WorkBy = ''
              this.Location = ''
              this.DateStart = ''
              this.DateEnd = ''
              this.CalHourse = '0'
              this.CalCredit = '0'
              this.PLACE = ''
              this.Province_id = ''
              this.BudgetRequest = ''
              this.ChooseTypeDep = '0'
              this.ChooseTypRegis = '1'
              this.ChooseTypRegis2 = '0'
              this.dateRegStart = ''
              this.dateRegEnd = ''
              this.ProjectQuotaCount = ''
              this.ProjectQuotaDepCount = 0
              this.MessageSuc = ''
              this.MessageError = ''
              this.ChkJoinPerson = true
              this.ShowAlertErr = false
              this.ShowAlertSuc = false
              this.Project_group = ''
              this.DepSelect = ''
              this.Period_code = ''
              this.editorData = ''
              this.FiscalYear = ''
              this.IsPlan = null
              this.IsPlanStatus = ''
              this.WorkByName = ''
              this.WorkByPhone = ''
              this.itemCode = ''
              this.txtAlert = []
              this.alert = false
            } else {
              this.$swal.fire({
                icon: 'error',
                title: 'พบข้อผิดพลาด',
                text: 'ไม่สามารถบันทึกข้อมูลได้',
              })
              this.Project_code = ''
              this.Project_name = ''
              this.Course_code = '0000000'
              this.course_group = ''
              this.Project_type = ''
              this.Project_group = ''
              this.Objective = ''
              this.TargetGroup = ''
              this.IsProcess = null
              this.Project_category = null
              this.Remarks = ''
              this.WorkBy = ''
              this.Location = ''
              this.DateStart = ''
              this.DateEnd = ''
              this.CalHourse = '0'
              this.CalCredit = '0'
              this.PLACE = ''
              this.Province_id = ''
              this.BudgetRequest = ''
              this.ChooseTypeDep = '0'
              this.ChooseTypRegis = '1'
              this.ChooseTypRegis2 = '0'
              this.dateRegStart = ''
              this.dateRegEnd = ''
              this.ProjectQuotaCount = ''
              this.ProjectQuotaDepCount = 0
              this.MessageSuc = ''
              this.MessageError = ''
              this.ChkJoinPerson = true
              this.ShowAlertErr = false
              this.ShowAlertSuc = false
              this.Project_group = ''
              this.DepSelect = ''
              this.Period_code = ''
              this.editorData = ''
              this.FiscalYear = ''
              this.IsPlan = null
              this.IsPlanStatus = ''
              this.WorkByName = ''
              this.WorkByPhone = ''
              this.itemCode = ''
              this.txtAlert = []
              this.alert = false
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'ไม่สามารถบันทึกข้อมูลได้',
          })
          this.Project_code = ''
          this.Project_name = ''
          this.Course_code = '0000000'
          this.course_group = ''
          this.Objective = ''
          this.TargetGroup = ''
          this.Project_group = ''
          this.Project_type = ''
          this.IsProcess = null
          this.Project_category = null
          this.Remarks = ''
          this.WorkBy = ''
          this.Location = ''
          this.DateStart = ''
          this.DateEnd = ''
          this.CalHourse = '0'
          this.CalCredit = '0'
          this.PLACE = ''
          this.Province_id = ''
          this.BudgetRequest = ''
          this.ChooseTypeDep = '0'
          this.ChooseTypRegis = '1'
          this.ChooseTypRegis2 = '0'
          this.dateRegStart = ''
          this.dateRegEnd = ''
          this.ProjectQuotaCount = ''
          this.ProjectQuotaDepCount = 0
          this.MessageSuc = ''
          this.MessageError = ''
          this.ChkJoinPerson = true
          this.ShowAlertErr = false
          this.ShowAlertSuc = false
          this.Project_group = ''
          this.DepSelect = ''
          this.Period_code = ''
          this.editorData = ''
          this.FiscalYear = ''
          this.IsPlan = null
          this.IsPlanStatus = ''
          this.WorkByName = ''
          this.WorkByPhone = ''
          this.itemCode = ''
          this.txtAlert = []
          this.alert = false
        }
      });
    },
    async clearActiveData(projectCode) {
      await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Project_code/' + projectCode, {
        active: '0',
        Update_By: this.MeData[0].perid
      }, this.headerAxios)
      await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/Project_code/' + projectCode, {
        active: '0',
        update_by: this.MeData[0].perid
      }, this.headerAxios)
    },
    SendEditMail() {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: this.Project.Create_By,
        perid: this.MeData[0].perid,
        headerName: 'แจ้งเตือนการแก้ไขข้อมูลเสนอแผนตั้งงบประมาณประจำปี ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')',
        header: this.Project.Project_name,
        body: '<p style="font-size: 25px;color: peru;font-weight: bold">มีการแก้ไขข้อมูลแผนใหม่โดยผู้มีอำนาจอนุมัติ ชื่อแผน: ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')</p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">สามารถตรวจสอบข้อมูลแผนได้</span> ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/Propose_a_plan/"> ขอเสนอแผนอนุมัติงบประมาณประจำปี </a> </p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    SendCancelMail() {
      axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
        perid_admin: this.Project.Create_By,
        perid: this.MeData[0].perid,
        headerName: 'แจ้งเตือนการยกเลิกแผนขออนุมัติงบประมาณประจำปี ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')',
        header: this.Project.Project_name,
        body: '<p style="font-size: 25px;color: peru;font-weight: bold">มีการยกเลิกแผนขออนุมัติงบประมาณประจำปีโดยผู้มีอำนาจอนุมัติ ชื่อแผน: ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')</p> ' +
            '<p style="margin-top: 25px;font-size: 16px;"> <span style="margin: 0px 10px 10px 0px;font-weight: bold;color: #42b983">สามารถตรวจสอบข้อมูลแผนได้</span> ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/Propose_a_plan/"> ขอเสนอแผนอนุมัติงบประมาณประจำปี </a> </p> ' +
            '<hr style="margin-top: 50px;">' +
            '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
            '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>'
      }), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
    },
    insertFileData(Project_code, Ref_id) {
      return new Promise(resolve => {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Type/0/active/1/Project_code/' + Project_code).then(res => {
          if (res.data) {
            const headerAxiosDel = {
              headers: {
                'Content-Type': 'application/json'
              }
            }
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files/Project_code/' + Project_code, {
              active: '0',
              Update_By: this.MeData[0].perid
            }, headerAxiosDel).then(res => {
              if (res.data.status) {
                this.initTempFileProject({
                  Ref_id: Ref_id
                }).then(res => {
                  if (res) {
                    if (this.TempFiles.length > 0) {
                      var Count = 0
                      this.TempFiles.map((item) => {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files', {
                          Project_code: Project_code,
                          File_name: item.File_name,
                          File_path: item.File_path,
                          File_type: item.File_type,
                          Type: '0'
                        }, {
                          headers: {
                            'Content-Type': 'application/json',
                            'X-REST-METHOD': 'PUT'
                          }
                        }).then(res => {
                          if (res.data.status) {
                            Count++
                            if (Count == this.TempFiles.length) {
                              resolve(true)
                            }
                          }
                        })
                      })
                    } else {
                      resolve(true)
                    }
                  } else {
                    resolve(true)
                  }
                }).catch(resCatch => {
                  if (resCatch) {
                    resolve(true)
                  }
                })
              } else {
                resolve(false)
              }
            })
          } else {
            this.initTempFileProject({
              Ref_id: Ref_id
            }).then(res => {
              if (res) {
                if (this.TempFiles.length > 0) {
                  var Count = 0
                  this.TempFiles.map((item) => {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files', {
                      Project_code: Project_code,
                      File_name: item.File_name,
                      File_path: item.File_path,
                      File_type: item.File_type,
                      Type: '0'
                    }, {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'PUT'
                      }
                    }).then(res => {
                      if (res.data.status) {
                        Count++
                        if (Count == this.TempFiles.length) {
                          resolve(true)
                        }
                      }
                    })
                  })
                }
              } else {
                resolve(true)
              }
            }).catch(resCatch => {
              if (resCatch) {
                resolve(true)
              }
            })
          }
        }).catch(resCatch => {
          if (resCatch) {
            resolve(false)
          }
        })
      })
    },
    insertLogFileData(Project_code, Ref_id) {
      return new Promise(resolve => {
        if (this.FileProject.length > 0) {
          var countFileProject = 0
          this.FileProject.map((item) => {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project_files', {
              Ref_id: Ref_id,
              Project_code: Project_code,
              File_name: item.name,
              File_path: item.path,
              File_type: item.type_Img,
              Type: '0',
              Create_By: this.MeData[0].perid
            }, {
              headers: {
                'Content-Type': 'application/json',
                'X-REST-METHOD': 'PUT'
              }
            }).then(res => {
              if (res.data.status) {
                countFileProject++
                if (countFileProject == this.FileProject.length) {
                  this.FileProject = []
                  resolve(true)
                }
              } else {
                resolve(false)
              }
            }).catch(resCatch => {
              if (resCatch) {
                resolve(false)
              }
            })
          })
        } else {
          resolve(true)
        }
      })
    },
    getRandomFileName() {
      var timestamp = new Date().toISOString().replace(/[-:.]/g, "");
      var random = ("" + Math.random()).substring(2, 8);
      var random_number = timestamp + random;
      return random_number;
    },
    AddLogCompetency(Ref_id_edit) {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      return new Promise(resolve => {
        if (this.logSelection.length > 0) {
          for (var i = 0; i <= this.logSelection.length - 1; i++) {
            this.CompetencyData.map(root => {
              if (root.children.length > 0) {
                root.children.map(child1 => {
                  if (child1.children.length > 0) {
                    child1.children.map(child2 => {
                      if (child2.id == this.logSelection[i]) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project_competency/', {
                          Ref_id: Ref_id_edit,
                          Project_code: this.DataCourse.Project_code,
                          DelvNo: child2.DelvNo,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()',
                        }, headerAxiosPUT)
                      }
                    })
                  }
                  if (child1.id == this.logSelection[i]) {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project_competency/', {
                      Ref_id: Ref_id_edit,
                      Project_code: this.DataCourse.Project_code,
                      DelvNo: child1.DelvNo,
                      create_by: this.MeData[0].perid,
                      create_time: 'now()',
                    }, headerAxiosPUT)
                  }
                })
              }
              if (root.id == this.logSelection[i]) {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project_competency/', {
                  Ref_id: Ref_id_edit,
                  Project_code: this.DataCourse.Project_code,
                  DelvNo: root.DelvNo,
                  create_by: this.MeData[0].perid,
                  create_time: 'now()',
                }, headerAxiosPUT)
              }
            })
          }
          this.logSelection = []
          resolve(true)
        } else {
          resolve(false)
        }
      })
    },
    AddCompetency() {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      return new Promise(resolve => {
        if (this.selection.length > 0) {
          for (var i = 0; i <= this.selection.length - 1; i++) {
            this.CompetencyData.map(root => {
              if (root.children.length > 0) {
                root.children.map(child1 => {
                  if (child1.children.length > 0) {
                    child1.children.map(child2 => {
                      if (child2.id == this.selection[i]) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                          Project_code: this.DataCourse.Project_code,
                          DelvNo: child2.DelvNo,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()',
                        }, headerAxiosPUT)
                      }
                    })
                  }
                  if (child1.id == this.selection[i]) {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                      Project_code: this.DataCourse.Project_code,
                      DelvNo: child1.DelvNo,
                      create_by: this.MeData[0].perid,
                      create_time: 'now()',
                    }, headerAxiosPUT)
                  }
                })
              }
              if (root.id == this.selection[i]) {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                  Project_code: this.DataCourse.Project_code,
                  DelvNo: root.DelvNo,
                  create_by: this.MeData[0].perid,
                  create_time: 'now()',
                }, headerAxiosPUT)
              }
            })
          }
          this.selection = []
          resolve(true)
        } else {
          resolve(true)
        }
      })

    },
    AddCompetency2(Project_code, Ref_id) {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      const headerAxiosDel = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      return new Promise(resolve => {
        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/Project_code/' + Project_code).then(res => {
          if (res.data) {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/Project_code/' + Project_code, {
              active: '0',
              update_by: this.MeData[0].perid
            }, headerAxiosDel).then(res => {
              if (res.data.status) {
                this.initTempCompetencyProject({
                  Ref_id: Ref_id
                }).then(res => {
                  if (res) {
                    if (this.TempCompetencyProject.length > 0) {
                      this.TempCompetencyProject.map(tempCom => {
                        this.CompetencyData.map(root => {
                          if (root.children.length > 0) {
                            root.children.map(child1 => {
                              if (child1.children.length > 0) {
                                child1.children.map(child2 => {
                                  if (child2.id == tempCom.DelvNo) {
                                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                                      Project_code: Project_code,
                                      DelvNo: child2.DelvNo,
                                      create_by: this.MeData[0].perid,
                                      create_time: 'now()',
                                    }, headerAxiosPUT)
                                  }
                                })
                              }
                              if (child1.id == tempCom.DelvNo) {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                                  Project_code: Project_code,
                                  DelvNo: child1.DelvNo,
                                  create_by: this.MeData[0].perid,
                                  create_time: 'now()',
                                }, headerAxiosPUT)
                              }
                            })
                          }
                          if (root.id == tempCom.DelvNo) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                              Project_code: Project_code,
                              DelvNo: root.DelvNo,
                              create_by: this.MeData[0].perid,
                              create_time: 'now()',
                            }, headerAxiosPUT)
                          }
                        })
                      })
                      resolve(true)
                    } else {
                      resolve(true)
                    }
                  }
                }).catch(res => {
                  if (res) {
                    resolve(true)
                  }
                })
              } else {
                resolve(false)
              }
            })
          } else {
            this.initTempCompetencyProject({
              Ref_id: Ref_id
            }).then(res => {
              if (res) {
                if (this.TempCompetencyProject.length > 0) {
                  this.TempCompetencyProject.map(tempCom => {
                    this.CompetencyData.map(root => {
                      if (root.children.length > 0) {
                        root.children.map(child1 => {
                          if (child1.children.length > 0) {
                            child1.children.map(child2 => {
                              if (child2.id == tempCom.DelvNo) {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                                  Project_code: Project_code,
                                  DelvNo: child2.DelvNo,
                                  create_by: this.MeData[0].perid,
                                  create_time: 'now()'
                                }, headerAxiosPUT)
                              }
                            })
                          }
                          if (child1.id == tempCom.DelvNo) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                              Project_code: Project_code,
                              DelvNo: child1.DelvNo,
                              create_by: this.MeData[0].perid,
                              create_time: 'now()'
                            }, headerAxiosPUT)
                          }
                        })
                      }
                      if (root.id == tempCom.DelvNo) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                          Project_code: Project_code,
                          DelvNo: root.DelvNo,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()'
                        }, headerAxiosPUT)
                      }
                    })
                  })
                  resolve(true)
                } else {
                  resolve(true)
                }
              }
            }).catch(res => {
              if (res) {
                resolve(true)
              }
            })
          }
        }).catch(res => {
          if (res) {
            this.initTempCompetencyProject({
              Ref_id: Ref_id
            }).then(res => {
              if (res) {
                if (this.TempCompetencyProject.length > 0) {
                  this.TempCompetencyProject.map(tempCom => {
                    this.CompetencyData.map(root => {
                      if (root.children.length > 0) {
                        root.children.map(child1 => {
                          if (child1.children.length > 0) {
                            child1.children.map(child2 => {
                              if (child2.id == tempCom.DelvNo) {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                                  Project_code: Project_code,
                                  DelvNo: child2.DelvNo,
                                  create_by: this.MeData[0].perid,
                                  create_time: 'now()'
                                }, headerAxiosPUT)
                              }
                            })
                          }
                          if (child1.id == tempCom.DelvNo) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                              Project_code: Project_code,
                              DelvNo: child1.DelvNo,
                              create_by: this.MeData[0].perid,
                              create_time: 'now()'
                            }, headerAxiosPUT)
                          }
                        })
                      }
                      if (root.id == tempCom.DelvNo) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_competency/', {
                          Project_code: Project_code,
                          DelvNo: root.DelvNo,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()'
                        }, headerAxiosPUT)
                      }
                    })
                  })
                  resolve(true)
                } else {
                  resolve(true)
                }
              }
            }).catch(res => {
              if (res) {
                resolve(true)
              }
            })
          }
        })
      })
    },
    AddLogCompetency2(Project_code, Ref_id) {
      const headerAxiosPUT = {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }
      return new Promise(resolve => {
        if (this.selection.length > 0) {
          for (var i = 0; i <= this.selection.length - 1; i++) {
            this.CompetencyData.map(root => {
              if (root.children.length > 0) {
                root.children.map(child1 => {
                  if (child1.children.length > 0) {
                    child1.children.map(child2 => {
                      if (child2.id == this.selection[i]) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project_competency/', {
                          Ref_id: Ref_id,
                          Project_code: Project_code,
                          DelvNo: child2.DelvNo,
                          create_by: this.MeData[0].perid,
                        }, headerAxiosPUT)
                      }
                    })
                  }
                  if (child1.id == this.selection[i]) {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project_competency/', {
                      Ref_id: Ref_id,
                      Project_code: Project_code,
                      DelvNo: child1.DelvNo,
                      create_by: this.MeData[0].perid,
                    }, headerAxiosPUT)
                  }
                })
              }
              if (root.id == this.selection[i]) {
                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project_competency/', {
                  Ref_id: Ref_id,
                  Project_code: Project_code,
                  DelvNo: root.DelvNo,
                  create_by: this.MeData[0].perid,
                }, headerAxiosPUT)
              }
            })
          }
          this.selection = []
          resolve(true)
        } else {
          resolve(true)
        }
      })
    },
    CheckPermission() {
      return new Promise(resolve => {
        var CheckPermiss = false
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == '10001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == '10001') {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    },
    proposal_To_Db() {
      const param = {
        IsPlanStatus: '1'
      }

      const headerAxios = {
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.proposal.Project_code, param, headerAxios).then(res => {
        if (res.data.status) {
          this.dialogProposal = false
          this.initPlanProjectDataForApprove().then(res => {
            if (res) {
              if (this.planProjectForApprove.length > 0) {
                if (this.CheckAdmin) {
                  this.getPermissionDep({
                    perid: this.MeData[0].perid
                  }).then(resDep => {
                    if (resDep) {
                      this.projectDataToTable = []
                      this.planProjectForApprove.map(Project => {
                        var DepData = this.Permission_Dep.filter(Dep => Project.dep_id == Dep.dep_id)
                        var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)
                        if (DepData.length > 0) {
                          if (DepBy.length > 0) {
                            this.projectDataToTable.push({
                              ...Project,
                              full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                  ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                                  ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + Project.dep_name + '</span></div>',
                              Owner: true
                            })
                          } else if (DepBy.length == 0) {
                            this.projectDataToTable.push({
                              ...Project,
                              full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                  ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + Project.dep_name + '</span></div>',
                              Owner: true
                            })
                          } else {
                            this.projectDataToTable.push({
                              ...Project,
                              full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name,
                              Owner: true
                            })
                          }
                        }
                      })
                      this.dialogLoading = false
                    } else {
                      this.dialogLoading = false
                    }
                  })
                } else if (this.CheckSubAdmin) {
                  this.getPermissionDepUserData({
                    perid: this.MeData[0].perid
                  }).then(resDep => {
                    if (resDep) {
                      this.projectDataToTable = []
                      this.planProjectForApprove.map(Project => {
                        var DepData = this.Permission_Dep_User.filter(Dep => Project.dep_id == Dep.dep_id)
                        var DepBy = this.depart.filter(depi => depi.dep_id == Project.Dep_Code)
                        if (DepData.length > 0) {
                          if (DepBy.length > 0) {
                            this.projectDataToTable.push({
                              ...Project,
                              full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                  ' <div><span style="font-weight: bold;color: #ff6d81"> โดย : ' + DepBy[0].dep_name + '</span></div>' +
                                  ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + Project.dep_name + '</span></div>',
                              Owner: true
                            })
                          } else if (DepBy.length == 0) {
                            this.projectDataToTable.push({
                              ...Project,
                              full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name +
                                  ' <div><span style="font-weight: bold;color: darkslategrey"> หน่วยงานบันทึกข้อมูล : ' + Project.dep_name + '</span></div>',
                              Owner: true
                            })
                          } else {
                            this.projectDataToTable.push({
                              ...Project,
                              full_Name: '<span style="font-weight: bold;color: darkblue">' + Project.Project_name,
                              Owner: true
                            })
                          }
                        }
                      })
                      this.dialogLoading = false
                    } else {
                      this.dialogLoading = false
                    }
                  })
                }
              }
            }
          })
        }
      })
    },
    GetData(item, IsExp, FuncExp) {
      this.DataCondi = []
      this.courseCondi = []
      if (IsExp) {
        FuncExp(false)
      } else {
        FuncExp(true)

        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/C_person_level_view/Project_code/' + item.Project_code).then(res => {
          if (res.data) {

            if (res.data.length > 0) {
              this.DataCondi = res.data
            } else {
              this.DataCondi.push(res.data)
            }
          } else {
            this.DataCondi = []
          }
        })

        axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_need_view/Project_code/' + item.Project_code).then(res => {
          if (res.data) {

            if (res.data.length > 0) {
              this.courseCondi = res.data
            } else {
              this.courseCondi.push(res.data)
            }
          } else {
            this.courseCondi = []
          }
        })
      }
    },
    ChangeStatus: function (item) {
      if (item.Course_status == '1') {
        const param = {
          Course_status: '9'
        }

        const headerAxios = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + item.Course_code, param, headerAxios).then(res => {
          if (res.data) {
            this.init()
          }
        })
      } else {
        const param = {
          Course_status: '1'
        }

        const headerAxios = {
          headers: {
            'Content-Type': 'application/json'
          }
        }
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_course/Course_code/' + item.Course_code, param, headerAxios).then(res => {
          if (res.data.status) {
            this.init()
          }
        })
      }
    },
    FileDocSelect: function () {
      // var count = 0
      this.txtAlert = []
      // this.FileProject = []
      this.alert = false
      if (this.files.length > 0) {
        this.files.map((item) => {
          var Checkfile = false;
          switch (item.type) {
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/bmp':
            case 'image/png':
              Checkfile = true;
              break
            case 'application/pdf':
              Checkfile = true;
              break
            default:
              Checkfile = false;
              break
          }

          if (Checkfile) {
            if (item.size > 4096 * 4096) {
              this.txtAlert.push({
                id: this.txtAlert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 8 mb*'
              })
            } else {
              const fd = new FormData()
              fd.append('file', item, item.name)
              const headerAxios = {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'WithCredentials': true,
                  "Access-Control-Allow-Origin": "*"
                  // "Accept": 'multipart/form-data'
                }
              }

              axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
                if (res.data.status) {
                  switch (item.type) {
                    case 'image/jpg':
                    case 'image/jpeg':
                    case 'image/gif':
                    case 'image/bmp':
                    case 'image/png':
                      this.FileProject.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'image',
                        type_Img: item.type
                      })
                      break
                    case 'application/pdf':
                      this.FileProject.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'pdf',
                        type_Img: item.type
                      })
                      break
                    default:
                      break
                  }

                  // count++
                  //
                  // if (count === this.files.length) {
                  //     this.FileProjectPdf = []
                  //     this.FileProject = []
                  // }
                }
              })
            }
          } else {
            this.txtAlert.push({
              id: this.txtAlert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type.split('/')[1] + ' ( ' + item.name + ' ) '
            })
            this.alert = true
          }
        })
      }

      // if (this.txtAlert.length == 0) {
      //     this.files.map((item) => {
      //         const fd = new FormData()
      //         fd.append('file', item, item.name)
      //         const headerAxios = {
      //             headers: {
      //                 'Content-Type': 'multipart/form-data',
      //                 'WithCredentials': true,
      //                 "Access-Control-Allow-Origin": "*"
      //                 // "Accept": 'multipart/form-data'
      //             }
      //         }
      //
      //         axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
      //             if (res.data.status) {
      //                 switch (item.type) {
      //                     case 'image/jpg':
      //                     case 'image/jpeg':
      //                     case 'image/gif':
      //                     case 'image/bmp':
      //                     case 'image/png':
      //                         this.FileProject.push({
      //                             name: item.name,
      //                             src: URL.createObjectURL(item),
      //                             path: res.data.path,
      //                             type: 'image',
      //                             type_Img: item.type
      //                         })
      //                         break
      //                     case 'application/pdf':
      //                         this.FileProject.push({
      //                             name: item.name,
      //                             src: URL.createObjectURL(item),
      //                             path: res.data.path,
      //                             type: 'pdf',
      //                             type_Img: item.type
      //                         })
      //                         break
      //                     default:
      //                         break
      //                 }
      //
      //                 // count++
      //                 //
      //                 // if (count === this.files.length) {
      //                 //     this.FileProjectPdf = []
      //                 //     this.FileProject = []
      //                 // }
      //             }
      //         })
      //     })
      //
      // } else {
      //     this.alert = true
      // }

    },
    FileSelect: function () {
      // var count = 0
      this.dialogLoading = true
      this.txtAlert = []
      // this.FileProject = []
      this.alert = false
      if (this.files.length > 0) {
        this.files.map((item) => {
          var Checkfile = false;
          switch (item.type) {
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/bmp':
            case 'image/png':
              Checkfile = true;
              break
            case 'application/pdf':
              Checkfile = true;
              break
            default:
              Checkfile = false;
              break
          }

          if (Checkfile) {
            if (item.size > 4096 * 4096) {
              this.dialogLoading = false
              this.txtAlert.push({
                id: this.txtAlert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 8 mb*'
              })
              this.alert = true
            } else {
              const fd = new FormData()
              fd.append('file', item, item.name)
              const headerAxios = {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'WithCredentials': true,
                  "Access-Control-Allow-Origin": "*"
                  // "Accept": 'multipart/form-data'
                }
              }

              axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
                if (res.data.status) {
                  switch (item.type) {
                    case 'image/jpg':
                    case 'image/jpeg':
                    case 'image/gif':
                    case 'image/bmp':
                    case 'image/png':
                      this.File_Consider.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'image',
                        type_Img: item.type
                      })
                      this.dialogLoading = false
                      break
                    case 'application/pdf':
                      this.File_Consider.push({
                        name: item.name,
                        src: URL.createObjectURL(item),
                        path: res.data.path,
                        type: 'pdf',
                        type_Img: item.type
                      })
                      this.dialogLoading = false
                      break
                    default:
                      break
                  }

                }
              })
            }
          } else {
            this.dialogLoading = false
            this.txtAlert.push({
              id: this.txtAlert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type.split('/')[1] + ' ( ' + item.name + ' ) '
            })
            this.alert = true
          }
        })
      }
    },
    getCourseType() {
      if (this.Course_code == null) {
        this.course_group = ''
        // this.Project_code = ''
        this.Period_code = 0
        this.CalHourse = '0'
        this.CalCredit = '0'
      } else {
        this.courseData.map((item) => {
          if (item.Course_code == this.Course_code) {
            this.course_group = item.Course_type_des
            this.Period_code = item.Period_code
            this.CalHourse = item.Course_hour
            this.CalCredit = item.General_credit
          }
        })
      }
    },
    changeDate() {
      switch (this.episode) {
        case '1':
          this.DateStart = (parseInt(this.FiscalYear) - 1) + '-10-01'
          this.DateEnd = (parseInt(this.FiscalYear) - 1) + '-12-31'
          break
        case '2':
          this.DateStart = this.FiscalYear + '-01-01'
          this.DateEnd = this.FiscalYear + '-03-31'
          break
        case '3':
          this.DateStart = this.FiscalYear + '-04-01'
          this.DateEnd = this.FiscalYear + '-06-30'
          break
        case '4':
          this.DateStart = this.FiscalYear + '-07-01'
          this.DateEnd = this.FiscalYear + '-09-30'
          break
        default:
          this.DateStart = (parseInt(this.FiscalYear) - 1) + '-10-01'
          this.DateEnd = this.FiscalYear + '-09-30'
          break
      }
    },
    UniqueArraybyId(collection, keyname) {
      var output = [],
          keys = [];

      collection.map((item) => {
        var key = item[keyname];
        if (keys.indexOf(key) === -1) {
          keys.push(key);
          output.push(item);
        }
      });
      return output;
    },
    CheckPlace() {
      if (this.PLACE == '2') {
        this.Country_id = ''
      } else if (this.PLACE == '3') {
        this.Province_id = ''
      }
    },
    CourseCondiFunc() {
      var CheckDupe = false
      this.courseCondi.map((item) => {
        if (item.Course_code == this.ChooseCourse) {
          CheckDupe = true
        }
      })
      if (CheckDupe) {
        this.$swal.fire({
          icon: 'error',
          title: 'มีข้อมูลหลักสูตรแล้ว ไม่สามารถเพิ่มข้อมูลได้อีก'
        })
      } else {
        this.courseData.map((item) => {
          if (item.Course_code == this.ChooseCourse) {
            this.courseCondi.push(item)
          }
        })
        this.ChooseCourse = ''
      }
    },
    ChooseProcess() {
      if (this.Process == '1') {
        this.changeTypeProject({
          type: '1'
        })
        this.changeColor({
          color: '#1976d2'
        })
        this.changeHeaderName({
          headerName: Const.defaultHeaderApp1
        })
      } else {
        this.changeTypeProject({
          type: '2'
        })
        this.changeColor({
          color: '#004D40'
        })
        this.changeHeaderName({
          headerName: Const.defaultHeaderApp2
        })
      }
      this.ChooseStatusPlan()
    },
    ConsideProject(sendmail) {
      if (this.Approve_m == null || (this.dateApprove == '' || this.dateApprove == null)) {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดกรอกข้อมูล สำหรับพิจารณาแผนให้ครบถ้วน'
        })
      } else if (this.txtAlert.length > 0) {
        this.$swal.fire({
          icon: 'error',
          title: 'พบข้อผิดพลาด',
          text: 'โปรดตรวจสอบไฟล์ที่ต้องการอัพโหลด!!',
        })
      } else {
        this.$swal.fire({
          title: 'ยืนยันการทำรายการ',
          text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
          icon: 'warning',
          showCancelButton: true,

          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.value) {
            var param = null
            const headerAxios = {
              headers: {
                'Content-Type': 'application/json',
                'X-REST-METHOD': 'PUT'
              }
            }
            var status = this.Approve_m

            /*if (this.Approve_m == '0') {
              status = '2'
            } else if (this.Approve_m == '1') {
              status = '3'
            } else {
              status = '4'
            }*/

            param = {
              Project_code: this.Project_code,
              Type: '1',
              Status: status,
              Remark: this.remarksApprove,
              Date_Approve: this.dateApprove,
              Create_By: this.MeData[0].perid,
              Create_Time: 'now()',
            }
            if (sendmail) {
              this.SendMailApprove()
            }
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record/', param, headerAxios).then(res => {
              if (res.data) {
                if (this.File_Consider.length > 0) {
                  axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_record_view/Project_code/' + this.Project_code + '/?sort=id_DESC&limit=1', param, headerAxios).then(res => {
                    if (res.data) {
                      const headerAxiosPUT = {
                        headers: {
                          'Content-Type': 'application/json',
                          'X-REST-METHOD': 'PUT'
                        }
                      }

                      var Count = 0

                      this.File_Consider.map((item) => {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project_files', {
                          Project_code: this.Project.Project_code,
                          File_name: item.name,
                          File_path: item.path,
                          File_type: item.type_Img,
                          Type: '4',
                          project_record_id: res.data.id,
                          Create_By: this.MeData[0].perid,
                          Create_Time: 'now()'
                        }, headerAxiosPUT).then(res => {
                          if (res.data.status) {
                            Count++
                            if (Count == this.File_Consider.length) {
                              this.File_Consider = []
                              this.files = []

                              axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
                                queryName: (this.Process == '2' ? 'updateStatusProject' : 'updateStatusProject2'),
                                param: btoa(JSON.stringify({
                                  IsPlanStatus: status,
                                  Project_code: this.Project_code,
                                  perid: this.MeData[0].perid,
                                }))
                              }).then(res => {
                                if (res.data.status) {
                                  if (this.Approve_m == '2' || this.Approve_m == '3' || this.Approve_m == '4') {
                                    axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
                                      perid_admin: this.Project.Create_By,
                                      perid: this.MeData[0].perid,
                                      headerName: 'แจ้งผลการพิจารณา แผนอนุมัติงบประมาณประจำปี',
                                      header: this.Project.Project_name + ' (' + this.Project.Project_code + ')',
                                      body: '<p style="font-size: 25px;color: #ff6d81;font-weight: bold">แผนประจำปี ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')' + ' ' + (this.Approve_m == '2' ? 'ถูกอนุมัติแล้ว' : this.Approve_m == '3' ? 'ไม่ถูกอนุมัติ' : 'ควรมีการแก้ไข') + '</p>' +
                                          '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + this.remarksApprove + '' +
                                          '<p style="margin-top: 25px;font-size: 16px;"> สามารถตรวจสอบผลการอนุมัติอีกครั้ง ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</a></p>' +
                                          '<hr style="margin-top: 50px;">' +
                                          '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                          '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',

                                    }), {
                                      headers: {
                                        "Content-Type": "application/x-www-form-urlencoded"
                                      }
                                    })
                                  }
                                  this.dialogMasterApprove = false
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                  this.init()
                                  this.Details_Cordi = false
                                } else {
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                                  })
                                }
                              }).catch(resCatch => {
                                if (resCatch) {
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                                  })
                                }
                              })
                            }
                          }
                        })
                      })
                    } else {
                      axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
                        queryName: (this.Process == '2' ? 'updateStatusProject' : 'updateStatusProject2'),
                        param: btoa(JSON.stringify({
                          IsPlanStatus: status,
                          Project_code: this.Project_code,
                          perid: this.MeData[0].perid,
                        }))
                      }).then(res => {
                        if (res.data.status) {
                          if (this.Approve_m == '2' || this.Approve_m == '3' || this.Approve_m == '4') {
                            axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
                              perid_admin: this.Project.Create_By,
                              perid: this.MeData[0].perid,
                              headerName: 'แจ้งผลการพิจารณา แผนอนุมัติงบประมาณประจำปี',
                              header: this.Project.Project_name + ' (' + this.Project.Project_code + ')',
                              body: '<p style="font-size: 25px;color: #ff6d81;font-weight: bold">แผนประจำปี ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')' + ' ' + (this.Approve_m == '2' ? 'ถูกอนุมัติแล้ว' : this.Approve_m == '3' ? 'ไม่ถูกอนุมัติ' : 'ควรมีการแก้ไข') + '</p>' +
                                  '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + this.remarksApprove + '' +
                                  '<p style="margin-top: 25px;font-size: 16px;"> สามารถตรวจสอบผลการอนุมัติอีกครั้ง ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</a></p>' +
                                  '<hr style="margin-top: 50px;">' +
                                  '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                  '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                            }), {
                              headers: {
                                "Content-Type": "application/x-www-form-urlencoded"
                              }
                            })
                          }
                          this.dialogMasterApprove = false
                          this.$swal.fire({
                            icon: 'success',
                            title: 'บันทึกข้อมูลสำเร็จ'
                          })
                          this.init()
                          this.Details_Cordi = false
                        } else {
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                          })
                        }
                      }).catch(resCatch => {
                        if (resCatch) {
                          this.$swal.fire({
                            icon: 'error',
                            title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                          })
                        }
                      })
                    }
                  })
                } else {
                  axios.post(ConstData.ConnectionHost + '/HrTrain2/serviceAPI.php', {
                    queryName: (this.Process == '2' ? 'updateStatusProject' : 'updateStatusProject2'),
                    param: btoa(JSON.stringify({
                      IsPlanStatus: status,
                      Project_code: this.Project_code,
                      perid: this.MeData[0].perid,
                    }))
                  }).then(res => {
                    if (res.data.status) {
                      if (this.Approve_m == '2' || this.Approve_m == '3' || this.Approve_m == '4') {
                        axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
                          perid_admin: this.Project.Create_By,
                          perid: this.MeData[0].perid,
                          headerName: 'แจ้งผลการพิจารณา แผนอนุมัติงบประมาณประจำปี',
                          header: this.Project.Project_name + ' (' + this.Project.Project_code + ')',
                          body: '<p style="font-size: 25px;color: #ff6d81;font-weight: bold">แผนประจำปี ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')' + ' ' + (this.Approve_m == '2' ? 'ถูกอนุมัติแล้ว' : this.Approve_m == '3' ? 'ไม่ถูกอนุมัติ' : 'ควรมีการแก้ไข') + '</p>' +
                              '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + this.remarksApprove + '' +
                              '<p style="margin-top: 25px;font-size: 16px;"> สามารถตรวจสอบผลการอนุมัติอีกครั้ง ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</a></p>' +
                              '<hr style="margin-top: 50px;">' +
                              '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                              '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',
                        }), {
                          headers: {
                            "Content-Type": "application/x-www-form-urlencoded"
                          }
                        })
                      }
                      this.dialogMasterApprove = false
                      this.$swal.fire({
                        icon: 'success',
                        title: 'บันทึกข้อมูลสำเร็จ'
                      })
                      this.init()
                      this.Details_Cordi = false
                    } else {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                      })
                    }
                  }).catch(resCatch => {
                    if (resCatch) {
                      this.$swal.fire({
                        icon: 'error',
                        title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
                      })
                    }
                  })
                }
              }
            })
          }
        })
      }
    },
    ConsideReqEditProject(sendmail) {
      if (this.Approve_m == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดกรอกข้อมูล สำหรับพิจารณาแผนให้ครบถ้วน'
        })
      } else {
        this.$swal.fire({
          title: 'ยืนยันการทำรายการ',
          text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึกข้อมูล",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก'
        }).then((result) => {
          if (result.value) {
            var param = null
            var paramRecord = null
            var Ref_id_edit = this.getRandomFileName()
            this.dialogLoading = true
            this.btnDisable = true
            const headerAxios = {
              headers: {
                'Content-Type': 'application/json',
                'X-REST-METHOD': 'PUT'
              }
            }
            const headerAxiosUpdate = {
              headers: {
                'Content-Type': 'application/json',
              }
            }

            param = {
              Req_status: this.Approve_m,
              Remark: this.remarksApprove,
              Update_By: this.MeData[0].perid,
            }
            paramRecord = {
              Project_code: this.Project_code,
              Status: this.Approve_m,
              Remark: this.remarksApprove,
              Create_By: this.MeData[0].perid,
              Create_Time: 'now()',
            }
            if (sendmail) {
              this.SendMailApprove()
            }
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_D_project_record/', paramRecord, headerAxios)
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Temp_Edit_Project/id/' + this.Project.temp_id, param, headerAxiosUpdate).then(res => {
              if (res.data) {
                if (this.Approve_m == '1' || this.Approve_m == '2') {
                  axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/D_project/Project_code/' + this.Project.Project_code, {
                    Project_code: this.Project.Project_code,
                    Project_name: this.Project.Project_name,
                    Course_code: this.Project.Course_code,
                    course_group: this.Project.course_group,
                    IsProcess: this.Project.IsProcess,
                    Project_category: this.Project.Project_category,
                    Project_type: this.Project.Project_type,
                    WorkBy: this.Project.WorkBy,
                    WorkByName: this.Project.WorkByName,
                    WorkByPhone: this.Project.WorkByPhone,
                    Location: this.Project.Location,
                    DatePeriod: this.Project.DatePeriod,
                    DateStart: this.Project.DateStart,
                    DateEnd: this.Project.DateEnd,
                    CalHourse: this.Project.CalHourse,
                    CalCredit: this.Project.CalCredit,
                    PLACE: this.Project.PLACE,
                    Province_id: this.Project.Province_id,
                    Country_id: this.Project.Country_id,
                    Status: this.Project.Status,
                    Objective: this.Project.Objective,
                    TargetGroup: this.Project.TargetGroup,
                    Remarks: this.Project.Remarks,
                    ProjectLevel: this.Project.ProjectLevel,
                    App_doc_no: this.Project.App_doc_no,
                    BudgetRequest: this.Project.BudgetRequest,
                    BudgetArrove: this.Project.BudgetArrove,
                    MoneyDisburse: this.Project.MoneyDisburse,
                    Project_group: this.Project.Project_group,
                    Approve: this.Project.Approve,
                    FiscalYear: this.Project.FiscalYear,
                    IsPlan: this.Project.IsPlan,
                    IsPlanStatus: this.Project.IsPlanStatus,
                    Status_Reg: this.Project.Status_Reg,
                    Status_Type_Reg: this.Project.Status_Type_Reg,
                    DateS_Reg: this.Project.DateS_Reg,
                    DateE_Reg: this.Project.DateE_Reg,
                    Status_Count_Reg: this.Project.Status_Count_Reg,
                    Count_Reg: this.Project.Count_Reg,
                    Dep_Code: this.Project.Dep_Code,
                    Create_By: this.MeData[0].perid
                  }, {
                    headers: {
                      'Content-Type': 'application/json',
                    }
                  }, headerAxios).then(async res => {
                    if (res.data.status) {
                      const logEdit = await axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_Edit_Project/', {
                        Ref_id: Ref_id_edit,
                        Create_By: this.MeData[0].perid
                      }, {
                        headers: {
                          'Content-Type': 'application/json',
                          'X-REST-METHOD': 'PUT'
                        }
                      })
                      if (logEdit.data.status) {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Log_D_project/', {
                          Ref_id: Ref_id_edit,
                          Project_code: this.ProjectBefore.Project_code,
                          Project_name: this.ProjectBefore.Project_name,
                          Course_code: this.ProjectBefore.Course_code,
                          course_group: this.ProjectBefore.course_group,
                          IsProcess: this.ProjectBefore.IsProcess,
                          Project_category: this.ProjectBefore.Project_category,
                          Project_type: this.ProjectBefore.Project_type,
                          WorkBy: this.ProjectBefore.WorkBy,
                          WorkByName: this.ProjectBefore.WorkByName,
                          WorkByPhone: this.ProjectBefore.WorkByPhone,
                          Location: this.ProjectBefore.Location,
                          DatePeriod: this.ProjectBefore.DatePeriod,
                          DateStart: this.ProjectBefore.DateStart,
                          DateEnd: this.ProjectBefore.DateEnd,
                          CalHourse: this.ProjectBefore.CalHourse,
                          CalCredit: this.ProjectBefore.CalCredit,
                          PLACE: this.ProjectBefore.PLACE,
                          Province_id: this.ProjectBefore.Province_id,
                          Country_id: this.ProjectBefore.Country_id,
                          Status: this.ProjectBefore.Status,
                          Objective: this.ProjectBefore.Objective,
                          TargetGroup: this.ProjectBefore.TargetGroup,
                          Remarks: this.ProjectBefore.Remarks,
                          ProjectLevel: this.ProjectBefore.ProjectLevel,
                          App_doc_no: this.ProjectBefore.App_doc_no,
                          BudgetRequest: this.ProjectBefore.BudgetRequest,
                          BudgetArrove: this.ProjectBefore.BudgetArrove,
                          MoneyDisburse: this.ProjectBefore.MoneyDisburse,
                          Project_group: this.ProjectBefore.Project_group,
                          Approve: this.ProjectBefore.Approve,
                          FiscalYear: this.ProjectBefore.FiscalYear,
                          IsPlan: this.ProjectBefore.IsPlan,
                          IsPlanStatus: this.ProjectBefore.IsPlanStatus,
                          Status_Reg: this.ProjectBefore.Status_Reg,
                          Status_Type_Reg: this.ProjectBefore.Status_Type_Reg,
                          DateS_Reg: this.ProjectBefore.DateS_Reg,
                          DateE_Reg: this.ProjectBefore.DateE_Reg,
                          Status_Count_Reg: this.ProjectBefore.Status_Count_Reg,
                          Count_Reg: this.ProjectBefore.Count_Reg,
                          Dep_Code: this.ProjectBefore.Dep_Code,
                          Create_By: this.MeData[0].perid
                        }, {
                          headers: {
                            'Content-Type': 'application/json',
                            'X-REST-METHOD': 'PUT'
                          }
                        }).then(async resLogD_Project => {
                          if (resLogD_Project.data.status) {
                            const resFile = await this.insertFileData(this.Project.Project_code, this.Project.Ref_id)
                            if (resFile) {
                              const resFileOld = await this.insertLogFileData(this.Project.Project_code, Ref_id_edit)
                              if (resFileOld) {

                                const resAddLogCom = await this.AddLogCompetency2(this.Project.Project_code, Ref_id_edit)

                                const resAddCom = resAddLogCom ? await this.AddCompetency2(this.Project.Project_code, this.Project.Ref_id) : false

                                if (resAddCom) {
                                  axios.post(ConstData.ConnectionHost + '/sendMail/SendMailData.php', queryString.stringify({
                                    perid_admin: this.Project.Create_By,
                                    perid: this.MeData[0].perid,
                                    headerName: 'แจ้งผลการพิจารณา คำขอแก้ไขแผนอนุมัติตั้งงบประมาณประจำปี',
                                    header: this.Project.Project_name + ' (' + this.Project.Project_code + ')',
                                    body: '<p style="font-size: 25px;color: #ff6d81;font-weight: bold">คำขอแก้ไขแผน : ' + this.Project.Project_name + ' (' + this.Project.Project_code + ')' + ' ' + (this.Approve_m == '1' ? 'ถูกอนุมัติแล้ว' : this.Approve_m == '2' ? 'ไม่ถูกอนุมัติ' : 'ควรมีการแก้ไข') + '</p>' +
                                        '<p style="margin-top: 25px;font-size: 16px;"> หมายเหตุ </p>' + this.remarksApprove + '' +
                                        '<p style="margin-top: 25px;font-size: 16px;"> สามารถตรวจสอบผลการอนุมัติอีกครั้ง ตามลิงค์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/Propose_a_plan">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</a></p>' +
                                        '<hr style="margin-top: 50px;">' +
                                        '<p style="font-size: 16px;color: #ff6d81">ระบบโครงการจัดอบรมและการเดินทางไปปฏิบัติงาน</p>' +
                                        '<p style="font-size: 16px;color: #ff6d81">ลิงค์เว็บไซต์ <a target="_blank" rel="noopener noreferrer" href="https://medhr.medicine.psu.ac.th/HrTrain2/#/" style="margin-left: 15px"> คลิก!! </a></p>',

                                  }), {
                                    headers: {
                                      "Content-Type": "application/x-www-form-urlencoded"
                                    }
                                  })
                                  this.dialogLoading = false
                                  this.btnDisable = false
                                  this.dialogMasterApprove = false
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'บันทึกข้อมูลสำเร็จ'
                                  })
                                  this.init()
                                  this.Details_Cordi = false

                                  this.btnDisable = false

                                  this.e1 = '1'

                                  this.Process = '1'
                                  this.Project_code = ''
                                  this.Project_name = ''
                                  this.Course_code = '0000000'
                                  this.course_group = ''
                                  this.Project_type = ''
                                  this.IsProcess = null
                                  this.Project_category = null
                                  this.Remarks = ''
                                  this.WorkBy = ''
                                  this.Location = ''
                                  this.DateStart = ''
                                  this.DateEnd = ''
                                  this.CalHourse = '0'
                                  this.CalCredit = '0'
                                  this.PLACE = ''
                                  this.Province_id = ''
                                  this.BudgetRequest = ''
                                  this.ChooseTypeDep = '0'
                                  this.ChooseTypRegis = '1'
                                  this.ChooseTypRegis2 = '0'
                                  this.dateRegStart = ''
                                  this.dateRegEnd = ''
                                  this.ProjectQuotaCount = ''
                                  this.ProjectQuotaDepCount = 0
                                  this.MessageSuc = ''
                                  this.MessageError = ''
                                  this.ChkJoinPerson = true
                                  this.ShowAlertErr = false
                                  this.ShowAlertSuc = false
                                  this.Project_group = ''
                                  this.DepSelect = ''
                                  this.Period_code = ''
                                  this.editorData = ''
                                  this.FiscalYear = ''
                                  this.IsPlan = null
                                  this.IsPlanStatus = ''
                                  this.WorkByName = ''
                                  this.WorkByPhone = ''
                                  this.itemCode = ''
                                  this.txtAlert = []
                                  this.alert = false
                                } else {
                                  this.dialogLoading = false
                                  this.btnDisable = false
                                  this.$swal.fire({
                                    icon: 'error',
                                    title: 'พบข้อผิดพลาด',
                                    text: 'ไม่สามารถบันทึกข้อมูลได้ โปรดติดต่อผู้ดูแลระบบ',
                                  })
                                }
                              } else {
                                this.dialogLoading = false
                                this.btnDisable = false
                                this.$swal.fire({
                                  icon: 'error',
                                  title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลประวัติข้อมูลประวัติไฟล์ประกอบเพิ่มเติมได้!!'
                                })
                              }
                            } else {
                              this.dialogLoading = false
                              this.btnDisable = false
                              this.$swal.fire({
                                icon: 'error',
                                title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลไฟล์ประกอบเพิ่มเติมได้!!'
                              })
                            }
                          } else {
                            this.dialogLoading = false
                            this.btnDisable = false
                            this.$swal.fire({
                              icon: 'error',
                              title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลประวัติการแก้ไขข้อมูลได้!!'
                            })
                          }
                        })
                      } else {
                        this.dialogLoading = false
                        this.btnDisable = false
                        this.$swal.fire({
                          icon: 'error',
                          title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลประวัติทำรายการได้!!'
                        })
                      }
                    }
                  })
                } else {
                  this.dialogLoading = false
                  this.btnDisable = false
                  this.dialogMasterApprove = false
                  this.$swal.fire({
                    icon: 'success',
                    title: 'บันทึกข้อมูลสำเร็จ'
                  })
                  this.init()
                  this.Details_Cordi = false
                  this.btnDisable = false
                }
              }
            })
          }
        })
      }
    },
    ChooseMasterApprove(typeApprove, process) {
      console.log(this.Project_type)
      console.log(this.AllApproveMaster)
      console.log(this.AllApproveMaster.filter(item => item.type == this.typePermiss && (item.Approve_Project_Type_Ms == typeApprove || item.Approve_Project_Type_Ms == '9') && item.readonly == '0' && (item.project_type == '3' || (item.project_type == this.Project_type))))
      this.sendApprovePerson = []
      if (process == 'approvePlan') {
        if (this.Approve_m == '' || (this.dateApprove == '' || this.dateApprove == null)) {
          this.$swal.fire({
            icon: 'error',
            title: 'โปรดกรอกข้อมูล สำหรับพิจารณาแผนให้ครบถ้วน'
          })
        } else if (this.txtAlert.length > 0) {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'โปรดตรวจสอบไฟล์ที่ต้องการอัพโหลด!!',
          })
        } else {
          this.approveMasterChoose = []
          this.approveMasterChoose = this.AllApproveMaster.filter(item => item.type == this.typePermiss && (item.Approve_Project_Type_Ms == typeApprove || item.Approve_Project_Type_Ms == '9') && item.readonly == '0' && (item.project_type == '3' || (item.project_type == this.Project_type)))
          this.dialogMasterApprove = true
        }
      } else {
        if (this.Approve_m == '' || (this.dateApprove == '' || this.dateApprove == null)) {
          this.$swal.fire({
            icon: 'error',
            title: 'โปรดกรอกข้อมูล สำหรับพิจารณาแผนให้ครบถ้วน'
          })
        } else if (this.txtAlert.length > 0) {
          this.$swal.fire({
            icon: 'error',
            title: 'พบข้อผิดพลาด',
            text: 'โปรดตรวจสอบไฟล์ที่ต้องการอัพโหลด!!',
          })
        } else {
          this.approveMasterChoose = []
          this.approveMasterChoose = this.AllApproveMaster.filter(item => item.type == this.typePermiss && (item.Approve_Project_Type_Ms == typeApprove || item.Approve_Project_Type_Ms == '9') && item.readonly == '0' && (item.project_type == '3' || (item.project_type == this.Project_type)))
          this.dialogMasterApprove = true
        }
      }
    },
    ChooseMasterApprove2() {
      this.sendApprovePerson = []
      if (this.ChooseSendMail == null) {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดกรอกข้อมูล สำหรับพิจารณาแผนให้ครบถ้วน'
        })
      } else {
        this.approveMasterChoose = []
        this.approveMasterChoose = this.AllApproveMaster.filter(item => item.type == this.typePermiss && item.Approve_Project_Type_Ms == this.ChooseSendMail && item.readonly == '0' && (item.project_type == '3' || (item.project_type == this.Project_type)))
        this.dialogMasterApprove2 = true
      }
    },
    ChooseCompetency() {
      this.CompetencyData = JSON.parse(JSON.stringify(this.CompetencyDataDump))
      if (this.Project_category == '1') {
        this.CompetencyData[0].checkCordi = true
        this.CompetencyData[2].checkCordi = true
      } else {
        this.CompetencyData[0].checkCordi = false
        this.CompetencyData[2].checkCordi = true
      }
      if (this.selection.length > 0) {
        for (var i = 0; i <= this.selection.length - 1; i++) {
          this.CompetencyData.map(root => {
            if (root.children.length > 0) {
              root.children.map(child1 => {
                if (child1.children.length > 0) {
                  child1.children.map(child2 => {
                    if (child2.id == this.selection[i]) {
                      if ((this.Project_category == '1' && ((root.DelvGroup == 'A' && root.DelvLevel == '0') || (root.DelvGroup == 'D' && root.DelvLevel == '0'))) || (this.Project_category != '1' && root.DelvGroup == 'D' && root.DelvLevel == '0')) {
                        root.checkCordi = false
                      }
                    }
                  })
                }
                if (child1.id == this.selection[i]) {
                  if ((this.Project_category == '1' && ((root.DelvGroup == 'A' && root.DelvLevel == '0') || (root.DelvGroup == 'D' && root.DelvLevel == '0'))) || (this.Project_category != '1' && root.DelvGroup == 'D' && root.DelvLevel == '0')) {
                    root.checkCordi = false
                  }
                }
              })
            }
            if (root.id == this.selection[i]) {
              if ((this.Project_category == '1' && ((root.DelvGroup == 'A' && root.DelvLevel == '0') || (root.DelvGroup == 'D' && root.DelvLevel == '0'))) || (this.Project_category != '1' && root.DelvGroup == 'D' && root.DelvLevel == '0')) {
                root.checkCordi = false
              } else {
                root.checkCordi = true
              }
            }
          })
        }
      }
      this.getCourseType()
    },
    OpenDialogReport() {
      this.exportType = null
      this.exportType2 = null
      this.exportType3 = null
      this.dialogExportPlanProj = true
    },
    ShowDialogCompetency(item) {
      this.dialogDetail = true
      this.itemToShow = null
      this.itemToShow = item
    },
  },
  mounted() {
    this.Process = (this.TypeProject != null ? this.TypeProject : '1')
    this.changeColor({
      color: Const.defaultColorApp
    })
    this.changeHeaderName({
      headerName: Const.defaultHeaderApp
    })
    this.initMeData().then(async res => {
      if (res) {
        await this.getIgnoreMenuPermissData({
          perid: this.MeData[0].perid,
          page_id: '7'
        })
        this.getMenuPermissData().then(res => {
          if (res) {
            if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '7' && item.page_status == '1').length > 0 || this.IgnoreMenuPermiss.filter(item => item.perid == this.MeData[0].perid).length > 0) {
              this.maintain = false
              this.initApproveMasterAll()
              this.initApproveMaster({
                perid: this.MeData[0].perid
              }).then(res => {
                if (res) {
                  if (this.ApproveMaster.length > 0 || this.MeData[0].perid == '46792') {
                    this.checkProj1 = this.ApproveMaster.filter(appItem => appItem.project_type == '1' || appItem.project_type == '3').length > 0 ? true : false
                    this.checkProj2 = this.ApproveMaster.filter(appItem => appItem.project_type == '2' || appItem.project_type == '3').length > 0 ? true : false
                    if (this.checkProj1 && this.checkProj2) {
                      this.Process = '1'
                    } else if (this.checkProj1 && !this.checkProj2) {
                      this.Process = '1'
                    } else if (!this.checkProj1 && this.checkProj2) {
                      this.Process = '2'
                    } else {
                      this.Process = '1'
                    }
                    this.typePermiss = this.ApproveMaster[0].type
                    this.CheckAdmin = true
                    this.init()
                    /*this.ApproveMaster.map((ApproveM, idx) => {
                      if (ApproveM.type == '0') {
                        this.CheckAdmin = true
                        this.init()
                      } else {
                        if (!this.CheckAdmin && idx == this.ApproveMaster.length - 1) {
                          this.$router.push('/')
                        }
                      }
                    })*/
                  }
                } else {
                  this.$router.push('/')
                }
              }, reason => {
                console.log(reason)
                this.$router.push('/')
              })
            } else {
              this.maintain = true
            }
          }
        }).catch(err => {
          if (err) {
            this.maintain = true
          }
        })
      } else {
        this.$router.push('/')
        this.$swal.fire({
          icon: 'error',
          title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
      this.$router.push('/')
      this.$swal.fire({
        icon: 'error',
        title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
      })
    })
  }
}
</script>

<style scoped>
.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>
